! function() {
    var e = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : "undefined" != typeof global ? global : {},
        t = {},
        n = {},
        i = e.parcelRequire3852;
    null == i && ((i = function(e) {
        if (e in t) return t[e].exports;
        if (e in n) {
            var i = n[e];
            delete n[e];
            var o = {
                id: e,
                exports: {}
            };
            return t[e] = o, i.call(o.exports, o, o.exports), o.exports
        }
        var a = new Error("Cannot find module '" + e + "'");
        throw a.code = "MODULE_NOT_FOUND", a
    }).register = function(e, t) {
        n[e] = t
    }, e.parcelRequire3852 = i), i.register("gCGxJ", (function(e, t) {
        var n, i;
        n = "undefined" != typeof window ? window : {}, i = function(e, t, n) {
            "use strict";
            var i, o;
            if (function() {
                    var t, n = {
                        lazyClass: "lazyload",
                        loadedClass: "lazyloaded",
                        loadingClass: "lazyloading",
                        preloadClass: "lazypreload",
                        errorClass: "lazyerror",
                        autosizesClass: "lazyautosizes",
                        fastLoadedClass: "ls-is-cached",
                        iframeLoadMode: 0,
                        srcAttr: "data-src",
                        srcsetAttr: "data-srcset",
                        sizesAttr: "data-sizes",
                        minSize: 40,
                        customMedia: {},
                        init: !0,
                        expFactor: 1.5,
                        hFac: .8,
                        loadMode: 2,
                        loadHidden: !0,
                        ricTimeout: 0,
                        throttleDelay: 125
                    };
                    for (t in o = e.lazySizesConfig || e.lazysizesConfig || {}, n) t in o || (o[t] = n[t])
                }(), !t || !t.getElementsByClassName) return {
                init: function() {},
                cfg: o,
                noSupport: !0
            };
            var a, r, s, c, l, u, d, h, f, p, v, m, y, g, _, b, k, S, w, C, E, I, x, L, T, M, A, P, B, D, O, q, R, F, N, H, V, z, K, U, W, Y, j, X, Q, G = t.documentElement,
                Z = e.HTMLPictureElement,
                J = "addEventListener",
                $ = "getAttribute",
                ee = e[J].bind(e),
                te = e.setTimeout,
                ne = e.requestAnimationFrame || te,
                ie = e.requestIdleCallback,
                oe = /^picture$/i,
                ae = ["load", "error", "lazyincluded", "_lazyloaded"],
                re = {},
                se = Array.prototype.forEach,
                ce = function(e, t) {
                    return re[t] || (re[t] = new RegExp("(\\s|^)" + t + "(\\s|$)")), re[t].test(e[$]("class") || "") && re[t]
                },
                le = function(e, t) {
                    ce(e, t) || e.setAttribute("class", (e[$]("class") || "").trim() + " " + t)
                },
                ue = function(e, t) {
                    var n;
                    (n = ce(e, t)) && e.setAttribute("class", (e[$]("class") || "").replace(n, " "))
                },
                de = function(e, t, n) {
                    var i = n ? J : "removeEventListener";
                    n && de(e, t), ae.forEach((function(n) {
                        e[i](n, t)
                    }))
                },
                he = function(e, n, o, a, r) {
                    var s = t.createEvent("Event");
                    return o || (o = {}), o.instance = i, s.initEvent(n, !a, !r), s.detail = o, e.dispatchEvent(s), s
                },
                fe = function(t, n) {
                    var i;
                    !Z && (i = e.picturefill || o.pf) ? (n && n.src && !t[$]("srcset") && t.setAttribute("srcset", n.src), i({
                        reevaluate: !0,
                        elements: [t]
                    })) : n && n.src && (t.src = n.src)
                },
                pe = function(e, t) {
                    return (getComputedStyle(e, null) || {})[t]
                },
                ve = function(e, t, n) {
                    for (n = n || e.offsetWidth; n < o.minSize && t && !e._lazysizesWidth;) n = t.offsetWidth, t = t.parentNode;
                    return n
                },
                me = (Y = [], j = W = [], X = function() {
                    var e = j;
                    for (j = W.length ? Y : W, K = !0, U = !1; e.length;) e.shift()();
                    K = !1
                }, Q = function(e, n) {
                    K && !n ? e.apply(this, arguments) : (j.push(e), U || (U = !0, (t.hidden ? te : ne)(X)))
                }, Q._lsFlush = X, Q),
                ye = function(e, t) {
                    return t ? function() {
                        me(e)
                    } : function() {
                        var t = this,
                            n = arguments;
                        me((function() {
                            e.apply(t, n)
                        }))
                    }
                },
                ge = function(e) {
                    var t, i = 0,
                        a = o.throttleDelay,
                        r = o.ricTimeout,
                        s = function() {
                            t = !1, i = n.now(), e()
                        },
                        c = ie && r > 49 ? function() {
                            ie(s, {
                                timeout: r
                            }), r !== o.ricTimeout && (r = o.ricTimeout)
                        } : ye((function() {
                            te(s)
                        }), !0);
                    return function(e) {
                        var o;
                        (e = !0 === e) && (r = 33), t || (t = !0, (o = a - (n.now() - i)) < 0 && (o = 0), e || o < 9 ? c() : te(c, o))
                    }
                },
                _e = function(e) {
                    var t, i, o = 99,
                        a = function() {
                            t = null, e()
                        },
                        r = function() {
                            var e = n.now() - i;
                            e < o ? te(r, o - e) : (ie || a)(a)
                        };
                    return function() {
                        i = n.now(), t || (t = te(r, o))
                    }
                },
                be = (k = /^img$/i, S = /^iframe$/i, w = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent), C = 0, E = 0, I = 0, x = -1, L = function(e) {
                    I--, (!e || I < 0 || !e.target) && (I = 0)
                }, T = function(e) {
                    return null == b && (b = "hidden" == pe(t.body, "visibility")), b || !("hidden" == pe(e.parentNode, "visibility") && "hidden" == pe(e, "visibility"))
                }, M = function(e, n) {
                    var i, o = e,
                        a = T(e);
                    for (m -= n, _ += n, y -= n, g += n; a && (o = o.offsetParent) && o != t.body && o != G;)(a = (pe(o, "opacity") || 1) > 0) && "visible" != pe(o, "overflow") && (i = o.getBoundingClientRect(), a = g > i.left && y < i.right && _ > i.top - 1 && m < i.bottom + 1);
                    return a
                }, P = ge(A = function() {
                    var e, n, a, r, s, c, d, f, k, S, L, A, P = i.elements;
                    if ((h = o.loadMode) && I < 8 && (e = P.length)) {
                        for (n = 0, x++; n < e; n++)
                            if (P[n] && !P[n]._lazyRace)
                                if (!w || i.prematureUnveil && i.prematureUnveil(P[n])) N(P[n]);
                                else if ((f = P[n][$]("data-expand")) && (c = 1 * f) || (c = E), S || (S = !o.expand || o.expand < 1 ? G.clientHeight > 500 && G.clientWidth > 500 ? 500 : 370 : o.expand, i._defEx = S, L = S * o.expFactor, A = o.hFac, b = null, E < L && I < 1 && x > 2 && h > 2 && !t.hidden ? (E = L, x = 0) : E = h > 1 && x > 1 && I < 6 ? S : C), k !== c && (p = innerWidth + c * A, v = innerHeight + c, d = -1 * c, k = c), a = P[n].getBoundingClientRect(), (_ = a.bottom) >= d && (m = a.top) <= v && (g = a.right) >= d * A && (y = a.left) <= p && (_ || g || y || m) && (o.loadHidden || T(P[n])) && (u && I < 3 && !f && (h < 3 || x < 4) || M(P[n], c))) {
                            if (N(P[n]), s = !0, I > 9) break
                        } else !s && u && !r && I < 4 && x < 4 && h > 2 && (l[0] || o.preloadAfterLoad) && (l[0] || !f && (_ || g || y || m || "auto" != P[n][$](o.sizesAttr))) && (r = l[0] || P[n]);
                        r && !s && N(r)
                    }
                }), D = ye(B = function(e) {
                    var t = e.target;
                    t._lazyCache ? delete t._lazyCache : (L(e), le(t, o.loadedClass), ue(t, o.loadingClass), de(t, O), he(t, "lazyloaded"))
                }), O = function(e) {
                    D({
                        target: e.target
                    })
                }, q = function(e, t) {
                    var n = e.getAttribute("data-load-mode") || o.iframeLoadMode;
                    0 == n ? e.contentWindow.location.replace(t) : 1 == n && (e.src = t)
                }, R = function(e) {
                    var t, n = e[$](o.srcsetAttr);
                    (t = o.customMedia[e[$]("data-media") || e[$]("media")]) && e.setAttribute("media", t), n && e.setAttribute("srcset", n)
                }, F = ye((function(e, t, n, i, a) {
                    var r, s, c, l, u, h;
                    (u = he(e, "lazybeforeunveil", t)).defaultPrevented || (i && (n ? le(e, o.autosizesClass) : e.setAttribute("sizes", i)), s = e[$](o.srcsetAttr), r = e[$](o.srcAttr), a && (l = (c = e.parentNode) && oe.test(c.nodeName || "")), h = t.firesLoad || "src" in e && (s || r || l), u = {
                        target: e
                    }, le(e, o.loadingClass), h && (clearTimeout(d), d = te(L, 2500), de(e, O, !0)), l && se.call(c.getElementsByTagName("source"), R), s ? e.setAttribute("srcset", s) : r && !l && (S.test(e.nodeName) ? q(e, r) : e.src = r), a && (s || l) && fe(e, {
                        src: r
                    })), e._lazyRace && delete e._lazyRace, ue(e, o.lazyClass), me((function() {
                        var t = e.complete && e.naturalWidth > 1;
                        h && !t || (t && le(e, o.fastLoadedClass), B(u), e._lazyCache = !0, te((function() {
                            "_lazyCache" in e && delete e._lazyCache
                        }), 9)), "lazy" == e.loading && I--
                    }), !0)
                })), N = function(e) {
                    if (!e._lazyRace) {
                        var t, n = k.test(e.nodeName),
                            i = n && (e[$](o.sizesAttr) || e[$]("sizes")),
                            a = "auto" == i;
                        (!a && u || !n || !e[$]("src") && !e.srcset || e.complete || ce(e, o.errorClass) || !ce(e, o.lazyClass)) && (t = he(e, "lazyunveilread").detail, a && ke.updateElem(e, !0, e.offsetWidth), e._lazyRace = !0, I++, F(e, t, a, i, n))
                    }
                }, H = _e((function() {
                    o.loadMode = 3, P()
                })), z = function() {
                    u || (n.now() - f < 999 ? te(z, 999) : (u = !0, o.loadMode = 3, P(), ee("scroll", V, !0)))
                }, {
                    _: function() {
                        f = n.now(), i.elements = t.getElementsByClassName(o.lazyClass), l = t.getElementsByClassName(o.lazyClass + " " + o.preloadClass), ee("scroll", P, !0), ee("resize", P, !0), ee("pageshow", (function(e) {
                            if (e.persisted) {
                                var n = t.querySelectorAll("." + o.loadingClass);
                                n.length && n.forEach && ne((function() {
                                    n.forEach((function(e) {
                                        e.complete && N(e)
                                    }))
                                }))
                            }
                        })), e.MutationObserver ? new MutationObserver(P).observe(G, {
                            childList: !0,
                            subtree: !0,
                            attributes: !0
                        }) : (G[J]("DOMNodeInserted", P, !0), G[J]("DOMAttrModified", P, !0), setInterval(P, 999)), ee("hashchange", P, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach((function(e) {
                            t[J](e, P, !0)
                        })), /d$|^c/.test(t.readyState) ? z() : (ee("load", z), t[J]("DOMContentLoaded", P), te(z, 2e4)), i.elements.length ? (A(), me._lsFlush()) : P()
                    },
                    checkElems: P,
                    unveil: N,
                    _aLSL: V = function() {
                        3 == o.loadMode && (o.loadMode = 2), H()
                    }
                }),
                ke = (r = ye((function(e, t, n, i) {
                    var o, a, r;
                    if (e._lazysizesWidth = i, i += "px", e.setAttribute("sizes", i), oe.test(t.nodeName || ""))
                        for (a = 0, r = (o = t.getElementsByTagName("source")).length; a < r; a++) o[a].setAttribute("sizes", i);
                    n.detail.dataAttr || fe(e, n.detail)
                })), s = function(e, t, n) {
                    var i, o = e.parentNode;
                    o && (n = ve(e, o, n), (i = he(e, "lazybeforesizes", {
                        width: n,
                        dataAttr: !!t
                    })).defaultPrevented || (n = i.detail.width) && n !== e._lazysizesWidth && r(e, o, i, n))
                }, {
                    _: function() {
                        a = t.getElementsByClassName(o.autosizesClass), ee("resize", c)
                    },
                    checkElems: c = _e((function() {
                        var e, t = a.length;
                        if (t)
                            for (e = 0; e < t; e++) s(a[e])
                    })),
                    updateElem: s
                }),
                Se = function() {
                    !Se.i && t.getElementsByClassName && (Se.i = !0, ke._(), be._())
                };
            return te((function() {
                o.init && Se()
            })), i = {
                cfg: o,
                autoSizer: ke,
                loader: be,
                init: Se,
                uP: fe,
                aC: le,
                rC: ue,
                hC: ce,
                fire: he,
                gW: ve,
                rAF: me
            }
        }(n, n.document, Date), n.lazySizes = i, e.exports && (e.exports = i)
    })), i("gCGxJ");
    var o = {};

    function a(e, t) {
        for (var n in t) {
            var i = t[n];
            e.addEventListener(n, i.listener || i, i.options || void 0)
        }
    }! function(e, t) {
        if (e) {
            var n = function() {
                t(e.lazySizes), e.removeEventListener("lazyunveilread", n, !0)
            };
            t = t.bind(null, e, e.document), o ? t(i("gCGxJ")) : "function" == typeof define && define.amd ? define(["lazysizes"], t) : e.lazySizes ? n() : e.addEventListener("lazyunveilread", n, !0)
        }
    }("undefined" != typeof window ? window : 0, (function(e, t, n) {
        "use strict";
        if (e.addEventListener) {
            var i = /\s+(\d+)(w|h)\s+(\d+)(w|h)/,
                o = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/,
                a = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/,
                r = /^picture$/i,
                s = n.cfg,
                c = {
                    getParent: function(t, n) {
                        var i = t,
                            o = t.parentNode;
                        return n && "prev" != n || !o || !r.test(o.nodeName || "") || (o = o.parentNode), "self" != n && (i = "prev" == n ? t.previousElementSibling : n && (o.closest || e.jQuery) && (o.closest ? o.closest(n) : jQuery(o).closest(n)[0]) || o), i
                    },
                    getFit: function(e) {
                        var t, n, i = getComputedStyle(e, null) || {},
                            r = i.content || i.fontFamily,
                            s = {
                                fit: e._lazysizesParentFit || e.getAttribute("data-parent-fit")
                            };
                        return !s.fit && r && (t = r.match(o)) && (s.fit = t[1]), s.fit ? (!(n = e._lazysizesParentContainer || e.getAttribute("data-parent-container")) && r && (t = r.match(a)) && (n = t[1]), s.parent = c.getParent(e, n)) : s.fit = i.objectFit, s
                    },
                    getImageRatio: function(t) {
                        var n, o, a, c, l, u, d, h = t.parentNode,
                            f = h && r.test(h.nodeName || "") ? h.querySelectorAll("source, img") : [t];
                        for (n = 0; n < f.length; n++)
                            if (o = (t = f[n]).getAttribute(s.srcsetAttr) || t.getAttribute("srcset") || t.getAttribute("data-pfsrcset") || t.getAttribute("data-risrcset") || "", a = t._lsMedia || t.getAttribute("media"), a = s.customMedia[t.getAttribute("data-media") || a] || a, o && (!a || (e.matchMedia && matchMedia(a) || {}).matches)) {
                                (c = parseFloat(t.getAttribute("data-aspectratio"))) || ((l = o.match(i)) ? "w" == l[2] ? (u = l[1], d = l[3]) : (u = l[3], d = l[1]) : (u = t.getAttribute("width"), d = t.getAttribute("height")), c = u / d);
                                break
                            }
                        return c
                    },
                    calculateSize: function(e, t) {
                        var n, i, o, a = this.getFit(e),
                            r = a.fit,
                            s = a.parent;
                        return "width" == r || ("contain" == r || "cover" == r) && (i = this.getImageRatio(e)) ? (s ? t = s.clientWidth : s = e, o = t, "width" == r ? o = t : (n = t / s.clientHeight) && ("cover" == r && n < i || "contain" == r && n > i) && (o = t * (i / n)), o) : t
                    }
                };
            n.parentFit = c, t.addEventListener("lazybeforesizes", (function(e) {
                if (!e.defaultPrevented && e.detail.instance == n) {
                    var t = e.target;
                    e.detail.width = c.calculateSize(t, e.detail.width)
                }
            }))
        }
    }));
    var r = "IntersectionObserver" in window && "IntersectionObserverEntry" in window && "intersectionRatio" in window.IntersectionObserverEntry.prototype,
        s = /baidu|(?:google|bing|yandex|duckduck)bot/i.test(navigator.userAgent),
        c = ["src", "poster"];

    function l(e, t) {
        var n = !0,
            i = !1,
            o = void 0;
        try {
            for (var a, r = c[Symbol.iterator](); !(n = (a = r.next()).done); n = !0) {
                var s = a.value;
                s in e.dataset && (e.setAttribute(s, e.dataset[s]), e.classList.contains(t) && e.classList.remove(t))
            }
        } catch (e) {
            i = !0, o = e
        } finally {
            try {
                n || null == r.return || r.return()
            } finally {
                if (i) throw o
            }
        }
    }

    function u(e, t, n, i) {
        if ("VIDEO" == e.nodeName) {
            var o = Array.from(e.querySelectorAll("source")),
                a = !0,
                r = !1,
                s = void 0;
            try {
                for (var c, u = o[Symbol.iterator](); !(a = (c = u.next()).done); a = !0) {
                    l(c.value, t)
                }
            } catch (e) {
                r = !0, s = e
            } finally {
                try {
                    a || null == u.return || u.return()
                } finally {
                    if (r) throw s
                }
            }
            e.load()
        }
        l(e, t);
        var d = e.classList;
        d.contains(n) && (d.remove(n), d.add(i))
    }

    function d(e) {
        var t = (null == e ? void 0 : e.lazyClass) || "lazy",
            n = (null == e ? void 0 : e.lazyBackgroundClass) || "lazy-bg",
            i = (null == e ? void 0 : e.lazyBackgroundLoaded) || "lazy-bg-loaded",
            o = (null == e ? void 0 : e.threshold) || 200,
            c = (null == e ? void 0 : e.events) || {},
            l = (null == e ? void 0 : e.observeChanges) || !1,
            d = (null == e ? void 0 : e.observeRootSelector) || "body",
            h = (null == e ? void 0 : e.mutationObserverOptions) || {
                childList: !0,
                subtree: !0
            },
            f = "video.".concat(t, ",.").concat(n),
            p = Array.from(document.querySelectorAll(f)),
            v = !0,
            m = !1,
            y = void 0;
        try {
            for (var g, _ = p[Symbol.iterator](); !(v = (g = _.next()).done); v = !0) {
                a(g.value, c)
            }
        } catch (e) {
            m = !0, y = e
        } finally {
            try {
                v || null == _.return || _.return()
            } finally {
                if (m) throw y
            }
        }
        var b = !0,
            k = !1,
            S = void 0;
        if (!0 === r && !1 === s) {
            var w = new IntersectionObserver((function(e) {
                    var o = !0,
                        a = !1,
                        r = void 0;
                    try {
                        for (var s, c = function() {
                                var e = s.value;
                                if (e.isIntersecting || e.intersectionRatio) {
                                    var o = e.target;
                                    u(o, t, n, i), w.unobserve(o), p = p.filter((function(e) {
                                        return e != o
                                    })), 0 === p.length && !1 === l && w.disconnect()
                                }
                            }, d = e[Symbol.iterator](); !(o = (s = d.next()).done); o = !0) c()
                    } catch (e) {
                        a = !0, r = e
                    } finally {
                        try {
                            o || null == d.return || d.return()
                        } finally {
                            if (a) throw r
                        }
                    }
                }), {
                    rootMargin: "".concat(o, "px 0%")
                }),
                C = !0,
                E = !1,
                I = void 0;
            try {
                for (var x, L = p[Symbol.iterator](); !(C = (x = L.next()).done); C = !0) {
                    var T = x.value;
                    w.observe(T)
                }
            } catch (e) {
                E = !0, I = e
            } finally {
                try {
                    C || null == L.return || L.return()
                } finally {
                    if (E) throw I
                }
            }
            l && new MutationObserver((function() {
                var e = document.querySelectorAll(f),
                    t = !0,
                    n = !1,
                    i = void 0;
                try {
                    for (var o, l = e[Symbol.iterator](); !(t = (o = l.next()).done); t = !0) {
                        var u = o.value;
                        !1 === p.includes(u) && (p.push(u), a(u, c), !0 === r && !1 === s && w.observe(u))
                    }
                } catch (e) {
                    n = !0, i = e
                } finally {
                    try {
                        t || null == l.return || l.return()
                    } finally {
                        if (n) throw i
                    }
                }
            })).observe(document.querySelector(d), h)
        } else if (s) try {
            for (var M, A = p[Symbol.iterator](); !(b = (M = A.next()).done); b = !0) {
                u(M.value, t, n, i)
            }
        } catch (e) {
            k = !0, S = e
        } finally {
            try {
                b || null == A.return || A.return()
            } finally {
                if (k) throw S
            }
        }
    }

    function h(e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function")
    }

    function f(e, t) {
        for (var n = 0; n < t.length; n++) {
            var i = t[n];
            i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, i.key, i)
        }
    }

    function p(e, t, n) {
        return t && f(e.prototype, t), n && f(e, n), e
    }

    function v(e, t, n) {
        return t in e ? Object.defineProperty(e, t, {
            value: n,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }) : e[t] = n, e
    }

    function m(e) {
        for (var t = 1; t < arguments.length; t++) {
            var n = null != arguments[t] ? arguments[t] : {},
                i = Object.keys(n);
            "function" == typeof Object.getOwnPropertySymbols && (i = i.concat(Object.getOwnPropertySymbols(n).filter((function(e) {
                return Object.getOwnPropertyDescriptor(n, e).enumerable
            })))), i.forEach((function(t) {
                v(e, t, n[t])
            }))
        }
        return e
    }

    function y(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
        return i
    }

    function g(e) {
        if (Array.isArray(e)) return y(e)
    }

    function _(e) {
        if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e)
    }

    function b() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function k(e, t) {
        if (e) {
            if ("string" == typeof e) return y(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(n) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? y(e, t) : void 0
        }
    }

    function S(e) {
        return g(e) || _(e) || k(e) || b()
    }
    var w = function() {
            "use strict";

            function e(t) {
                h(this, e), this._notification = t
            }
            return p(e, [{
                key: "show",
                value: function(e, t) {
                    this._notification.show(e, t)
                }
            }]), e
        }(),
        C = new(function() {
            "use strict";

            function e() {
                var t = this;
                h(this, e), v(this, "_handleWindowScroll", (function() {
                    t._timeoutScrollId && (clearTimeout(t._timeoutScrollId), t.isScrolling = !0), t._timeoutScrollId = setTimeout((function() {
                        t.isScrolling = !1
                    }), 300)
                }));
                var n = document.querySelector("#GlobalNotification");
                n && (this.notification = new w(n)), this.isScrolling = !1, this.overlaySelector = "#BodyOverlay", window.addEventListener("wheel", this._handleWindowScroll), this.overlayCalls = []
            }
            return p(e, [{
                key: "showOverlay",
                value: function(e, t) {
                    var n = document.querySelector(this.overlaySelector);
                    n && (this.overlayCalls = S(this.overlayCalls).concat([{
                        key: e,
                        styles: t
                    }]), this.setBodyOverlayStyles(m({}, {
                        zIndex: 3,
                        backgroundColor: "var(--gsc-black-color-50)"
                    }, t)), n.setAttribute("visible", ""), this.setScrollLock())
                }
            }, {
                key: "hideOverlay",
                value: function(e) {
                    var t = document.querySelector(this.overlaySelector);
                    if (t && t.hasAttribute("visible")) {
                        this.overlayCalls = this.overlayCalls.filter((function(t) {
                            return t.key !== e
                        }));
                        var n = this.overlayCalls[this.overlayCalls.length - 1];
                        n ? this.setBodyOverlayStyles(n.styles) : (t.removeAttribute("visible"), t.setAttribute("style", ""), this.unsetScrollLock())
                    }
                }
            }, {
                key: "setScrollLock",
                value: function() {
                    document.body.setAttribute("scroll-y-offf", "")
                    // document.body.style.top = "-".concat(window.scrollY || Math.abs(parseInt(document.body.style.top || "0")), "px"), document.body.setAttribute("scroll-y-off", "")
                }
            }, {
                key: "unsetScrollLock",
                value: function() {
                    document.body.removeAttribute("scroll-y-offf")
                    // var e = document.body.style.top;
                    // document.body.removeAttribute("scroll-y-off"), document.body.style.top = "", window.scrollTo(0, -1 * parseInt(e || "0"))
                }
            }, {
                key: "setBodyOverlayStyles",
                value: function(e) {
                    var t = document.querySelector(this.overlaySelector);
                    t && (e && Object.keys(e).forEach((function(n) {
                        t.style[n] = e[n]
                    })))
                }
            }]), e
        }());

    function E(e) {
        if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return e
    }

    function I(e, t) {
        return I = Object.setPrototypeOf || function(e, t) {
            return e.__proto__ = t, e
        }, I(e, t)
    }

    function x(e, t) {
        return I(e, t)
    }

    function L(e, t) {
        if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
        e.prototype = Object.create(t && t.prototype, {
            constructor: {
                value: e,
                writable: !0,
                configurable: !0
            }
        }), t && x(e, t)
    }

    function T() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}))), !0
        } catch (e) {
            return !1
        }
    }

    function M(e) {
        return M = Object.setPrototypeOf ? Object.getPrototypeOf : function(e) {
            return e.__proto__ || Object.getPrototypeOf(e)
        }, M(e)
    }

    function A(e) {
        return M(e)
    }

    function P(e) {
        return e && e.constructor === Symbol ? "symbol" : typeof e
    }

    function B(e, t) {
        return !t || "object" !== P(t) && "function" != typeof t ? E(e) : t
    }

    function D(e) {
        var t = T();
        return function() {
            var n, i = A(e);
            if (t) {
                var o = A(this).constructor;
                n = Reflect.construct(i, arguments, o)
            } else n = i.apply(this, arguments);
            return B(this, n)
        }
    }

    function O(e, t, n) {
        return O = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Date.prototype.toString.call(Reflect.construct(Date, [], (function() {}))), !0
            } catch (e) {
                return !1
            }
        }() ? Reflect.construct : function(e, t, n) {
            var i = [null];
            i.push.apply(i, t);
            var o = new(Function.bind.apply(e, i));
            return n && x(o, n.prototype), o
        }, O.apply(null, arguments)
    }

    function q(e, t, n) {
        return O.apply(null, arguments)
    }

    function R(e) {
        var t = "function" == typeof Map ? new Map : void 0;
        return R = function(e) {
            if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
            var n;
            if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, i)
            }

            function i() {
                return q(e, arguments, A(this).constructor)
            }
            return i.prototype = Object.create(e.prototype, {
                constructor: {
                    value: i,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), x(i, e)
        }, R(e)
    }

    function F(e) {
        return R(e)
    }
    var N = {
            SECTION_LOAD: "shopify:section:load",
            SECTION_UNLOAD: "shopify:section:unload",
            SECTION_SELECT: "shopify:section:select",
            SECTION_DESELECT: "shopify:section:deselect",
            SECTION_REORDER: "shopify:section:reorder",
            BLOCK_SELECT: "shopify:block:select",
            BLOCK_DESELECT: "shopify:block:deselect"
        },
        H = {
            ARROW_LEFT_STRING_KEY: "ArrowLeft",
            ARROW_RIGHT_STRING_KEY: "ArrowRight",
            ARROW_LEFT_NUMBER_KEY: 37,
            ARROW_RIGHT_NUMBER_KEY: 39,
            ENTER_STRING_KEY: "Enter",
            ENTER_NUMBER_KEY: 13,
            ESCAPE_STRING_KEY: "Escape",
            ESCAPE_NUMBER_KEY: 27
        },
        V = function(e) {
            return new Promise((function(t, n) {
                setTimeout(t, e)
            }))
        },
        z = function(e, t, n, i) {
            n && e && t && e["".concat(i, "EventListener")](t, n)
        },
        K = function(e, t, n) {
            z(e, t, n, "add")
        },
        U = function(e, t, n) {
            z(e, t, n, "remove")
        },
        W = new IntersectionObserver((function(e, t) {
            e.forEach((function(e) {
                var t = e.isIntersecting,
                    n = e.target.closest('[aria-hidden="true"], .hidden');
                e.target.toggleAttribute("data-is-in-viewport", t && !n)
            }))
        })),
        Y = function() {
            return ["button", "[href]", "[data-focus-trap-target]", "a", "[tabindex]"].map((function(e) {
                return "".concat(e, ':not([tabindex="-1"]):not([data-color-swatches-hidden-count]:empty)')
            })).join(",")
        },
        j = function(e) {
            var t = document.createElement("div");
            return t.classList.add("hidden"), document.body.appendChild(t), t.appendChild(e), t
        },
        X = function(e) {
            e.remove()
        },
        Q = function(e) {
            return e === H.ENTER_NUMBER_KEY || e === H.ENTER_STRING_KEY
        },
        G = function(e) {
            return e === H.ARROW_RIGHT_NUMBER_KEY || e === H.ARROW_RIGHT_STRING_KEY
        },
        Z = function(e) {
            return e === H.ARROW_LEFT_NUMBER_KEY || e === H.ARROW_LEFT_STRING_KEY
        },
        J = function() {
            "use strict";

            function e() {
                h(this, e), this._listeners = {}
            }
            return p(e, [{
                key: "subscribe",
                value: function(e, t) {
                    this._listeners[e] || (this._listeners[e] = []), K(document, N[e], t), this._listeners[e].push(t)
                }
            }, {
                key: "unsubscribe",
                value: function(e, t) {
                    this._listeners[e] && (U(document, N[e], t), this._listeners[e] = this._listeners[e].filter((function(e) {
                        return e !== t
                    })))
                }
            }, {
                key: "destroy",
                value: function() {
                    var e = this;
                    Object.keys(this._listeners).forEach((function(t) {
                        e._listeners[t].forEach((function(n) {
                            e.unsubscribe(t, n)
                        }))
                    })), this._listeners = {}
                }
            }]), e
        }(),
        $ = window.Shopify,
        ee = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), (e = t.call(this))._editor = new J, e._isEditorMode = $.designMode, e._listeners = {}, e
            }
            return p(n, [{
                key: "subscribe",
                value: function(e, t) {
                    this._listeners[e] || (this._listeners[e] = []), this._listeners[e].push(t)
                }
            }, {
                key: "unsubscribe",
                value: function(e, t) {
                    this._listeners[e] && (this._listeners[e] = this._listeners[e].filter((function(e) {
                        return e !== t
                    })))
                }
            }, {
                key: "emit",
                value: function(e, t) {
                    this._listeners[e] && this._listeners[e].forEach((function(e) {
                        return e(t)
                    }))
                }
            }]), n
        }(F(HTMLElement)),
        te = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleClick", (function(t) {
                    var n = t.target;
                    if (n.hasAttribute("data-login-form-button")) {
                        var i = n.dataset.loginFormId || "";
                        e.setFormVisibleById(i), e.updateFocus()
                    }
                })), e.forms = S(e.querySelectorAll("[data-login-form]")), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.updateFocus(), this.addEventListener("click", this._handleClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("click", this._handleClick)
                }
            }, {
                key: "setFormVisibleById",
                value: function(e) {
                    this.forms.forEach((function(t) {
                        var n = t.getAttribute("data-login-form") === e;
                        t.classList.toggle("hidden", !n)
                    }))
                }
            }, {
                key: "updateFocus",
                value: function() {
                    this.forms.forEach((function(e) {
                        var t = e.classList.contains("hidden"),
                            n = e.querySelector('[type="email"]');
                        !t && n && n.focus()
                    }))
                }
            }]), n
        }(ee),
        ne = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleWindowScroll", (function() {
                    e.updateButtonVisible()
                })), v(E(e), "_handleButtonClick", (function() {
                    e.scrollToTop()
                })), e.button = e.querySelector("[data-back-to-top-button]"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.button && this.button.addEventListener("click", this._handleButtonClick), window.addEventListener("scroll", this._handleWindowScroll)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.button && this.button.removeEventListener("click", this._handleButtonClick), window.removeEventListener("scroll", this._handleWindowScroll)
                }
            }, {
                key: "updateButtonVisible",
                value: function() {
                    if (this.button) {
                        var e = window.scrollY > window.innerHeight;
                        this.button.toggleAttribute("visible", e)
                    }
                }
            }, {
                key: "scrollToTop",
                value: function() {
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth"
                    })
                }
            }]), n
        }(F(HTMLElement)),
        ie = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleWindowScroll", (function() {
                    var t = document.querySelector(".shopify-section.shopify-section-header");
                    if (t && e.button) {
                        var n = t.getBoundingClientRect().bottom + e.button.offsetHeight < 0;
                        e.button.toggleAttribute("visible", n)
                    }
                })), e.button = e.querySelector("[data-cart-sticky-button]"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    window.addEventListener("scroll", this._handleWindowScroll)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    window.removeEventListener("scroll", this._handleWindowScroll)
                }
            }]), n
        }(F(HTMLElement)),
        oe = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleBlur", (function(t) {
                    if (e.input) {
                        var n = t.target.value || "0";
                        e.input.value = n, e._updateButtonsDisabled(), e._prevValue = n
                    }
                })), v(E(e), "_handleKeydown", (function(t) {
                    e.input && (Q(t.key || t.keyCode) && (t.preventDefault(), e.input.blur()))
                })), v(E(e), "_handleInput", (function(t) {
                    if (e.input) {
                        var n = t.target.value;
                        e.input.value = e._isMoreThanStock ? e._stockValue : n, e._updateButtonsDisabled(), e._prevValue = n
                    }
                })), e.inputSelector = "[data-quantity-input]", e.input = e.querySelector(e.inputSelector), e._prevValue = e._value, e._stockValue = e.dataset.stock || "0", e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._updateButtonsDisabled(), K(this.input, "keypress", this._handleKeydown), K(this.input, "input", this._handleInput), K(this.input, "blur", this._handleBlur)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this.input, "keypress", this._handleKeydown), U(this.input, "input", this._handleInput), U(this.input, "blur", this._handleBlur)
                }
            }, {
                key: "inputChange",
                value: function(e) {
                    this.input && ("minus" === e ? this.input.stepDown() : this.input.stepUp(), +this._prevValue != +this._value && this.input.dispatchEvent(new Event("change", {
                        bubbles: !0
                    })), this._updateButtonsDisabled())
                }
            }, {
                key: "_updateButtonsDisabled",
                value: function() {
                    this._updateButtonDisabled("minus", this._isLessThanMin), this._updateButtonDisabled("plus", this._isMoreThanStock)
                }
            }, {
                key: "setDisable",
                value: function(e) {
                    this._updateButtonDisabled("minus", e), this._updateButtonDisabled("plus", e)
                }
            }, {
                key: "_updateButtonDisabled",
                value: function(e, t) {
                    var n = this.querySelector('quantity-btn[data-action="'.concat(e, '"]'));
                    n && n.toggleAttribute("disabled", t)
                }
            }, {
                key: "_value",
                get: function() {
                    return this.input ? this.input.value : "0"
                }
            }, {
                key: "_isLessThanMin",
                get: function() {
                    return !!this.input && +this._value <= +this.input.min
                }
            }, {
                key: "_isMoreThanStock",
                get: function() {
                    return +this._value >= +this._stockValue
                }
            }]), n
        }(ee),
        ae = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleButtonClick", (function(t) {
                    t.preventDefault(), e.update()
                })), v(E(e), "_handleKeyDown", (function(t) {
                    var n = Q(t.key || t.keyCode),
                        i = t.target;
                    n && !i.hasAttribute("disabled") && (t.preventDefault(), e.update())
                })), e._quantity = e.closest("quantity-component"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("click", this._handleButtonClick), this.addEventListener("keydown", this._handleKeyDown)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("click", this._handleButtonClick), this.removeEventListener("keydown", this._handleKeyDown)
                }
            }, {
                key: "update",
                value: function() {
                    var e = this.dataset.action;
                    this._quantity && e && (this._quantity.inputChange(e), "minus" === e && this._setDisabled())
                }
            }, {
                key: "_setDisabled",
                value: function() {
                    if (this._quantity && this._quantity.input) {
                        var e = "1" === this._quantity.input.value;
                        this.toggleAttribute("disabled", e)
                    }
                }
            }]), n
        }(ee),
        re = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleClick", (function(t) {
                    t.preventDefault();
                    var n = t.target;
                    n.hasAttribute("data-localization-item") && e.input && e.form && n.dataset.value && (e.input.value = n.dataset.value, e.form.submit())
                })), e.inputSelector = "[data-localization-input]", e.formSelector = "form", e.input = e.querySelector(e.inputSelector), e.form = e.querySelector(e.formSelector), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this, "click", this._handleClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this, "click", this._handleClick)
                }
            }]), n
        }(ee),
        se = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleCloseButtonClick", (function() {
                    e.hide()
                })), e._closeBtnSelector = "[data-notification-close-button]", e._alertSelector = "[data-notification-alert]", e._alertTextSelector = "[data-notification-alert-text]", e._closeBtn = e.querySelector(e._closeBtnSelector), e._alert = e.querySelector(e._alertSelector), e._alertText = e.querySelector(e._alertTextSelector), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._closeBtn && this._closeBtn.addEventListener("click", this._handleCloseButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._closeBtn && this._closeBtn.removeEventListener("click", this._handleCloseButtonClick)
                }
            }, {
                key: "show",
                value: function(e, t) {
                    var n = this;
                    this._setAlert(e, t || "warning"), this.showTimeoutId && clearTimeout(this.showTimeoutId), this._setVisible(!0), this.showTimeoutId = setTimeout((function() {
                        n._setVisible(!1)
                    }), 3e3)
                }
            }, {
                key: "hide",
                value: function() {
                    this._setVisible(!1)
                }
            }, {
                key: "_setVisible",
                value: function(e) {
                    this.toggleAttribute("open", e)
                }
            }, {
                key: "_setAlert",
                value: function(e, t) {
                    this._alert && this._alertText && (this._alert.setAttribute("alert-type", t), this._alertText.innerHTML = e)
                }
            }]), n
        }(ee);

    function ce(e, t) {
        return t = null != t ? t : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : function(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var i = Object.getOwnPropertySymbols(e);
                t && (i = i.filter((function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable
                }))), n.push.apply(n, i)
            }
            return n
        }(Object(t)).forEach((function(n) {
            Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(t, n))
        })), e
    }
    var le = function() {
            "use strict";

            function e(t) {
                h(this, e), this.element = t
            }
            return p(e, [{
                key: "update",
                value: function(e) {
                    var t = e === this.element.getAttribute("data-id");
                    this.element.classList.toggle("selected", t)
                }
            }]), e
        }(),
        ue = function(e) {
            e && e.classList.remove("hidden")
        },
        de = function(e) {
            e && e.classList.add("hidden")
        },
        he = function(e, t) {
            return getComputedStyle(e)[t]
        },
        fe = function(e) {
            return e.content.cloneNode(!0)
        },
        pe = function(e) {
            return e.content.firstElementChild.cloneNode(!0)
        },
        ve = function(e, t) {
            e && e.classList.toggle("forward-transition", t)
        },
        me = function(e) {
            return (new DOMParser).parseFromString(e, "text/html")
        },
        ye = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleTabNameClick", (function(t) {
                    t.preventDefault();
                    var n = t.target;
                    n.dataset.id && e.selectTab(n.dataset.id)
                })), v(E(e), "_handleKeyDown", (function(t) {
                    var n = t.target;
                    n.dataset.id && (Q(t.key || t.keyCode) && (t.preventDefault(), e.selectTab(n.dataset.id)))
                })), e.containerSelector = "[data-tabs-container]", e.templateSelector = "[data-tabs-elements-template]", e.tabSelector = "tab-component", e.tabNameSelector = "[data-tabs-name]", e.container = e.querySelector(e.containerSelector), e.template = e.querySelector(e.templateSelector), e.templateContent = fe(e.template), e.tabNames = S(e.querySelectorAll(e.tabNameSelector)), e.tabMap = e.generateTabMap(), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this;
                    this.tabNames.forEach((function(t) {
                        t.addEventListener("keydown", e._handleKeyDown), t.addEventListener("click", e._handleTabNameClick)
                    }))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    var e = this;
                    this.tabNames.forEach((function(t) {
                        t.removeEventListener("keydown", e._handleKeyDown), t.removeEventListener("click", e._handleTabNameClick)
                    }))
                }
            }, {
                key: "generateTabMap",
                value: function() {
                    return [this.querySelector(this.tabSelector)].concat(S(this.templateContent.querySelectorAll(this.tabSelector))).reduce((function(e, t) {
                        var n = t.dataset.id;
                        return n ? ce(m({}, e), v({}, n, t)) : e
                    }), {})
                }
            }, {
                key: "selectTab",
                value: function(e) {
                    this._updateNameById(e), this._setTabById(e), this.emit("selectTab", e)
                }
            }, {
                key: "_unmountTab",
                value: function(e) {
                    e.remove()
                }
            }, {
                key: "_mountTab",
                value: function(e) {
                    this.container && this.container.appendChild(e)
                }
            }, {
                key: "_updateNameById",
                value: function(e) {
                    this.tabNames.forEach((function(t) {
                        new le(t).update(e)
                    }))
                }
            }, {
                key: "_setTabById",
                value: function(e) {
                    var t = this.tabMap[e],
                        n = this.tabMap[this.dataset.selectedTabId];
                    n && t && (this.showNextTab(t), n !== t && this.hideCurrentTab(n))
                }
            }, {
                key: "showNextTab",
                value: function(e) {
                    var t = e.getAttribute("data-id");
                    t && (this._mountTab(e), e.show(), this.dataset.selectedTabId = t)
                }
            }, {
                key: "hideCurrentTab",
                value: function(e) {
                    var t = this;
                    e.hide().then((function() {
                        t._unmountTab(e)
                    }))
                }
            }]), n
        }(ee),
        ge = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "collapse", (function() {
                    e._hideItems(), de(e._collapseBtn), ue(e._expandBtn)
                })), v(E(e), "expand", (function() {
                    e._initialHeight || e._setInitialHeight(), e._showItems(), e._tryHideExpandBtn(), ue(e._collapseBtn), e._setMaxHeight()
                })), e.itemSelector = "[data-list-item]", e.expandBtnSelector = 'list-btn[data-trigger="expand"]', e.collapseBtnSelector = 'list-btn[data-trigger="collapse"]', e.visibleItemSelector = "".concat(e.itemSelector, ":not(.hidden)"), e.hiddenItemSelector = "".concat(e.itemSelector, ".hidden"), e._expandBtn = e.querySelector(e.expandBtnSelector), e._collapseBtn = e.querySelector(e.collapseBtnSelector), e.styles = getComputedStyle(E(e)), e
            }
            return p(n, [{
                key: "_setInitialHeight",
                value: function() {
                    this._initialHeight = this.offsetHeight, this.style.maxHeight = "".concat(this._initialHeight, "px")
                }
            }, {
                key: "_setMaxHeight",
                value: function() {
                    this._maxHeight = this.scrollHeight, this.style.maxHeight = "".concat(this._maxHeight, "px")
                }
            }, {
                key: "_hideItems",
                value: function() {
                    var e = this,
                        t = this.querySelectorAll(this.visibleItemSelector);
                    this.style.maxHeight = "".concat(this._initialHeight, "px"), setTimeout((function() {
                        t.forEach((function(t, n) {
                            n + 1 > +(e.dataset.initialCount ? +e.dataset.initialCount : 0) && de(t)
                        }))
                    }), this._transitionDuration)
                }
            }, {
                key: "_showItems",
                value: function() {
                    var e = this;
                    this.querySelectorAll(this.hiddenItemSelector).forEach((function(t, n) {
                        n + 1 < +(e.dataset.showCount ? e.dataset.showCount : 0) && ue(t)
                    })), this.style.maxHeight = "".concat(this._maxHeight, "px")
                }
            }, {
                key: "_tryHideExpandBtn",
                value: function() {
                    0 === this.querySelectorAll(this.hiddenItemSelector).length && de(this._expandBtn)
                }
            }, {
                key: "_transitionDuration",
                get: function() {
                    return 1e3 * parseFloat(this.styles.transitionDuration)
                }
            }]), n
        }(ee),
        _e = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function() {
                    e.update()
                })), v(E(e), "_handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e.update())
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("keydown", this._handleKeyDown), this.addEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("keydown", this._handleKeyDown), this.removeEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "update",
                value: function() {
                    var e = this.closest("list-component");
                    e && ("collapse" === this.dataset.trigger ? e.collapse() : e.expand(), this.emit("click", e))
                }
            }]), n
        }(ee),
        be = _e;

    function ke(e, t, n, i, o, a, r) {
        try {
            var s = e[a](r),
                c = s.value
        } catch (e) {
            return void n(e)
        }
        s.done ? t(c) : Promise.resolve(c).then(i, o)
    }

    function Se(e) {
        return function() {
            var t = this,
                n = arguments;
            return new Promise((function(i, o) {
                var a = e.apply(t, n);

                function r(e) {
                    ke(a, i, o, r, s, "next", e)
                }

                function s(e) {
                    ke(a, i, o, r, s, "throw", e)
                }
                r(void 0)
            }))
        }
    }

    function we(e, t) {
        if (null == e) return {};
        var n, i, o = {},
            a = Object.keys(e);
        for (i = 0; i < a.length; i++) n = a[i], t.indexOf(n) >= 0 || (o[n] = e[n]);
        return o
    }

    function Ce(e, t) {
        if (null == e) return {};
        var n, i, o = we(e, t);
        if (Object.getOwnPropertySymbols) {
            var a = Object.getOwnPropertySymbols(e);
            for (i = 0; i < a.length; i++) n = a[i], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n])
        }
        return o
    }

    function Ee(e, t) {
        var n, i, o, a, r = function(e) {
                return function(t) {
                    return s([e, t])
                }
            },
            s = function(r) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && (a = 0, r[0] && (c = 0)), c;) try {
                    if (n = 1, i && (o = 2 & r[0] ? i.return : r[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, r[1])).done) return o;
                    switch (i = 0, o && (r = [2 & r[0], o.value]), r[0]) {
                        case 0:
                        case 1:
                            o = r;
                            break;
                        case 4:
                            return c.label++, {
                                value: r[1],
                                done: !1
                            };
                        case 5:
                            c.label++, i = r[1], r = [0];
                            continue;
                        case 7:
                            r = c.ops.pop(), c.trys.pop();
                            continue;
                        default:
                            if (!(o = c.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== r[0] && 2 !== r[0])) {
                                c = 0;
                                continue
                            }
                            if (3 === r[0] && (!o || r[1] > o[0] && r[1] < o[3])) {
                                c.label = r[1];
                                break
                            }
                            if (6 === r[0] && c.label < o[1]) {
                                c.label = o[1], o = r;
                                break
                            }
                            if (o && c.label < o[2]) {
                                c.label = o[2], c.ops.push(r);
                                break
                            }
                            o[2] && c.ops.pop(), c.trys.pop();
                            continue
                    }
                    r = t.call(e, c)
                } catch (e) {
                    r = [6, e], i = 0
                } finally {
                    n = o = 0
                }
                if (5 & r[0]) throw r[1];
                return {
                    value: r[0] ? r[1] : void 0,
                    done: !0
                }
            },
            c = {
                label: 0,
                sent: function() {
                    if (1 & o[0]) throw o[1];
                    return o[1]
                },
                trys: [],
                ops: []
            };
        return a = {
            next: r(0),
            throw: r(1),
            return: r(2)
        }, "function" == typeof Symbol && (a[Symbol.iterator] = function() {
            return this
        }), a
    }
    Object.create;
    Object.create;

    function Ie(e) {
        return e.split("-")[1]
    }

    function xe(e) {
        return "y" === e ? "height" : "width"
    }

    function Le(e) {
        return e.split("-")[0]
    }

    function Te(e) {
        return ["top", "bottom"].includes(Le(e)) ? "x" : "y"
    }

    function Me(e, t, n) {
        var i, o = e.reference,
            a = e.floating,
            r = o.x + o.width / 2 - a.width / 2,
            s = o.y + o.height / 2 - a.height / 2,
            c = Te(t),
            l = xe(c),
            u = o[l] / 2 - a[l] / 2,
            d = "x" === c;
        switch (Le(t)) {
            case "top":
                i = {
                    x: r,
                    y: o.y - a.height
                };
                break;
            case "bottom":
                i = {
                    x: r,
                    y: o.y + o.height
                };
                break;
            case "right":
                i = {
                    x: o.x + o.width,
                    y: s
                };
                break;
            case "left":
                i = {
                    x: o.x - a.width,
                    y: s
                };
                break;
            default:
                i = {
                    x: o.x,
                    y: o.y
                }
        }
        switch (Ie(t)) {
            case "start":
                i[c] -= u * (n && d ? -1 : 1);
                break;
            case "end":
                i[c] += u * (n && d ? -1 : 1)
        }
        return i
    }
    var Ae, Pe = (Ae = Se((function(e, t, n) {
        var i, o, a, r, s, c, l, u, d, h, f, p, y, g, _, b, k, S, w, C, E, I, x, L, T, M;
        return Ee(this, (function(A) {
            switch (A.label) {
                case 0:
                    return i = n.placement, o = void 0 === i ? "bottom" : i, a = n.strategy, r = void 0 === a ? "absolute" : a, s = n.middleware, c = void 0 === s ? [] : s, l = n.platform, u = c.filter(Boolean), [4, null == l.isRTL ? void 0 : l.isRTL(t)];
                case 1:
                    return d = A.sent(), [4, l.getElementRects({
                        reference: e,
                        floating: t,
                        strategy: r
                    })];
                case 2:
                    h = A.sent(), f = Me(h, o, d), p = f.x, y = f.y, g = o, _ = {}, b = 0, k = 0, A.label = 3;
                case 3:
                    return k < u.length ? (S = u[k], w = S.name, [4, (0, S.fn)({
                        x: p,
                        y: y,
                        initialPlacement: o,
                        placement: g,
                        strategy: r,
                        middlewareData: _,
                        rects: h,
                        platform: l,
                        elements: {
                            reference: e,
                            floating: t
                        }
                    })]) : [3, 11];
                case 4:
                    return C = A.sent(), E = C.x, I = C.y, x = C.data, L = C.reset, p = null != E ? E : p, y = null != I ? I : y, _ = ce(m({}, _), v({}, w, m({}, _[w], x))), L && b <= 50 ? (b++, "object" != typeof L ? [3, 9] : (L.placement && (g = L.placement), L.rects ? !0 !== L.rects ? [3, 6] : [4, l.getElementRects({
                        reference: e,
                        floating: t,
                        strategy: r
                    })] : [3, 8])) : [3, 10];
                case 5:
                    return T = A.sent(), [3, 7];
                case 6:
                    T = L.rects, A.label = 7;
                case 7:
                    h = T, A.label = 8;
                case 8:
                    M = Me(h, g, d), p = M.x, y = M.y, A.label = 9;
                case 9:
                    return k = -1, [3, 10];
                case 10:
                    return k++, [3, 3];
                case 11:
                    return [2, {
                        x: p,
                        y: y,
                        placement: g,
                        strategy: r,
                        middlewareData: _
                    }]
            }
        }))
    })), function(e, t, n) {
        return Ae.apply(this, arguments)
    });

    function Be(e) {
        return "number" != typeof e ? function(e) {
            return m({
                top: 0,
                right: 0,
                bottom: 0,
                left: 0
            }, e)
        }(e) : {
            top: e,
            right: e,
            bottom: e,
            left: e
        }
    }

    function De(e) {
        return ce(m({}, e), {
            top: e.y,
            left: e.x,
            right: e.x + e.width,
            bottom: e.y + e.height
        })
    }

    function Oe(e, t) {
        return qe.apply(this, arguments)
    }

    function qe() {
        return (qe = Se((function(e, t) {
            var n, i, o, a, r, s, c, l, u, d, h, f, p, v, y, g, _, b, k, S, w, C, E, I, x, L, T, M, A, P;
            return Ee(this, (function(B) {
                switch (B.label) {
                    case 0:
                        return void 0 === t && (t = {}), i = e.x, o = e.y, a = e.platform, r = e.rects, s = e.elements, c = e.strategy, l = t.boundary, u = void 0 === l ? "clippingAncestors" : l, d = t.rootBoundary, h = void 0 === d ? "viewport" : d, f = t.elementContext, p = void 0 === f ? "floating" : f, v = t.altBoundary, y = void 0 !== v && v, g = t.padding, _ = Be(void 0 === g ? 0 : g), b = "floating" === p ? "reference" : "floating", k = s[y ? b : p], w = a.getClippingRect, C = {}, [4, null == a.isElement ? void 0 : a.isElement(k)];
                    case 1:
                        return null == (n = B.sent()) || n ? (E = k, [3, 5]) : [3, 2];
                    case 2:
                        return (I = k.contextElement) ? [3, 4] : [4, null == a.getDocumentElement ? void 0 : a.getDocumentElement(s.floating)];
                    case 3:
                        I = B.sent(), B.label = 4;
                    case 4:
                        E = I, B.label = 5;
                    case 5:
                        return [4, w.apply(a, [(C.element = E, C.boundary = u, C.rootBoundary = h, C.strategy = c, C)])];
                    case 6:
                        return S = De.apply(void 0, [B.sent()]), x = "floating" === p ? ce(m({}, r.floating), {
                            x: i,
                            y: o
                        }) : r.reference, [4, null == a.getOffsetParent ? void 0 : a.getOffsetParent(s.floating)];
                    case 7:
                        return L = B.sent(), [4, null == a.isElement ? void 0 : a.isElement(L)];
                    case 8:
                        return B.sent() ? [4, null == a.getScale ? void 0 : a.getScale(L)] : [3, 10];
                    case 9:
                        return M = B.sent() || {
                            x: 1,
                            y: 1
                        }, [3, 11];
                    case 10:
                        M = {
                            x: 1,
                            y: 1
                        }, B.label = 11;
                    case 11:
                        return T = M, a.convertOffsetParentRelativeRectToViewportRelativeRect ? [4, a.convertOffsetParentRelativeRectToViewportRelativeRect({
                            rect: x,
                            offsetParent: L,
                            strategy: c
                        })] : [3, 13];
                    case 12:
                        return P = B.sent(), [3, 14];
                    case 13:
                        P = x, B.label = 14;
                    case 14:
                        return A = De.apply(void 0, [P]), [2, {
                            top: (S.top - A.top + _.top) / T.y,
                            bottom: (A.bottom - S.bottom + _.bottom) / T.y,
                            left: (S.left - A.left + _.left) / T.x,
                            right: (A.right - S.right + _.right) / T.x
                        }]
                }
            }))
        }))).apply(this, arguments)
    }
    var Re = Math.min,
        Fe = Math.max;

    function Ne(e, t, n) {
        return Fe(e, Re(t, n))
    }
    var He = function(e) {
            return {
                name: "arrow",
                options: e,
                fn: function(t) {
                    return Se((function() {
                        var n, i, o, a, r, s, c, l, u, d, h, f, p, m, y, g, _, b, k, S, w, C, E, I, x, L, T, M, A, P, B, D, O;
                        return Ee(this, (function(q) {
                            switch (q.label) {
                                case 0:
                                    return i = (n = e || {}).element, o = n.padding, a = void 0 === o ? 0 : o, r = t.x, s = t.y, c = t.placement, l = t.rects, u = t.platform, d = t.elements, null == i ? [2, {}] : (h = Be(a), f = {
                                        x: r,
                                        y: s
                                    }, p = Te(c), m = xe(p), [4, u.getDimensions(i)]);
                                case 1:
                                    return y = q.sent(), _ = (g = "y" === p) ? "top" : "left", b = g ? "bottom" : "right", k = g ? "clientHeight" : "clientWidth", S = l.reference[m] + l.reference[p] - f[p] - l.floating[m], w = f[p] - l.reference[p], [4, null == u.getOffsetParent ? void 0 : u.getOffsetParent(i)];
                                case 2:
                                    return C = q.sent(), E = C ? C[k] : 0, (I = !E) ? [3, 4] : [4, null == u.isElement ? void 0 : u.isElement(C)];
                                case 3:
                                    I = !q.sent(), q.label = 4;
                                case 4:
                                    return I && (E = d.floating[k] || l.floating[m]), x = S / 2 - w / 2, L = h[_], T = E - y[m] - h[b], M = E / 2 - y[m] / 2 + x, A = Ne(L, M, T), P = null != Ie(c) && M != A && l.reference[m] / 2 - (M < L ? h[_] : h[b]) - y[m] / 2 < 0, B = P ? M < L ? L - M : T - M : 0, [2, (O = {}, v(O, p, f[p] - B), v(O, "data", (D = {}, v(D, p, A), v(D, "centerOffset", M - A), D)), O)]
                            }
                        }))
                    }))()
                }
            }
        },
        Ve = {
            left: "right",
            right: "left",
            bottom: "top",
            top: "bottom"
        };

    function ze(e) {
        return e.replace(/left|right|bottom|top/g, (function(e) {
            return Ve[e]
        }))
    }

    function Ke(e, t, n) {
        void 0 === n && (n = !1);
        var i = Ie(e),
            o = Te(e),
            a = xe(o),
            r = "x" === o ? i === (n ? "end" : "start") ? "right" : "left" : "start" === i ? "bottom" : "top";
        return t.reference[a] > t.floating[a] && (r = ze(r)), {
            main: r,
            cross: ze(r)
        }
    }
    var Ue = {
        start: "end",
        end: "start"
    };

    function We(e) {
        return e.replace(/start|end/g, (function(e) {
            return Ue[e]
        }))
    }
    var Ye = function(e) {
        return void 0 === e && (e = {}), {
            name: "flip",
            options: e,
            fn: function(t) {
                return Se((function() {
                    var n, i, o, a, r, s, c, l, u, d, h, f, p, v, m, y, g, _, b, k, w, C, E, I, x, L, T, M, A, P, B, D, O, q, R, F, N, H;
                    return Ee(this, (function(V) {
                        switch (V.label) {
                            case 0:
                                return o = t.placement, a = t.middlewareData, r = t.rects, s = t.initialPlacement, c = t.platform, l = t.elements, u = e.mainAxis, d = void 0 === u || u, h = e.crossAxis, f = void 0 === h || h, p = e.fallbackPlacements, v = e.fallbackStrategy, m = void 0 === v ? "bestFit" : v, y = e.fallbackAxisSideDirection, g = void 0 === y ? "none" : y, _ = e.flipAlignment, b = void 0 === _ || _, k = Ce(e, ["mainAxis", "crossAxis", "fallbackPlacements", "fallbackStrategy", "fallbackAxisSideDirection", "flipAlignment"]), w = Le(o), C = Le(s) === s, [4, null == c.isRTL ? void 0 : c.isRTL(l.floating)];
                            case 1:
                                return E = V.sent(), I = p || (C || !b ? [ze(s)] : function(e) {
                                    var t = ze(e);
                                    return [We(e), t, We(t)]
                                }(s)), p || "none" === g || (n = I).push.apply(n, S(function(e, t, n, i) {
                                    var o = Ie(e),
                                        a = function(e, t, n) {
                                            var i = ["left", "right"],
                                                o = ["right", "left"];
                                            switch (e) {
                                                case "top":
                                                case "bottom":
                                                    return n ? t ? o : i : t ? i : o;
                                                case "left":
                                                case "right":
                                                    return t ? ["top", "bottom"] : ["bottom", "top"];
                                                default:
                                                    return []
                                            }
                                        }(Le(e), "start" === n, i);
                                    return o && (a = a.map((function(e) {
                                        return e + "-" + o
                                    })), t && (a = a.concat(a.map(We)))), a
                                }(s, b, g, E))), x = [s].concat(S(I)), [4, Oe(t, k)];
                            case 2:
                                if (L = V.sent(), T = [], M = (null == (i = a.flip) ? void 0 : i.overflows) || [], d && T.push(L[w]), f && (A = Ke(o, r, E), P = A.main, B = A.cross, T.push(L[P], L[B])), M = S(M).concat([{
                                        placement: o,
                                        overflows: T
                                    }]), !T.every((function(e) {
                                        return e <= 0
                                    }))) {
                                    if (q = ((null == (D = a.flip) ? void 0 : D.index) || 0) + 1, R = x[q]) return [2, {
                                        data: {
                                            index: q,
                                            overflows: M
                                        },
                                        reset: {
                                            placement: R
                                        }
                                    }];
                                    if (!(F = null == (O = M.filter((function(e) {
                                            return e.overflows[0] <= 0
                                        })).sort((function(e, t) {
                                            return e.overflows[1] - t.overflows[1]
                                        }))[0]) ? void 0 : O.placement)) switch (m) {
                                        case "bestFit":
                                            H = null == (N = M.map((function(e) {
                                                return [e.placement, e.overflows.filter((function(e) {
                                                    return e > 0
                                                })).reduce((function(e, t) {
                                                    return e + t
                                                }), 0)]
                                            })).sort((function(e, t) {
                                                return e[1] - t[1]
                                            }))[0]) ? void 0 : N[0], H && (F = H);
                                            break;
                                        case "initialPlacement":
                                            F = s
                                    }
                                    if (o !== F) return [2, {
                                        reset: {
                                            placement: F
                                        }
                                    }]
                                }
                                return [2, {}]
                        }
                    }))
                }))()
            }
        }
    };

    function je(e, t) {
        return Xe.apply(this, arguments)
    }

    function Xe() {
        return Xe = Se((function(e, t) {
            var n, i, o, a, r, s, c, l, u, d, h, f, p, v;
            return Ee(this, (function(y) {
                switch (y.label) {
                    case 0:
                        return n = e.placement, i = e.platform, o = e.elements, [4, null == i.isRTL ? void 0 : i.isRTL(o.floating)];
                    case 1:
                        return a = y.sent(), r = Le(n), s = Ie(n), c = "x" === Te(n), l = ["left", "top"].includes(r) ? -1 : 1, u = a && c ? -1 : 1, d = "function" == typeof t ? t(e) : t, h = "number" == typeof d ? {
                            mainAxis: d,
                            crossAxis: 0,
                            alignmentAxis: null
                        } : m({
                            mainAxis: 0,
                            crossAxis: 0,
                            alignmentAxis: null
                        }, d), f = h.mainAxis, p = h.crossAxis, v = h.alignmentAxis, s && "number" == typeof v && (p = "end" === s ? -1 * v : v), [2, c ? {
                            x: p * u,
                            y: f * l
                        } : {
                            x: f * l,
                            y: p * u
                        }]
                }
            }))
        })), Xe.apply(this, arguments)
    }
    var Qe = function(e) {
        return void 0 === e && (e = 0), {
            name: "offset",
            options: e,
            fn: function(t) {
                return Se((function() {
                    var n, i, o;
                    return Ee(this, (function(a) {
                        switch (a.label) {
                            case 0:
                                return n = t.x, i = t.y, [4, je(t, e)];
                            case 1:
                                return o = a.sent(), [2, {
                                    x: n + o.x,
                                    y: i + o.y,
                                    data: o
                                }]
                        }
                    }))
                }))()
            }
        }
    };

    function Ge(e) {
        return "x" === e ? "y" : "x"
    }
    var Ze, Je = function(e) {
        return void 0 === e && (e = {}), {
            name: "shift",
            options: e,
            fn: function(t) {
                return Se((function() {
                    var n, i, o, a, r, s, c, l, u, d, h, f, p, y, g, _, b, k, S, w, C, E, I, x;
                    return Ee(this, (function(L) {
                        switch (L.label) {
                            case 0:
                                return n = t.x, i = t.y, o = t.placement, a = e.mainAxis, r = void 0 === a || a, s = e.crossAxis, c = void 0 !== s && s, l = e.limiter, u = void 0 === l ? {
                                    fn: function(e) {
                                        return {
                                            x: e.x,
                                            y: e.y
                                        }
                                    }
                                } : l, d = Ce(e, ["mainAxis", "crossAxis", "limiter"]), h = {
                                    x: n,
                                    y: i
                                }, [4, Oe(t, d)];
                            case 1:
                                return f = L.sent(), p = Te(Le(o)), y = Ge(p), g = h[p], _ = h[y], r && (b = "y" === p ? "bottom" : "right", k = g + f["y" === p ? "top" : "left"], S = g - f[b], g = Ne(k, g, S)), c && (w = "y" === y ? "bottom" : "right", C = _ + f["y" === y ? "top" : "left"], E = _ - f[w], _ = Ne(C, _, E)), x = u.fn(ce(m({}, t), (v(I = {}, p, g), v(I, y, _), I))), [2, ce(m({}, x), {
                                    data: {
                                        x: x.x - n,
                                        y: x.y - i
                                    }
                                })]
                        }
                    }))
                }))()
            }
        }
    };

    function $e(e) {
        var t;
        return (null == (t = e.ownerDocument) ? void 0 : t.defaultView) || window
    }

    function et(e) {
        return $e(e).getComputedStyle(e)
    }

    function tt(e) {
        return e instanceof $e(e).Node
    }

    function nt(e) {
        return tt(e) ? (e.nodeName || "").toLowerCase() : ""
    }

    function it() {
        if (Ze) return Ze;
        var e = navigator.userAgentData;
        return e && Array.isArray(e.brands) ? Ze = e.brands.map((function(e) {
            return e.brand + "/" + e.version
        })).join(" ") : navigator.userAgent
    }

    function ot(e) {
        return e instanceof $e(e).HTMLElement
    }

    function at(e) {
        return e instanceof $e(e).Element
    }

    function rt(e) {
        return "undefined" != typeof ShadowRoot && (e instanceof $e(e).ShadowRoot || e instanceof ShadowRoot)
    }

    function st(e) {
        var t = et(e),
            n = t.overflow,
            i = t.overflowX,
            o = t.overflowY,
            a = t.display;
        return /auto|scroll|overlay|hidden|clip/.test(n + o + i) && !["inline", "contents"].includes(a)
    }

    function ct(e) {
        return ["table", "td", "th"].includes(nt(e))
    }

    function lt(e) {
        var t = /firefox/i.test(it()),
            n = et(e),
            i = n.backdropFilter || n.WebkitBackdropFilter;
        return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || t && "filter" === n.willChange || t && !!n.filter && "none" !== n.filter || ["transform", "perspective"].some((function(e) {
            return n.willChange.includes(e)
        })) || ["paint", "layout", "strict", "content"].some((function(e) {
            var t = n.contain;
            return null != t && t.includes(e)
        }))
    }

    function ut() {
        return /^((?!chrome|android).)*safari/i.test(it())
    }

    function dt(e) {
        return ["html", "body", "#document"].includes(nt(e))
    }
    var ht = Math.min,
        ft = Math.max,
        pt = Math.round;

    function vt(e) {
        var t = et(e),
            n = parseFloat(t.width),
            i = parseFloat(t.height),
            o = ot(e),
            a = o ? e.offsetWidth : n,
            r = o ? e.offsetHeight : i,
            s = pt(n) !== a || pt(i) !== r;
        return s && (n = a, i = r), {
            width: n,
            height: i,
            fallback: s
        }
    }

    function mt(e) {
        return at(e) ? e : e.contextElement
    }
    var yt = {
        x: 1,
        y: 1
    };

    function gt(e) {
        var t = mt(e);
        if (!ot(t)) return yt;
        var n = t.getBoundingClientRect(),
            i = vt(t),
            o = i.width,
            a = i.height,
            r = i.fallback,
            s = (r ? pt(n.width) : n.width) / o,
            c = (r ? pt(n.height) : n.height) / a;
        return s && Number.isFinite(s) || (s = 1), c && Number.isFinite(c) || (c = 1), {
            x: s,
            y: c
        }
    }

    function _t(e, t, n, i) {
        var o, a;
        void 0 === t && (t = !1), void 0 === n && (n = !1);
        var r = e.getBoundingClientRect(),
            s = mt(e),
            c = yt;
        t && (i ? at(i) && (c = gt(i)) : c = gt(e));
        var l = s ? $e(s) : window,
            u = ut() && n,
            d = (r.left + (u && (null == (o = l.visualViewport) ? void 0 : o.offsetLeft) || 0)) / c.x,
            h = (r.top + (u && (null == (a = l.visualViewport) ? void 0 : a.offsetTop) || 0)) / c.y,
            f = r.width / c.x,
            p = r.height / c.y;
        if (s)
            for (var v = $e(s), m = i && at(i) ? $e(i) : i, y = v.frameElement; y && i && m !== v;) {
                var g = gt(y),
                    _ = y.getBoundingClientRect(),
                    b = getComputedStyle(y);
                _.x += (y.clientLeft + parseFloat(b.paddingLeft)) * g.x, _.y += (y.clientTop + parseFloat(b.paddingTop)) * g.y, d *= g.x, h *= g.y, f *= g.x, p *= g.y, d += _.x, h += _.y, y = $e(y).frameElement
            }
        return De({
            width: f,
            height: p,
            x: d,
            y: h
        })
    }

    function bt(e) {
        return ((tt(e) ? e.ownerDocument : e.document) || window.document).documentElement
    }

    function kt(e) {
        return at(e) ? {
            scrollLeft: e.scrollLeft,
            scrollTop: e.scrollTop
        } : {
            scrollLeft: e.pageXOffset,
            scrollTop: e.pageYOffset
        }
    }

    function St(e) {
        return _t(bt(e)).left + kt(e).scrollLeft
    }

    function wt(e) {
        if ("html" === nt(e)) return e;
        var t = e.assignedSlot || e.parentNode || rt(e) && e.host || bt(e);
        return rt(t) ? t.host : t
    }

    function Ct(e) {
        var t = wt(e);
        return dt(t) ? t.ownerDocument.body : ot(t) && st(t) ? t : Ct(t)
    }

    function Et(e, t) {
        var n;
        void 0 === t && (t = []);
        var i = Ct(e),
            o = i === (null == (n = e.ownerDocument) ? void 0 : n.body),
            a = $e(i);
        return o ? t.concat(a, a.visualViewport || [], st(i) ? i : []) : t.concat(i, Et(i))
    }

    function It(e, t, n) {
        var i;
        if ("viewport" === t) i = function(e, t) {
            var n = $e(e),
                i = bt(e),
                o = n.visualViewport,
                a = i.clientWidth,
                r = i.clientHeight,
                s = 0,
                c = 0;
            if (o) {
                a = o.width, r = o.height;
                var l = ut();
                (!l || l && "fixed" === t) && (s = o.offsetLeft, c = o.offsetTop)
            }
            return {
                width: a,
                height: r,
                x: s,
                y: c
            }
        }(e, n);
        else if ("document" === t) i = function(e) {
            var t = bt(e),
                n = kt(e),
                i = e.ownerDocument.body,
                o = ft(t.scrollWidth, t.clientWidth, i.scrollWidth, i.clientWidth),
                a = ft(t.scrollHeight, t.clientHeight, i.scrollHeight, i.clientHeight),
                r = -n.scrollLeft + St(e),
                s = -n.scrollTop;
            return "rtl" === et(i).direction && (r += ft(t.clientWidth, i.clientWidth) - o), {
                width: o,
                height: a,
                x: r,
                y: s
            }
        }(bt(e));
        else if (at(t)) i = function(e, t) {
            var n = _t(e, !0, "fixed" === t),
                i = n.top + e.clientTop,
                o = n.left + e.clientLeft,
                a = ot(e) ? gt(e) : {
                    x: 1,
                    y: 1
                };
            return {
                width: e.clientWidth * a.x,
                height: e.clientHeight * a.y,
                x: o * a.x,
                y: i * a.y
            }
        }(t, n);
        else {
            var o = m({}, t);
            if (ut()) {
                var a, r, s = $e(e);
                o.x -= (null == (a = s.visualViewport) ? void 0 : a.offsetLeft) || 0, o.y -= (null == (r = s.visualViewport) ? void 0 : r.offsetTop) || 0
            }
            i = o
        }
        return De(i)
    }

    function xt(e, t) {
        var n = wt(e);
        return !(n === t || !at(n) || dt(n)) && ("fixed" === et(n).position || xt(n, t))
    }

    function Lt(e, t) {
        return ot(e) && "fixed" !== et(e).position ? t ? t(e) : e.offsetParent : null
    }

    function Tt(e, t) {
        var n = $e(e);
        if (!ot(e)) return n;
        for (var i = Lt(e, t); i && ct(i) && "static" === et(i).position;) i = Lt(i, t);
        return i && ("html" === nt(i) || "body" === nt(i) && "static" === et(i).position && !lt(i)) ? n : i || function(e) {
            for (var t = wt(e); ot(t) && !dt(t);) {
                if (lt(t)) return t;
                t = wt(t)
            }
            return null
        }(e) || n
    }

    function Mt(e, t, n) {
        var i = ot(t),
            o = bt(t),
            a = _t(e, !0, "fixed" === n, t),
            r = {
                scrollLeft: 0,
                scrollTop: 0
            },
            s = {
                x: 0,
                y: 0
            };
        if (i || !i && "fixed" !== n)
            if (("body" !== nt(t) || st(o)) && (r = kt(t)), ot(t)) {
                var c = _t(t, !0);
                s.x = c.x + t.clientLeft, s.y = c.y + t.clientTop
            } else o && (s.x = St(o));
        return {
            x: a.left + r.scrollLeft - s.x,
            y: a.top + r.scrollTop - s.y,
            width: a.width,
            height: a.height
        }
    }
    var At = {
        getClippingRect: function(e) {
            var t = e.element,
                n = e.boundary,
                i = e.rootBoundary,
                o = e.strategy,
                a = S("clippingAncestors" === n ? function(e, t) {
                    var n = t.get(e);
                    if (n) return n;
                    for (var i = Et(e).filter((function(e) {
                            return at(e) && "body" !== nt(e)
                        })), o = null, a = "fixed" === et(e).position, r = a ? wt(e) : e; at(r) && !dt(r);) {
                        var s = et(r),
                            c = lt(r);
                        c || "fixed" !== s.position || (o = null), (a ? !c && !o : !c && "static" === s.position && o && ["absolute", "fixed"].includes(o.position) || st(r) && !c && xt(e, r)) ? i = i.filter((function(e) {
                            return e !== r
                        })) : o = s, r = wt(r)
                    }
                    return t.set(e, i), i
                }(t, this._c) : [].concat(n)).concat([i]),
                r = a[0],
                s = a.reduce((function(e, n) {
                    var i = It(t, n, o);
                    return e.top = ft(i.top, e.top), e.right = ht(i.right, e.right), e.bottom = ht(i.bottom, e.bottom), e.left = ft(i.left, e.left), e
                }), It(t, r, o));
            return {
                width: s.right - s.left,
                height: s.bottom - s.top,
                x: s.left,
                y: s.top
            }
        },
        convertOffsetParentRelativeRectToViewportRelativeRect: function(e) {
            var t = e.rect,
                n = e.offsetParent,
                i = e.strategy,
                o = ot(n),
                a = bt(n);
            if (n === a) return t;
            var r = {
                    scrollLeft: 0,
                    scrollTop: 0
                },
                s = {
                    x: 1,
                    y: 1
                },
                c = {
                    x: 0,
                    y: 0
                };
            if ((o || !o && "fixed" !== i) && (("body" !== nt(n) || st(a)) && (r = kt(n)), ot(n))) {
                var l = _t(n);
                s = gt(n), c.x = l.x + n.clientLeft, c.y = l.y + n.clientTop
            }
            return {
                width: t.width * s.x,
                height: t.height * s.y,
                x: t.x * s.x - r.scrollLeft * s.x + c.x,
                y: t.y * s.y - r.scrollTop * s.y + c.y
            }
        },
        isElement: at,
        getDimensions: function(e) {
            return vt(e)
        },
        getOffsetParent: Tt,
        getDocumentElement: bt,
        getScale: gt,
        getElementRects: function(e) {
            return Se((function() {
                var t, n, i, o, a, r, s, c;
                return Ee(this, (function(l) {
                    switch (l.label) {
                        case 0:
                            return t = e.reference, n = e.floating, i = e.strategy, o = this.getOffsetParent || Tt, a = this.getDimensions, r = {}, s = [t], [4, o(n)];
                        case 1:
                            return r.reference = Mt.apply(void 0, s.concat([l.sent(), i])), c = [{
                                x: 0,
                                y: 0
                            }], [4, a(n)];
                        case 2:
                            return [2, (r.floating = m.apply(void 0, c.concat([l.sent()])), r)]
                    }
                }))
            })).apply(this)
        },
        getClientRects: function(e) {
            return Array.from(e.getClientRects())
        },
        isRTL: function(e) {
            return "rtl" === et(e).direction
        }
    };

    function Pt(e, t, n, i) {
        void 0 === i && (i = {});
        var o = i.ancestorScroll,
            a = void 0 === o || o,
            r = i.ancestorResize,
            s = void 0 === r || r,
            c = i.elementResize,
            l = void 0 === c || c,
            u = i.animationFrame,
            d = void 0 !== u && u,
            h = a || s ? S(at(e) ? Et(e) : e.contextElement ? Et(e.contextElement) : []).concat(S(Et(t))) : [];
        h.forEach((function(e) {
            var t = !at(e) && e.toString().includes("V");
            !a || d && !t || e.addEventListener("scroll", n, {
                passive: !0
            }), s && e.addEventListener("resize", n)
        }));
        var f, p = null;
        l && (p = new ResizeObserver((function() {
            n()
        })), at(e) && !d && p.observe(e), at(e) || !e.contextElement || d || p.observe(e.contextElement), p.observe(t));
        var v = d ? _t(e) : null;
        return d && function t() {
                var i = _t(e);
                !v || i.x === v.x && i.y === v.y && i.width === v.width && i.height === v.height || n();
                v = i, f = requestAnimationFrame(t)
            }(), n(),
            function() {
                var e;
                h.forEach((function(e) {
                    a && e.removeEventListener("scroll", n), s && e.removeEventListener("resize", n)
                })), null == (e = p) || e.disconnect(), p = null, d && cancelAnimationFrame(f)
            }
    }
    var Bt = function(e, t, n) {
            var i = new Map,
                o = m({
                    platform: At
                }, n),
                a = ce(m({}, o.platform), {
                    _c: i
                });
            return Pe(e, t, ce(m({}, o), {
                platform: a
            }))
        },
        Dt = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                h(this, n), v(E(e = t.call(this)), "_handleScroll", (function() {
                    "tooltip" === e._type && (e.hide(), U(window, "wheel", e._handleScroll))
                })), v(E(e), "_handleBlockSelect", (function(t) {
                    e.dataset.sectionId === t.detail.sectionId && (e.element.querySelector('[block-id="'.concat(t.detail.blockId, '"]')) && e._btn ? e._btn.trigger() : e.hide())
                })), v(E(e), "_handleBlockDeselect", (function(t) {
                    if (e.dataset.sectionId === t.detail.sectionId) {
                        if (!e.element.querySelector('[block-id="'.concat(t.detail.blockId, '"]'))) return;
                        e.hide()
                    }
                })), v(E(e), "init", (function() {
                    var t = document.querySelector("#".concat(e.dataset.floatingElementId)) || e._btn;
                    t && Pt(t, E(e), (function() {
                        Bt(t, e, e._getOptions()).then((function(t) {
                            e._updatePosition(t), e._arrow && e._updateArrow(t)
                        }))
                    }))
                })), v(E(e), "show", (function() {
                    "tooltip" === e._type && C.isScrolling || (e._mount(), e.playVideos(), e._setVisible(!0), e.emit("show", {}), K(window, "wheel", e._handleScroll))
                })), v(E(e), "hide", (function() {
                    e._setVisible(!1), e.pauseVideos(), e._unmount(), e.emit("hide", {})
                })), e._withOverlay = e.hasAttribute("data-with-overlay");
                var i, o, a, r = e.querySelector("template");
                return e.element = pe(r), e._arrow = e.element.querySelector("[data-float-element-arrow]"), "fixed" === e._strategy && (i = E(e), (a = document.getElementById("Portal")).appendChild(i), (o && o.appendChild ? o : document.body).appendChild(a)), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.init(), this._isEditorMode && (this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect), this._editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._unmount(), this._isEditorMode && this._editor.destroy(), U(window, "wheel", this._handleScroll)
                }
            }, {
                key: "_updatePosition",
                value: function(e) {
                    var t = e.x,
                        n = e.y;
                    Object.assign(this.style, {
                        left: "".concat(t, "px"),
                        top: "".concat(n, "px")
                    })
                }
            }, {
                key: "_getOptions",
                value: function() {
                    return {
                        placement: this._placement,
                        middleware: this._getMiddleware(),
                        strategy: this._strategy
                    }
                }
            }, {
                key: "_getMiddleware",
                value: function() {
                    var e = this.dataset.alignmentAxisOffset || 0,
                        t = this.dataset.mainAxisOffset || 0,
                        n = [Qe({
                            alignmentAxis: +e,
                            mainAxis: +t
                        }), Ye(), Je()];
                    return this._arrow && n.push(He({
                        element: this._arrow
                    })), n
                }
            }, {
                key: "checkCursorOutside",
                value: function(e, t) {
                    var n = +(this.dataset.mainAxisOffset || 0),
                        i = this.getBoundingClientRect(),
                        o = i.top - (t + n) > 2,
                        a = t - i.bottom - n > 2,
                        r = i.left - (e + n) > 2,
                        s = e - i.right - n > 2;
                    return o || a || r || s
                }
            }, {
                key: "_updateArrow",
                value: function(e) {
                    var t = e.placement,
                        n = e.middlewareData;
                    if (this._arrow) {
                        var i = n.arrow,
                            o = i.x,
                            a = i.y,
                            r = {
                                top: "bottom",
                                right: "left",
                                bottom: "top",
                                left: "right"
                            }[t.split("-")[0]];
                        Object.assign(this._arrow.style, v({
                            left: null != o ? "".concat(o, "px") : "",
                            top: null != a ? "".concat(a, "px") : "",
                            right: "",
                            bottom: ""
                        }, r, "-5px"))
                    }
                }
            }, {
                key: "_mount",
                value: function() {
                    this.contains(this.element) || this.appendChild(this.element)
                }
            }, {
                key: "_unmount",
                value: function() {
                    this.isOpen && this._withOverlay && C.hideOverlay(this.id), this.element && this.element.remove()
                }
            }, {
                key: "playVideos",
                value: function() {
                    S(this.element.querySelectorAll("video")).forEach((function(e) {
                        e.play()
                    }))
                }
            }, {
                key: "pauseVideos",
                value: function() {
                    S(this.element.querySelectorAll("video")).forEach((function(e) {
                        e.pause()
                    }))
                }
            }, {
                key: "_setVisible",
                value: function(e) {
                    if (this.setAttribute("aria-hidden", e ? "false" : "true"), this._btn && this._btn.setExpand(e), this._withOverlay) {
                        var t = {
                            backdropFilter: this.hasAttribute("data-overlay-with-blur") ? "blur(16.5px)" : "none"
                        };
                        this.isOpen ? C.showOverlay(this.id, t) : C.hideOverlay(this.id)
                    }
                }
            }, {
                key: "_btn",
                get: function() {
                    return document.querySelector('[data-float-element-id="'.concat(this.id, '"], [data-tooltip-id="').concat(this.id, '"]'))
                }
            }, {
                key: "isOpen",
                get: function() {
                    return "false" === this.getAttribute("aria-hidden")
                }
            }, {
                key: "_strategy",
                get: function() {
                    return this.dataset.strategy || "absolute"
                }
            }, {
                key: "_type",
                get: function() {
                    return this.dataset.type
                }
            }, {
                key: "_placement",
                get: function() {
                    return this.dataset.placement || "bottom-end"
                }
            }]), n
        }(ee),
        Ot = Dt;

    function qt(e) {
        if (Array.isArray(e)) return e
    }

    function Rt() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
    }

    function Ft(e, t) {
        return qt(e) || _(e) || k(e, t) || Rt()
    }
    var Nt = "http://www.w3.org/2000/svg",
        Ht = function(e, t) {
            return !(!e || !t) && e.contains(t)
        },
        Vt = function(e, t) {
            var n, i, o = /apple/i.test(navigator.vendor),
                a = document.defaultView || window,
                r = document.createElementNS(Nt, "svg");
            Object.assign(r.style, {
                position: "fixed",
                left: "".concat(o && (null === (n = a.visualViewport) || void 0 === n ? void 0 : n.offsetLeft) || 0, "px"),
                top: "".concat(o && (null === (i = a.visualViewport) || void 0 === i ? void 0 : i.offsetTop) || 0, "px"),
                width: "100%",
                height: "100%",
                pointerEvents: "none",
                zIndex: 2147483647
            }), r.setAttribute("data-type", t ? "rect" : "triangle");
            var s = document.createElementNS(Nt, "polygon");
            return s.setAttribute("points", e.map((function(e) {
                var t = Ft(e, 2),
                    n = t[0],
                    i = t[1];
                return "".concat(n, ",").concat(i)
            })).join(" ")), Object.assign(s.style, {
                pointerEvents: "auto",
                fill: "transparent",
                opacity: 0
            }), r.appendChild(s), r
        },
        zt = function(e) {
            e.current && (e.current.remove(), e.current = null)
        },
        Kt = function() {
            var e, t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                n = t.restMs,
                i = void 0 === n ? 0 : n,
                o = t.buffer,
                a = void 0 === o ? .5 : o,
                r = t.blockPointerEvents,
                s = void 0 === r || r,
                c = !1,
                l = !1;
            return function(t) {
                var n = t.x,
                    o = t.y,
                    r = t.placement,
                    u = t.elements,
                    d = t.onClose,
                    h = t.polygonRef;
                return function(t) {
                    var f, p = function() {
                        zt(h), clearTimeout(e), d()
                    };
                    if (clearTimeout(e), u.domReference && u.floating && null != r && null != n && null != o) {
                        var v, m = t.clientX,
                            y = t.clientY,
                            g = t.target,
                            _ = "mouseleave" === t.type,
                            b = Ht(u.domReference, g),
                            k = Ht(u.floating, g);
                        if (_ || !b) {
                            if (_ || !(b || c && Ht(h.current, g)))
                                if (!(_ && (v = t.relatedTarget, v && v instanceof(document.defaultView || window).Element) && Ht(u.floating, t.relatedTarget)))
                                    if (!u.floating.querySelector('float-element[aria-hidden="false"]'))
                                        if (k && (l = !0), !k || _ || "rect" === (null === (f = h.current) || void 0 === f ? void 0 : f.dataset.type)) {
                                            var w = u.domReference.getBoundingClientRect(),
                                                C = u.floating.getBoundingClientRect(),
                                                E = r.split("-")[0],
                                                I = n > C.right - C.width / 2,
                                                x = o > C.bottom - C.height / 2;
                                            if ("top" === E && o >= w.bottom - 1 || "bottom" === E && o <= w.top + 1 || "left" === E && n >= w.right - 1 || "right" === E && n <= w.left + 1) return p();
                                            var L = [];
                                            switch (E) {
                                                case "top":
                                                    L = [
                                                        [C.left, w.top + 1],
                                                        [C.left, C.bottom - 1],
                                                        [C.right, C.bottom - 1],
                                                        [C.right, w.top + 1]
                                                    ], c = m >= C.left && m <= C.right && y >= C.top && y <= w.top + 1;
                                                    break;
                                                case "bottom":
                                                    L = [
                                                        [C.left, C.top + 1],
                                                        [C.left, w.bottom - 1],
                                                        [C.right, w.bottom - 1],
                                                        [C.right, C.top + 1]
                                                    ], c = m >= C.left && m <= C.right && y >= w.bottom - 1 && y <= C.bottom;
                                                    break;
                                                case "left":
                                                    L = [
                                                        [C.right - 1, C.bottom],
                                                        [C.right - 1, C.top],
                                                        [w.left + 1, C.top],
                                                        [w.left + 1, C.bottom]
                                                    ], c = m >= C.left && m <= w.left + 1 && y >= C.top && y <= C.bottom;
                                                    break;
                                                case "right":
                                                    L = [
                                                        [w.right - 1, C.bottom],
                                                        [w.right - 1, C.top],
                                                        [C.left + 1, C.top],
                                                        [C.left + 1, C.bottom]
                                                    ], c = m >= w.right - 1 && m <= C.right && y >= C.top && y <= C.bottom
                                            }
                                            var T = c ? L : function(e) {
                                                var t = Ft(e, 2),
                                                    n = t[0],
                                                    i = t[1],
                                                    o = C.width > w.width,
                                                    r = C.height > w.height;
                                                switch (E) {
                                                    case "top":
                                                        var s = [o ? n + a / 2 : I ? n + 4 * a : n - 4 * a, i + a + 1],
                                                            c = [o ? n - a / 2 : I ? n + 4 * a : n - 4 * a, i + a + 1],
                                                            l = [
                                                                [C.left, I || o ? C.bottom - a : C.top],
                                                                [C.right, I ? o ? C.bottom - a : C.top : C.bottom - a]
                                                            ];
                                                        return [s, c].concat(S(l));
                                                    case "bottom":
                                                        var u = [o ? n + a / 2 : I ? n + 4 * a : n - 4 * a, i - a],
                                                            d = [o ? n - a / 2 : I ? n + 4 * a : n - 4 * a, i - a],
                                                            h = [
                                                                [C.left, I || o ? C.top + a : C.bottom],
                                                                [C.right, I ? o ? C.top + a : C.bottom : C.top + a]
                                                            ];
                                                        return [u, d].concat(S(h));
                                                    case "left":
                                                        var f = [n + a + 1, r ? i + a / 2 : x ? i + 4 * a : i - 4 * a],
                                                            p = [n + a + 1, r ? i - a / 2 : x ? i + 4 * a : i - 4 * a];
                                                        return S([
                                                            [x || r ? C.right - a : C.left, C.top],
                                                            [x ? r ? C.right - a : C.left : C.right - a, C.bottom]
                                                        ]).concat([f, p]);
                                                    case "right":
                                                        var v = [n - a, r ? i + a / 2 : x ? i + 4 * a : i - 4 * a],
                                                            m = [n - a, r ? i - a / 2 : x ? i + 4 * a : i - 4 * a],
                                                            y = [
                                                                [x || r ? C.left + a : C.right, C.top],
                                                                [x ? r ? C.left + a : C.right : C.left + a, C.bottom]
                                                            ];
                                                        return [v, m].concat(S(y))
                                                }
                                            }([n, o]);
                                            !h.current && s && _ && (h.current = Vt(T, c), document.body.appendChild(h.current)), c || (! function(e, t) {
                                                for (var n = Ft(e, 2), i = n[0], o = n[1], a = !1, r = t.length, s = 0, c = r - 1; s < r; c = s++) {
                                                    var l = Ft(t[s] || [0, 0], 2),
                                                        u = l[0],
                                                        d = l[1],
                                                        h = Ft(t[c] || [0, 0], 2),
                                                        f = h[0],
                                                        p = h[1];
                                                    d >= o != p >= o && i <= (f - u) * (o - d) / (p - d) + u && (a = !a)
                                                }
                                                return a
                                            }([m, y], T) ? p() : i && !l && (e = setTimeout(d, i)))
                                        } else zt(h)
                        } else zt(h)
                    }
                }
            }
        },
        Ut = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleBlur", (function() {
                    e.blurElementTimeoutId = setTimeout((function() {
                        e._floatElement && e._floatElement.hide()
                    }), 0)
                })), v(E(e), "_handleFocus", (function() {
                    e._floatElement.show(), e.setTargetListeners("add")
                })), v(E(e), "_handleFirstTargetFocus", (function() {
                    clearTimeout(e.blurElementTimeoutId)
                })), v(E(e), "_handleTargetFocus", (function() {
                    clearTimeout(e.blurLastTargetTimeoutId)
                })), v(E(e), "_handleLastTargetBlur", (function() {
                    e.blurLastTargetTimeoutId = setTimeout((function() {
                        e.setTargetListeners("remove"), e._floatElement.hide()
                    }), 0)
                })), v(E(e), "_handleMouseEnter", (function() {
                    e.mouseenterTimeout = setTimeout((function() {
                        e.trigger()
                    }), 0)
                })), v(E(e), "_handleElementClick", (function() {
                    e.trigger()
                })), v(E(e), "_handleWindowClick", (function(t) {
                    var n = e._floatElement.checkCursorOutside(t.clientX, t.clientX),
                        i = e._isTargetOutsideFloatElements(t.target);
                    n && i && (U(window, "click", e._handleWindowClick), e._floatElement.hide())
                })), v(E(e), "_handleMouseLeave", (function(t) {
                    clearTimeout(e.mouseenterTimeout), e.safePolygonFn && window.removeEventListener("mousemove", e._handleMouseMove), e.safePolygonFn = Kt()({
                        x: t.clientX,
                        y: t.clientY,
                        placement: e._floatElement.dataset.placement,
                        onClose: function() {
                            window.removeEventListener("mousemove", e._handleMouseMove), e._floatElement && e._floatElement.hide(), zt(e.polygonRef)
                        },
                        elements: {
                            domReference: e.element,
                            floating: e._floatElement
                        },
                        polygonRef: e.polygonRef
                    }), e.safePolygonFn(t), window.addEventListener("mousemove", e._handleMouseMove)
                })), v(E(e), "_handleMouseMove", (function(t) {
                    e.safePolygonFn(t)
                })), v(E(e), "trigger", (function() {
                    "click" === e._trigger ? (e._floatElement.isOpen ? e._floatElement.hide() : e._floatElement.show(), K(window, "click", e._handleWindowClick)) : (e._floatElement.show(), K(e.element, "mouseleave", e._handleMouseLeave))
                })), e._trigger = "click" === e.dataset.trigger ? "click" : "mouseenter", e.element = e.getElement(), e.polygonRef = {
                    current: null
                }, e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this.element, "focus", this._handleFocus), K(this.element, "blur", this._handleBlur), "click" === this.dataset.trigger ? (K(window, "click", this._handleWindowClick), K(this.element, "click", this._handleElementClick)) : (K(this.element, "mouseleave", this._handleMouseLeave), K(this.element, "mouseenter", this._handleMouseEnter))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this.element, "focus", this._handleFocus), U(this.element, "blur", this._handleBlur), "click" === this.dataset.trigger ? (U(window, "click", this._handleWindowClick), U(this.element, "click", this._handleElementClick)) : (U(this.element, "mouseleave", this._handleMouseLeave), U(this.element, "mouseenter", this._handleMouseEnter))
                }
            }, {
                key: "setTargetListeners",
                value: function(e) {
                    var t = this,
                        n = this.getTargets(),
                        i = n.targets,
                        o = n.firstTarget,
                        a = n.lastTarget,
                        r = "add" === e ? K : U;
                    r(o, "focus", this._handleFirstTargetFocus), i.forEach((function(e) {
                        r(e, "focus", t._handleTargetFocus)
                    })), r(a, "blur", this._handleLastTargetBlur), r(window, "click", this._handleWindowClick)
                }
            }, {
                key: "getElement",
                value: function() {
                    var e = '[data-float-element-trigger="'.concat(this.dataset.floatElementId, '"]');
                    return this.querySelector(e) || this
                }
            }, {
                key: "getTargets",
                value: function() {
                    var e = S(this._floatElement.element.querySelectorAll(Y()));
                    return {
                        targets: e,
                        firstTarget: e[0],
                        lastTarget: e[e.length - 1]
                    }
                }
            }, {
                key: "_isTargetOutsideFloatElements",
                value: function(e) {
                    var t = this._floatElement.contains(e),
                        n = this.contains(e);
                    return !t && !n
                }
            }, {
                key: "setExpand",
                value: function(e) {
                    this.setAttribute("data-aria-expanded", e)
                }
            }, {
                key: "_floatElement",
                get: function() {
                    if (this.dataset.floatElementId) return document.getElementById(this.dataset.floatElementId)
                }
            }, {
                key: "isOpen",
                get: function() {
                    return this._floatElement.isOpen
                }
            }]), n
        }(ee),
        Wt = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleBlur", (function() {
                    var t = e.getTargets().targets;
                    e.blurElementTimeoutId = setTimeout((function() {
                        if (!t.includes(document.activeElement)) {
                            if (!e._floatElement) return;
                            e.setTargetListeners("remove"), e._floatElement.hide()
                        }
                    }), 0)
                })), v(E(e), "_handleDropdownShow", (function() {
                    K(window, "keydown", e._handleDropdownKeyDown)
                })), v(E(e), "_handleDropdownHide", (function() {
                    U(window, "keydown", e._handleDropdownKeyDown)
                })), v(E(e), "_handleKeyUp", (function(t) {
                    if (e._floatElement) {
                        var n = t.key || t.keyCode;
                        Q(n) && (e._floatElement.isOpen || (e._floatElement.show(), e.setTargetListeners("add")))
                    }
                })), v(E(e), "_handleDropdownKeyDown", (function(t) {
                    if (e._floatElement) {
                        var n = t.key || t.keyCode,
                            i = n === H.ESCAPE_STRING_KEY || n === H.ESCAPE_NUMBER_KEY;
                        e._floatElement.isOpen && i && (e.element.focus(), e.setTargetListeners("remove"), e._floatElement.hide())
                    }
                })), v(E(e), "_handleFirstTargetFocus", (function() {
                    clearTimeout(e.blurElementTimeoutId)
                })), v(E(e), "_handleTargetFocus", (function() {
                    clearTimeout(e.blurLastTargetTimeoutId)
                })), v(E(e), "_handleLastTargetBlur", (function() {
                    e.blurLastTargetTimeoutId = setTimeout((function() {
                        e._floatElement && (e.setTargetListeners("remove"), e._floatElement.hide())
                    }), 0)
                })), v(E(e), "_handleTrigger", (function() {
                    e.trigger()
                })), v(E(e), "_handleUntrigger", (function(t) {
                    var n = t.clientX,
                        i = t.clientY,
                        o = t.target;
                    if (e._floatElement) {
                        var a = e._floatElement.checkCursorOutside(n, i),
                            r = e._isTargetOutsideFloatElements(o);
                        a && r && (e._floatElement.hide(), U(window, "click", e._handleUntrigger))
                    }
                })), v(E(e), "trigger", (function() {
                    e._floatElement && (e._floatElement.isOpen ? e._floatElement.hide() : e._floatElement.show(), K(window, "click", e._handleUntrigger))
                })), e.element = e.getElement(), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._floatElement && (customElements.upgrade(this._floatElement), this._floatElement.subscribe("show", this._handleDropdownShow), this._floatElement.subscribe("hide", this._handleDropdownHide)), K(this.element, "blur", this._handleBlur), K(this.element, "keyup", this._handleKeyUp), K(this.element, "mousedown", this._handleTrigger)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._floatElement && (this._floatElement.unsubscribe("show", this._handleDropdownShow), this._floatElement.unsubscribe("hide", this._handleDropdownHide)), U(this.element, "blur", this._handleBlur), U(this.element, "keyup", this._handleKeyUp), U(this.element, "mousedown", this._handleTrigger), U(window, "click", this._handleUntrigger)
                }
            }, {
                key: "setTargetListeners",
                value: function(e) {
                    var t = this,
                        n = this.getTargets(),
                        i = n.targets,
                        o = n.firstTarget,
                        a = n.lastTarget,
                        r = "add" === e ? K : U;
                    r(o, "focus", this._handleFirstTargetFocus), i.forEach((function(e) {
                        r(e, "focus", t._handleTargetFocus)
                    })), r(a, "blur", this._handleLastTargetBlur), r(window, "click", this._handleUntrigger)
                }
            }, {
                key: "getTargets",
                value: function() {
                    if (this._floatElement) {
                        var e = S(this._floatElement.element.querySelectorAll(Y()));
                        return {
                            targets: e,
                            firstTarget: e[0],
                            lastTarget: e[e.length - 1]
                        }
                    }
                }
            }, {
                key: "_isTargetOutsideFloatElements",
                value: function(e) {
                    if (this._floatElement) {
                        var t = this._floatElement.contains(e),
                            n = this.contains(e);
                        return !t && !n
                    }
                }
            }, {
                key: "getElement",
                value: function() {
                    var e = '[data-float-element-trigger="'.concat(this.dataset.floatElementId, '"]');
                    return this.querySelector(e) || this
                }
            }, {
                key: "setExpand",
                value: function(e) {
                    this.setAttribute("data-aria-expanded", e)
                }
            }, {
                key: "_floatElement",
                get: function() {
                    return document.querySelector("#".concat(this.dataset.floatElementId))
                }
            }]), n
        }(ee),
        Yt = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleMouseEnter", (function() {
                    e._floatElement && e._floatElement.show()
                })), v(E(e), "_handleMouseLeave", (function() {
                    e._floatElement && e._floatElement.hide()
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this, "mouseenter", this._handleMouseEnter), K(this, "mouseleave", this._handleMouseLeave)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this, "mouseenter", this._handleMouseEnter), U(this, "mouseleave", this._handleMouseLeave)
                }
            }, {
                key: "setExpand",
                value: function(e) {
                    this.setAttribute("data-aria-expanded", e ? "true" : "false")
                }
            }, {
                key: "_floatElement",
                get: function() {
                    return this.dataset.floatElementId ? document.querySelector("#".concat(this.dataset.floatElementId)) : null
                }
            }]), n
        }(ee),
        jt = Yt,
        Xt = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleContentResize", (function() {
                    e.updateMaxHeight()
                })), v(E(e), "_handleBlockSelect", (function(t) {
                    var n = t.detail,
                        i = n.sectionId,
                        o = n.blockId,
                        a = n.load,
                        r = e.querySelector(e._contentWrapperSelector),
                        s = e.dataset.sectionId === i,
                        c = e.dataset.blockId === o;
                    s && c && !e.isExpanded && (ve(r, a), ve(E(e), a), e.show().then((function() {
                        ve(r, !1), ve(E(e), !1)
                    })))
                })), v(E(e), "_handleBlockDeselect", (function(t) {
                    var n = t.detail,
                        i = n.sectionId,
                        o = n.blockId;
                    e.dataset.sectionId === i && e.dataset.blockId === o && e.isExpanded && e.hide()
                })), e._contentSelector = "[data-accordeon-content]", e._contentWrapperSelector = "[data-accordeon-content-wrapper]", e._content = e.querySelector(e._contentSelector), e._resizeObserver = new ResizeObserver(e._handleContentResize), e.styles = getComputedStyle(E(e)), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.updateMaxHeight(), this._content && this._resizeObserver.observe(this._content), this._isEditorMode && (this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect), this._editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._resizeObserver.disconnect(), this._isEditorMode && this._editor.destroy()
                }
            }, {
                key: "hide",
                value: function() {
                    return this._setExpand(!1), V(this._transitionDuration)
                }
            }, {
                key: "show",
                value: function() {
                    return this._setExpand(!0), V(this._transitionDuration)
                }
            }, {
                key: "toggle",
                value: function() {
                    this._setExpand(!this.isExpanded)
                }
            }, {
                key: "updateMaxHeight",
                value: function() {
                    var e = this.closest("accordeon-component"),
                        t = this.querySelector(this._contentSelector),
                        n = this.querySelector(this._contentWrapperSelector);
                    if (e && t && n) {
                        var i = e.isExpanded ? t.offsetHeight : 0;
                        n.style.maxHeight = "".concat(i, "px")
                    }
                }
            }, {
                key: "_setExpand",
                value: function(e) {
                    document.querySelectorAll('.accordion')?.forEach(item => {
                        if(item.hasAttribute("data-aria-expanded")) {
                            item.setAttribute("data-aria-expanded", false);
                            item.querySelector('[data-accordeon-content-wrapper]').style.maxHeight = 0;
                        }
                    })
                    this.setAttribute("data-aria-expanded", e ? "true" : "false"), this.updateMaxHeight()
                }
            }, {
                key: "isExpanded",
                get: function() {
                    return "true" === this.getAttribute("data-aria-expanded")
                }
            }, {
                key: "_contentWrapper",
                get: function() {
                    return this.querySelector(this._contentWrapperSelector)
                }
            }, {
                key: "_transitionDuration",
                get: function() {
                    return 1e3 * parseFloat(this.styles.transitionDuration)
                }
            }]), n
        }(ee),
        Qt = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function(t) {
                    t.preventDefault(), e.update()
                })), v(E(e), "_handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e.update())
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("click", this._handleButtonClick), this.addEventListener("keydown", this._handleKeyDown)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("click", this._handleButtonClick), this.removeEventListener("keydown", this._handleKeyDown)
                }
            }, {
                key: "update",
                value: function() {
                    var e = this.closest("accordeon-component");
                    e && e.toggle()
                }
            }]), n
        }(ee),
        Gt = Qt,
        Zt = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleMouseEnter", (function() {
                    K(e._productCardInner, "mousemove", e._handleMouseMove)
                })), v(E(e), "_handleMouseLeave", (function() {
                    if (e._productCard) {
                        var t = e._productCard.querySelector("[data-main-media]");
                        t && (e._selected && e._reset(), e._setImageVisible(t, !0), U(e._productCardInner, "mousemove", e._handleMouseMove))
                    }
                })), v(E(e), "_handleMouseMove", (function(t) {
                    var n = e._getTabByCoords(t.clientX, t.clientY);
                    if (e._productCard && n) {
                        var i = e._productCard.querySelector("[data-main-media]"),
                            o = e._productCard.querySelector('[data-id="'.concat(n.dataset.id, '"]'));
                        if (!o || !i) return;
                        e._selected && e._reset(), e._setTabSelect(n, !0), e._setImageVisible(o, !0), e._setImageVisible(i, !1), e._selected = {
                            tab: n,
                            img: o
                        }
                    }
                })), e._productCard = e.closest("product-card"), e._productCardInner = e.closest(".product-card__inner"), e._tabs = S(e.querySelectorAll("product-media-tab")), e._selected = null, e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.update(), K(this._productCard, "mouseenter", this._handleMouseEnter), K(this._productCard, "mouseleave", this._handleMouseLeave)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this._productCard, "mouseenter", this._handleMouseEnter), U(this._productCard, "mouseleave", this._handleMouseLeave)
                }
            }, {
                key: "_getTabByCoords",
                value: function(e, t) {
                    return this._tabs.find((function(n) {
                        var i = n.getBoundingClientRect(),
                            o = t < i.y,
                            a = e - i.x < i.width;
                        return o && a
                    }))
                }
            }, {
                key: "update",
                value: function() {
                    this._tabs.forEach((function(e, t) {
                        e.style.display = t + 1 > 5 ? "none" : "flex"
                    }))
                }
            }, {
                key: "_setTabSelect",
                value: function(e, t) {
                    e.classList.toggle("selected", t)
                }
            }, {
                key: "_setImageVisible",
                value: function(e, t) {
                    e.classList.toggle("product-card__img--visible", t)
                }
            }, {
                key: "_reset",
                value: function() {
                    this._selected && (this._selected.img.classList.remove("product-card__img--visible"), this._selected.tab.classList.remove("selected"), this._selected = null)
                }
            }]), n
        }(ee),
        Jt = function() {
            "use strict";

            function e(t) {
                h(this, e), this.element = t
            }
            return p(e, [{
                key: "update",
                value: function(e) {
                    var t, n, i;
                    this.element.innerText = e ? (n = (t = e).slice(0, 1), i = t.slice(1), n.toUpperCase() + i) : ""
                }
            }]), e
        }(),
        $t = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "handleSwatchEnter", (function(t) {
                    if (e._productCard) {
                        var n = t.target,
                            i = n.dataset.variantId,
                            o = e._productCard.querySelector('[data-variant-id="'.concat(i, '"]')),
                            a = n.dataset.color;
                        o && e.mainImage && a && (e.updateLabel(a), e._setImageVisible(o, !0), e._setImageVisible(e.mainImage, !1), e.currentVisibleImage = o)
                    }
                })), v(E(e), "handleSwatchLeave", (function() {
                    e.updateLabel(""), e.currentVisibleImage && e._setImageVisible(e.currentVisibleImage, !1), e.mainImage && e._setImageVisible(e.mainImage, !0)
                })), e.hiddenCountSelector = "[data-color-swatches-hidden-count]", e.labelSelector = "[data-color-swatches-label]", e.itemSelector = "[data-color-swatches-item]", e._hiddenCount = e.querySelector(e.hiddenCountSelector), e._label = e.querySelector(e.labelSelector), e._items = S(e.querySelectorAll(e.itemSelector)), e._productCard = e.closest("product-card"), e._productCard && (e.mainImage = e._productCard.querySelector("[data-main-media]")), e._label && (e._labelComponent = new Jt(e._label)), e._hiddenCountStyles = getComputedStyle(e._hiddenCount), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this;
                    this.update(), this._items.forEach((function(t) {
                        t.addEventListener("mouseenter", e.handleSwatchEnter), t.addEventListener("mouseleave", e.handleSwatchLeave)
                    }))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    var e = this;
                    this._items.forEach((function(t) {
                        t.removeEventListener("mouseenter", e.handleSwatchEnter), t.removeEventListener("mouseleave", e.handleSwatchLeave)
                    }))
                }
            }, {
                key: "update",
                value: function() {
                    this._setSwatchesOffset(), this._setSwatches(), this._updateCount()
                }
            }, {
                key: "_setImageVisible",
                value: function(e, t) {
                    e.classList.toggle("product-card__img--visible", t)
                }
            }, {
                key: "_setSwatchesOffset",
                value: function() {
                    var e = this;
                    this._items.forEach((function(t) {
                        e._setVisible(t, !0), t.dataset.x = "".concat(t.offsetLeft + t.offsetWidth)
                    }))
                }
            }, {
                key: "_setSwatches",
                value: function() {
                    var e = this,
                        t = parseInt(this._hiddenCountStyles.width);
                    this._items.forEach((function(n, i) {
                        var o = +(n.dataset.x || 0) > e.offsetWidth - t,
                            a = i + 1 > +(e.dataset.limit || 0);
                        e._setVisible(n, !(o || a))
                    }))
                }
            }, {
                key: "_updateCount",
                value: function() {
                    if (this._hiddenCount) {
                        var e = this._items.filter((function(e) {
                                return !e.classList.contains("hide")
                            })),
                            t = +(this.dataset.count || 0) - e.length;
                        t > 0 ? (ue(this._hiddenCount), this._hiddenCount.innerText = "".concat(t)) : de(this._hiddenCount)
                    }
                }
            }, {
                key: "updateLabel",
                value: function(e) {
                    this._labelComponent && this._labelComponent.update(e)
                }
            }, {
                key: "_setVisible",
                value: function(e, t) {
                    e.classList.toggle("hide", !t)
                }
            }]), n
        }(ee),
        en = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleKeydown", (function(t) {
                    var n = t.key || t.keyCode;
                    (n === H.ESCAPE_STRING_KEY || n === H.ESCAPE_NUMBER_KEY) && e.hide()
                })), v(E(e), "_handleOutsideClick", (function(t) {
                    var n = document.getElementById("BodyOverlay"),
                        i = parseFloat(he(n, "zIndex")),
                        o = parseFloat(e.styles.zIndex) - 1;
                    t.target === n && i <= o && e.isOpen && e.hide()
                })), e._template = e.querySelector("template"), e.element = pe(e._template), e.styles = getComputedStyle(E(e)), e
            }
            return p(n, [{
                key: "show",
                value: function() {
                    var e = this;
                    this._mount(), this.focus(), setTimeout((function() {
                        e._setOpenState(!0)
                    }), 0), this.isOpen = !0
                }
            }, {
                key: "hide",
                value: function() {
                    var e = this;
                    return this._setOpenState(!1), V(this._transitionDuration).then((function() {
                        e._unmount(), e.isOpen = !1
                    }))
                }
            }, {
                key: "toggle",
                value: function() {
                    this.isOpen ? this.hide() : this.show()
                }
            }, {
                key: "_mount",
                value: function() {
                    this.element && !this.contains(this.element) && this.appendChild(this.element)
                }
            }, {
                key: "_unmount",
                value: function() {
                    this.element && this.element.remove()
                }
            }, {
                key: "_setOpenState",
                value: function(e) {
                    var t = this,
                        n = this.hasAttribute("data-overlay-important"),
                        i = this.getAttribute("data-overlay-opacity") || 50,
                        o = {
                            zIndex: n ? parseFloat(this.styles.zIndex) - 1 : 3,
                            backgroundColor: "var(--gsc-black-color-".concat(i, ")")
                        };
                    e ? C.showOverlay(this.id, o) : V(this._transitionDuration).then((function() {
                        C.hideOverlay(t.id)
                    })), this._setVisible(e), this._setListeners(e ? "add" : "remove"), this.emit(e ? "show" : "hide", {})
                }
            }, {
                key: "_setVisible",
                value: function(e) {
                    this.toggleAttribute("open", e)
                }
            }, {
                key: "_setListeners",
                value: function(e) {
                    var t = this.hasAttribute("data-with-close-on-outside"),
                        n = "".concat(e, "EventListener");
                    t && window[n]("click", this._handleOutsideClick), window[n]("keydown", this._handleKeydown)
                }
            }, {
                key: "_transitionDuration",
                get: function() {
                    return 1e3 * parseFloat(this.styles.transitionDuration) + 1e3 * parseFloat(this.styles.transitionDelay)
                }
            }]), n
        }(ee);

    function tn(e, t) {
        for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = A(e)););
        return e
    }

    function nn(e, t, n) {
        return nn = "undefined" != typeof Reflect && Reflect.get ? Reflect.get : function(e, t, n) {
            var i = tn(e, t);
            if (i) {
                var o = Object.getOwnPropertyDescriptor(i, t);
                return o.get ? o.get.call(n || e) : o.value
            }
        }, nn(e, t, n)
    }

    function on(e, t, n) {
        return nn(e, t, n)
    }
    var an = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), (e = t.call(this)).passwordInput = e.querySelector("[password-modal-input]"), e
            }
            return p(n, [{
                key: "show",
                value: function() {
                    on(A(n.prototype), "show", this).call(this), this.passwordInput && this.passwordInput.focus()
                }
            }]), n
        }(en),
        rn = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                return h(this, n), t.apply(this, arguments)
            }
            return p(n, [{
                key: "showProductFromParsedState",
                value: function(e, t) {
                    var n = e.sections["cart-notification-popup-content"],
                        i = me(n);
                    if (this.element) {
                        var o = i.querySelector("#CartNotificationPopupItem-".concat(t)),
                            a = this.element.querySelector("[data-cart-notification-popup]");
                        a && o && (a.innerHTML = "", a.appendChild(o)), this._updateCartCountInHeader(e), this.show()
                    }
                }
            }, {
                key: "_updateCartCountInHeader",
                value: function(e) {
                    var t = e.sections["cart-count"],
                        n = me(t),
                        i = document.getElementById("CartCount"),
                        o = document.getElementById("StickyCartCount"),
                        a = n.getElementById("CartCount");
                    o && a && (o.innerHTML = a.innerHTML), i && a && (i.innerHTML = a.innerHTML)
                }
            }]), n
        }(en),
        sn = rn,
        cn = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function() {
                    e.showModal(), e.emit("click", {})
                })), v(E(e), "_handleKeyDown", (function(t) {
                    if (Q(t.key || t.keyCode) && e.dataset.modal) {
                        t.preventDefault();
                        var n = document.querySelector(e.dataset.modal);
                        n && n.toggle()
                    }
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("keydown", this._handleKeyDown), this.addEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("keydown", this._handleKeyDown), this.removeEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "showModal",
                value: function() {
                    if (this.dataset.modal) {
                        var e = document.querySelector(this.dataset.modal);
                        e && e.show()
                    }
                }
            }]), n
        }(ee),
        ln = cn,
        un = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                return h(this, n), t.apply(this, arguments)
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    on(A(n.prototype), "connectedCallback", this).call(this), this.focus()
                }
            }]), n
        }(ln),
        dn = un,
        hn = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function() {
                    e.hide()
                })), v(E(e), "_handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e.hide())
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("keydown", this._handleKeyDown), this.addEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("keydown", this._handleKeyDown), this.removeEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "hide",
                value: function() {
                    if (this.dataset.modal) {
                        var e = document.querySelector(this.dataset.modal);
                        e && e.hide()
                    }
                }
            }]), n
        }(ee),
        fn = hn,
        pn = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleButtonClick", (function(e) {
                    e.preventDefault()
                })), v(E(e), "handleButtonMouseDown", (function(t) {
                    t.preventDefault();
                    var n = e.closest("carousel-component"),
                        i = e.closest("carousel-dots");
                    e.isDraggingInCarousel = !(!n && !i), e.isDraggingInCarousel ? (e.setMoveStartPoint(t.clientX, t.clientY), e.toggleAfterDraggingInCarousel = !0) : e.toggle()
                })), v(E(e), "handleButtonMouseMove", (function(t) {
                    if (e.isDraggingInCarousel) {
                        var n = Math.abs(e.startPointX - t.clientX),
                            i = Math.abs(e.startPointY - t.clientY);
                        (n > 24 || i > 24) && (e.toggleAfterDraggingInCarousel = !1)
                    }
                })), v(E(e), "handleButtonMouseUp", (function() {
                    e.isDraggingInCarousel && (e.toggleAfterDraggingInCarousel && e.toggle(), e.isDraggingInCarousel = !1, e.toggleAfterDraggingInCarousel = !1, e.setMoveStartPoint(0, 0))
                })), v(E(e), "_handleButtonFocus", (function() {
                    e.button && e.button.addEventListener("keydown", e.handleKeyDown)
                })), v(E(e), "_handleButtonBlur", (function() {
                    e.button && e.button.removeEventListener("keydown", e.handleKeyDown)
                })), v(E(e), "handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e.toggle())
                })), e.buttonSelector = "[data-sidebar-button]", e.button = e.querySelector(e.buttonSelector), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.button && (this.button.addEventListener("click", this._handleButtonClick), this.button.addEventListener("focus", this._handleButtonFocus), this.button.addEventListener("blur", this._handleButtonBlur), this.button.addEventListener("mousedown", this.handleButtonMouseDown), this.button.addEventListener("mousemove", this.handleButtonMouseMove), this.button.addEventListener("mouseup", this.handleButtonMouseUp))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.button && (this.button.removeEventListener("click", this._handleButtonClick), this.button.removeEventListener("focus", this._handleButtonFocus), this.button.removeEventListener("blur", this._handleButtonBlur), this.button.removeEventListener("mousedown", this.handleButtonMouseDown), this.button.removeEventListener("mousemove", this.handleButtonMouseMove), this.button.removeEventListener("mouseup", this.handleButtonMouseUp))
                }
            }, {
                key: "setMoveStartPoint",
                value: function(e, t) {
                    this.startPointX = e, this.startPointY = t
                }
            }, {
                key: "toggle",
                value: function() {
                    if (this.button) {
                        var e = this.button.dataset.sidebarId || "",
                            t = document.querySelector("#".concat(e));
                        t && (t.toggle(), this.update())
                    }
                }
            }, {
                key: "update",
                value: function() {
                    if (this.button) {
                        var e = this.button.dataset.sidebarId || "",
                            t = document.querySelector("#".concat(e));
                        t && this.button.setAttribute("data-aria-expanded", t.isOpen ? "true" : "false")
                    }
                }
            }]), n
        }(ee),
        vn = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleSectionLoad", (function() {
                    e._isSection || e.withOpenOnInit || e.hide()
                })), v(E(e), "_handleSectionSelect", (function(t) {
                    var n = t.detail.sectionId;
                    e._isSection && e.dataset.sectionId === n && e.open()
                })), v(E(e), "_handleSectionDeselect", (function(t) {
                    var n = t.detail.sectionId;
                    e._isSection && e.dataset.sectionId === n && e.hide()
                })), v(E(e), "_handleOutsideClick", (function(t) {
                    var n = document.getElementById("BodyOverlay"),
                        i = parseFloat(he(n, "zIndex")),
                        o = parseFloat(e.styles.zIndex) - 1;
                    t.target === n && i <= o && e.isOpen && e.hide()
                })), v(E(e), "_handleTouchStart", (function(t) {
                    e._touchStartX = t.targetTouches[0].clientX, e._touchStartY = t.targetTouches[0].clientY
                })), v(E(e), "_handleTouchMove", (function(t) {
                    e._touchEndX = t.targetTouches[0].clientX, e._touchEndY = t.targetTouches[0].clientY
                })), v(E(e), "_handleTouchEnd", (function(t) {
                    var n = Math.abs(e._touchStartX - e._touchEndX),
                        i = Math.abs(e._touchStartY - e._touchEndY);
                    if (!(t.target.closest("[data-carousel-viewport]") || 0 === e._touchEndX || i > 48)) {
                        var o = "right" === e.dataset.openDirection ? e._touchStartX < e._touchEndX : e._touchStartX > e._touchEndX;
                        e.isOpen && n > 96 && o && e.hide(), e.cleanTouchPoints()
                    }
                })), v(E(e), "_handleKeydown", (function(t) {
                    var n = t.key || t.keyCode;
                    e.hasAttribute("data-with-close-on-escape") && (n === H.ESCAPE_STRING_KEY || n === H.ESCAPE_NUMBER_KEY) && e.hide()
                })), e._template = e.querySelector("template"), e.element = pe(e._template), e.buttonSelector = '[data-sidebar-button][data-sidebar-id="'.concat(e.id, '"]'), e.styles = getComputedStyle(E(e)), e.withOpenOnInit && e.open(), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("touchstart", this._handleTouchStart), this.addEventListener("touchmove", this._handleTouchMove), this.addEventListener("touchend", this._handleTouchEnd), this._isEditorMode && (this._editor.subscribe("SECTION_LOAD", this._handleSectionLoad), this._editor.subscribe("SECTION_SELECT", this._handleSectionSelect), this._editor.subscribe("SECTION_DESELECT", this._handleSectionDeselect))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("touchstart", this._handleTouchStart), this.removeEventListener("touchmove", this._handleTouchMove), this.removeEventListener("touchend", this._handleTouchEnd), this._isEditorMode && this._editor.destroy()
                }
            }, {
                key: "cleanTouchPoints",
                value: function() {
                    this._touchStartX = 0, this._touchEndX = 0, this._touchStartY = 0, this._touchEndY = 0
                }
            }, {
                key: "open",
                value: function() {
                    var e = this;
                    if (this.element.id == "FiltersDesktop") {
                        return this.mount(), this.setAttribute("tabindex", "-1"), setTimeout((function() {
                            e._setOpenState(!0)
                        }), 0), V(this._transitionDuration)                        
                    }
                    return this.mount(), this.setAttribute("tabindex", "-1"), this.focus(), setTimeout((function() {
                        e._setOpenState(!0)
                    }), 0), V(this._transitionDuration)
                }
            }, {
                key: "hide",
                value: function(e) {
                    var t = this;
                    const searchInputBar = document.querySelector("suggestion-search-bar")
                    if (searchInputBar) {
                        searchInputBar.inputContainer.blur()
                        searchInputBar.isSidebarOpen = false;
                    }

                    if (this._setOpenState(!1), !e) return V(this._transitionDuration).then((function() {
                        t.unmount()
                    }));
                    this.unmount()
                }
            }, {
                key: "toggle",
                value: function() {
                    this.isOpen ? this.hide() : this.open()
                }
            }, {
                key: "mount",
                value: function() {
                    this.contains(this.element) || this.appendChild(this.element)
                }
            }, {
                key: "unmount",
                value: function() {
                    this.element && this.element.remove()
                }
            }, {
                key: "updateTemplate",
                value: function(e) {
                    this.element.remove(), this.element = pe(e), this.appendChild(this.element)
                }
            }, {
                key: "_setOpenState",
                value: function(e) {
                    var t = this,
                        n = this.hasAttribute("data-with-overlay"),
                        i = document.querySelectorAll(this.buttonSelector);
                    if (this._setVisible(e), this._setListeners(e ? "add" : "remove"), localStorage.setItem("sidebar-".concat(this.id), "".concat(e)), n) {
                        var o = this.hasAttribute("data-overlay-important"),
                            a = this.hasAttribute("data-overlay-with-blur"),
                            r = +(this.getAttribute("data-overlay-opacity") || 50),
                            s = {
                                zIndex: o ? parseFloat(this.styles.zIndex) - 1 : 3,
                                backdropFilter: a ? "blur(16.5px)" : "none",
                                backgroundColor: "var(--gsc-black-color-".concat(r, ")")
                            };
                        e ? C.showOverlay(this.id, s) : V(this._transitionDuration).then((function() {
                            C.hideOverlay(t.id)
                        }))
                    }
                    i.forEach((function(t) {
                        t.setAttribute("data-aria-expanded", e ? "true" : "false")
                    }))
                }
            }, {
                key: "_setVisible",
                value: function(e) {
                    this.setAttribute("data-aria-expanded", e ? "true" : "false")
                }
            }, {
                key: "_setListeners",
                value: function(e) {
                    var t = this.hasAttribute("data-with-close-on-outside"),
                        n = "".concat(e, "EventListener");
                    t && window[n]("click", this._handleOutsideClick), window[n]("keydown", this._handleKeydown)
                }
            }, {
                key: "_isSection",
                get: function() {
                    return this.hasAttribute("data-sidebar-section")
                }
            }, {
                key: "isOpen",
                get: function() {
                    return "true" === this.getAttribute("data-aria-expanded")
                }
            }, {
                key: "withOpenOnInit",
                get: function() {
                    return this.hasAttribute("data-with-open-on-init")
                }
            }, {
                key: "isOpenBeforeSectionChange",
                get: function() {
                    return "true" === localStorage.getItem("sidebar-".concat(this.id))
                }
            }, {
                key: "_transitionDuration",
                get: function() {
                    return 1e3 * parseFloat(this.styles.transitionDuration) + 1e3 * parseFloat(this.styles.transitionDelay)
                }
            }]), n
        }(ee),
        mn = function() {
            return matchMedia("(max-width: 1200px)").matches
        },
        yn = function() {
            return matchMedia("(prefers-reduced-motion: reduce)").matches
        },
        gn = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleInputKeydown", (function(e) {
                    Q(e.key || e.keyCode) && e.preventDefault()
                })), v(E(e), "_handleClick", (function(t) {
                    var n = t.target,
                        i = mn(),
                        o = n === e._searchInput,
                        a = "A" === n.tagName,
                        r = n.closest("[data-sidebar-search-query]");
                    if (e._searchInput && r) {
                        var s = new Event("input", {
                            bubbles: !0
                        });
                        e._searchInput.value = "".concat(r.getAttribute("data-sidebar-search-query")), e._searchInput.dispatchEvent(s), e._searchInput.focus()

                        var suggestionSearchBox = document.querySelector("suggestion-search-bar")
                        if (suggestionSearchBox) {
                            suggestionSearchBox.inputContainer.value = e._searchInput.value
                            suggestionSearchBox.inputContainer.focus() //
                        }
                    }
                    i && o && (e.isInputFocused = !0), !o && e.isInputFocused && (a && t.preventDefault(), e.isInputFocused = !1)
                })), v(E(e), "_handleInputFocus", (function() {
                    mn() && (e.isInputFocused = !0)
                })), v(E(e), "_handleSearchSidebarTouchEnd", (function(t) {
                    var n = t.target,
                        i = Math.abs(e._touchStartX - e._touchEndX),
                        o = Math.abs(e._touchStartY - e._touchEndY),
                        a = i > 12 || o > 12,
                        r = "A" === n.tagName;
                    e.isInputFocused && a && e._searchInput && (r && t.preventDefault(), e._searchInput.blur(), e.isInputFocused = !1), e.cleanTouchPoints()
                })), v(E(e), "_handleContentResultsResize", (function() {
                    e.updateViewport()
                })), v(E(e), "_handleContentScroll", (function() {
//                    if (e.content) {
//                        var t = e.checkContentOverflow(),
//                            n = e.content.scrollTop > 0;
//                        e.toggleAttribute("header-shadow-visible", t && n)
//                    }
                })), e.searchInputSelector = "[data-sidebar-search-input]", e.searchInputComponentSelector = "[data-sidebar-search-input-component]", e.contentSelector = "[data-sidebar-search-content]", e.contentResultsSelector = "[data-sidebar-search-content-results]", e.content = e.element.querySelector(e.contentSelector), e.contentResults = e.element.querySelector(e.contentResultsSelector), e._searchInputComponent = e.element.querySelector(e.searchInputComponentSelector), e._searchInput = e.element.querySelector(e.searchInputSelector), e._resizeObserver = new ResizeObserver(e._handleContentResultsResize), e.defaultStateElement = document, e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    on(A(n.prototype), "connectedCallback", this).call(this), this.content && this.content.addEventListener("scroll", this._handleContentScroll), this.addEventListener("click", this._handleClick), this.addEventListener("touchend", this._handleSearchSidebarTouchEnd), this._searchInput && (this._searchInput.addEventListener("focus", this._handleInputFocus), this._searchInput.addEventListener("keydown", this._handleInputKeydown)), this.contentResults && this._resizeObserver.observe(this.contentResults)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    on(A(n.prototype), "disconnectedCallback", this).call(this), this.content && this.content.removeEventListener("scroll", this._handleContentScroll), this.removeEventListener("click", this._handleClick), this.removeEventListener("touchend", this._handleSearchSidebarTouchEnd), this._searchInput && (this._searchInput.removeEventListener("focus", this._handleInputFocus), this._searchInput.removeEventListener("keydown", this._handleInputKeydown)), this._resizeObserver.disconnect()
                }
            }, {
                key: "updateViewport",
                value: function() {
                    var e = this.checkContentOverflow();
                    this.toggleAttribute("footer-shadow-visible", e)
                }
            }, {
                key: "open",
                value: function() {
                    var e = this;
                    return on(A(n.prototype), "open", this).call(this).then((function() {
                        e._searchInput && !e._isEditorMode && e._searchInput.focus()
                    }))
                }
            }, {
                key: "checkContentOverflow",
                value: function() {
                    return !(!this.contentResults || !this.content) && this.contentResults.offsetHeight > this.content.offsetHeight
                }
            }]), n
        }(vn),
        _n = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), (e = t.call(this)).containers = S(e.querySelectorAll("[recently-viewed-container]")), e.cardLimit = +e.dataset.cardLimit, e.visibleProductCount = 0, e.sectionSettings = JSON.parse(e.dataset.sectionSettings), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.setItems()
                }
            }, {
                key: "setItems",
                value: function() {
                    var e = localStorage.getItem("AuroraTheme-RecentlyProducts"),
                        t = this.createProducts(JSON.parse(e));
                    this.containers.forEach((function(e) {
                        e.innerHTML = t
                    }))
                }
            }, {
                key: "createProducts",
                value: function(e) {
                    var t = this,
                        n = "";
                    return Object.keys(e).reverse().forEach((function(i) {
                        var o = t.prepareTemplate(e[i]),
                            a = t.createNodeByString(o);
                        "center" === t.sectionSettings.product_card_align && a.classList.add("product-card--center-alignment");
                        var r = t._visibleProductCount >= t.cardLimit,
                            s = i === t.dataset.productHandle;
                        r || s || (n = "".concat(n, " ").concat(a.outerHTML), t._visibleProductCount += 1)
                    })), n
                }
            }, {
                key: "prepareTemplate",
                value: function(e) {
                    return e.replaceAll(/shape--square|shape--landscape|shape--portrait-xl|shape--portrait/gi, "shape--".concat(this.sectionSettings.img_ratio))
                }
            }, {
                key: "createNodeByString",
                value: function(e) {
                    return (new DOMParser).parseFromString(e, "text/html").querySelector("[recently-viewed-item]")
                }
            }, {
                key: "setVisible",
                value: function(e) {
                    this.classList.toggle("hidden", !e)
                }
            }, {
                key: "_visibleProductCount",
                get: function() {
                    return this.visibleProductCount
                },
                set: function(e) {
                    var t = e > 0;
                    this.visibleProductCount = e, this.setVisible(t)
                }
            }], [{
                key: "updateProductsInLocalStorage",
                value: function(e, t) {
                    if (e && t) {
                        var n = localStorage.getItem("AuroraTheme-RecentlyProducts"),
                            i = ce(m({}, JSON.parse(n)), v({}, t, e));
                        localStorage.setItem("AuroraTheme-RecentlyProducts", JSON.stringify(i))
                    }
                }
            }]), n
        }(ee),
        bn = window.Shopify,
        kn = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleContentScroll", (function() {
                    var t = !!e.content && e.content.scrollTop > 0;
                    e.toggleAttribute("header-shadow-visible", t)
                })), v(E(e), "openAndRenderProductByUrl", (function(t) {
                    e._cache[t] && e._cache[t].then((function(t) {
                        var i;
                        e._setProductFromHTML(t), e.onThisPageRenderedQuickView && (e.onThisPageRenderedQuickView.innerHTML = ""), e.isOpen || on((E(e), A(n.prototype)), "open", e).call(e), null == bn || null === (i = bn.PaymentButton) || void 0 === i || i.init()
                    }))
                })), e._cache = {}, e
            }
            return p(n, [{
                key: "requestProductFromUrl",
                value: function(e, t) {
                    var n = this;
                    this._resetProduct(), this._cache[e] || (this.onThisPageRenderedQuickView = document.querySelector('.shopify-section [data-quick-view-product-id="'.concat(t, '"]')), this.onThisPageRenderedQuickView && this.onThisPageRenderedQuickView.dataset.quickViewProductUrl === e ? this._cache[e] = V(0).then((function() {
                        return n.onThisPageRenderedQuickView
                    })) : this._cache[e] = fetch(e).then((function(e) {
                        return e.text()
                    })).then((function(e) {
                        return me(e)
                    })))
                }
            }, {
                key: "open",
                value: function() {}
            }, {
                key: "_setProductFromHTML",
                value: function(e) {
                    if (this.dataset.targetId) {
                        var t = e.getElementById(this.dataset.targetId);
                        if (t) {
                            _n.updateProductsInLocalStorage(t.dataset.productString, t.dataset.productHandle);
                            var n = t.getAttribute("class") || "";
                            this.element.setAttribute("class", n), this.element.innerHTML = t.innerHTML, this.content = this.element.querySelector("[data-quick-view-content]"), this.content && this.content.addEventListener("scroll", this._handleContentScroll)
                        }
                    }
                }
            }, {
                key: "_resetProduct",
                value: function() {
                    this.content && (this.content.removeEventListener("scroll", this._handleContentScroll), this.onThisPageRenderedQuickView && (this.onThisPageRenderedQuickView.innerHTML = this.content.innerHTML), this.content = null), this.element.innerHTML = ""
                }
            }]), n
        }(vn);

    function Sn(e) {
        return "number" == typeof e
    }

    function wn(e) {
        return "string" == typeof e
    }

    function Cn(e) {
        return "[object Object]" === Object.prototype.toString.call(e)
    }

    function En(e) {
        return Cn(e) || function(e) {
            return Array.isArray(e)
        }(e)
    }

    function In(e) {
        return Math.abs(e)
    }

    function xn(e) {
        return e ? e / In(e) : 0
    }

    function Ln(e, t) {
        return In(e - t)
    }

    function Tn(e) {
        return Pn(e).map(Number)
    }

    function Mn(e) {
        return e[An(e)]
    }

    function An(e) {
        return Math.max(0, e.length - 1)
    }

    function Pn(e) {
        return Object.keys(e)
    }

    function Bn(e, t) {
        return [e, t].reduce((function(e, t) {
            return Pn(t).forEach((function(n) {
                var i = e[n],
                    o = t[n],
                    a = Cn(i) && Cn(o);
                e[n] = a ? Bn(i, o) : o
            })), e
        }), {})
    }

    function Dn(e, t) {
        var n = Pn(e),
            i = Pn(t);
        return n.length === i.length && n.every((function(n) {
            var i = e[n],
                o = t[n];
            return "function" == typeof i ? "".concat(i) === "".concat(o) : En(i) && En(o) ? Dn(i, o) : i === o
        }))
    }

    function On(e, t) {
        var n = function(e) {
                return t - e
            },
            i = {
                start: function() {
                    return 0
                },
                center: function(e) {
                    return n(e) / 2
                },
                end: n
            };
        return {
            measure: function(n) {
                return Sn(e) ? t * Number(e) : i[e](n)
            }
        }
    }

    function qn(e, t) {
        var n = function(t) {
                return t < e
            },
            i = function(e) {
                return e > t
            },
            o = function(e) {
                return n(e) || i(e)
            },
            a = In(e - t);
        return {
            length: a,
            max: t,
            min: e,
            constrain: function(i) {
                return o(i) ? n(i) ? e : t : i
            },
            reachedAny: o,
            reachedMax: i,
            reachedMin: n,
            removeOffset: function(e) {
                return a ? e - a * Math.ceil((e - t) / a) : e
            }
        }
    }

    function Rn(e, t, n) {
        var i = function(e) {
                return n ? In((l + e) % l) : c(e)
            },
            o = function() {
                return u
            },
            a = function(e) {
                return u = i(e), d
            },
            r = qn(0, e),
            s = r.min,
            c = r.constrain,
            l = e + 1,
            u = i(t),
            d = {
                add: function(e) {
                    return a(o() + e)
                },
                clone: function() {
                    return Rn(e, o(), n)
                },
                get: o,
                set: a,
                min: s,
                max: e
            };
        return d
    }

    function Fn() {
        var e = [],
            t = {
                add: function(n, i, o, a) {
                    return void 0 === a && (a = {
                        passive: !0
                    }), n.addEventListener(i, o, a), e.push((function() {
                        return n.removeEventListener(i, o, a)
                    })), t
                },
                removeAll: function() {
                    return e = e.filter((function(e) {
                        return e()
                    })), t
                }
            };
        return t
    }

    function Nn(e) {
        var t = function(e) {
                return i /= e, o
            },
            n = function(e) {
                return Sn(e) ? e : e.get()
            },
            i = e,
            o = {
                add: function(e) {
                    return i += n(e), o
                },
                divide: t,
                get: function() {
                    return i
                },
                multiply: function(e) {
                    return i *= e, o
                },
                normalize: function() {
                    return 0 !== i && t(i), o
                },
                set: function(e) {
                    return i = n(e), o
                },
                subtract: function(e) {
                    return i -= n(e), o
                }
            };
        return o
    }

    function Hn(e, t, n, i, o, a, r, s, c, l, u, d, h, f, p, v) {
        var m = function(e) {
                if (!((q = !o.isTouchEvent(e)) && 0 !== e.button || (t = e.target, r = t.nodeName || "", k.indexOf(r) > -1))) {
                    var t, r, s = Ln(i.get(), a.get()) >= 2,
                        l = q || !s;
                    B = !0, o.pointerDown(e), w.set(i), i.set(a), c.useBaseMass().useSpeed(80),
                        function() {
                            var e = q ? document : n;
                            E.add(e, "touchmove", y, S).add(e, "touchend", g).add(e, "mousemove", y, S).add(e, "mouseup", g)
                        }(), A = o.readPoint(e), P = o.readPoint(e, b), d.emit("pointerDown"), l && (O = !1)
                }
            },
            y = function(e) {
                if (!D && !q) {
                    if (!e.cancelable) return g(e);
                    var n = o.readPoint(e),
                        a = o.readPoint(e, b),
                        s = Ln(n, A),
                        c = Ln(a, P);
                    if (!(D = s > c) && !O) return g(e)
                }
                var l = o.pointerMove(e);
                !O && l && (O = !0), r.start(), i.add(t.apply(l)), e.preventDefault()
            },
            g = function(e) {
                var n = l.byDistance(0, !1).index !== u.get(),
                    a = o.pointerUp(e) * (p ? L : x)[q ? "mouse" : "touch"],
                    r = function(e, t) {
                        var n = u.clone().add(-1 * xn(e)),
                            i = n.get() === u.min || n.get() === u.max,
                            o = l.byDistance(e, !p).distance;
                        return p || In(e) < I ? o : !f && i ? .4 * o : v && t ? .5 * o : l.byIndex(n.get(), 0).distance
                    }(t.apply(a), n),
                    h = function(e, t) {
                        if (0 === e || 0 === t) return 0;
                        if (In(e) <= In(t)) return 0;
                        var n = Ln(In(e), In(t));
                        return In(n / e)
                    }(a, r),
                    m = Ln(i.get(), w.get()) >= .5,
                    y = n && h > .75,
                    g = In(a) < I,
                    _ = y ? 10 : T,
                    b = y ? M + 2.5 * h : M;
                m && !q && (O = !0), D = !1, B = !1, E.removeAll(), c.useSpeed(g ? 9 : _).useMass(b), s.distance(r, !p), q = !1, d.emit("pointerUp")
            },
            _ = function(e) {
                O && (e.stopPropagation(), e.preventDefault())
            },
            b = e.cross,
            k = ["INPUT", "SELECT", "TEXTAREA"],
            S = {
                passive: !1
            },
            w = Nn(0),
            C = Fn(),
            E = Fn(),
            I = h.measure(20),
            x = {
                mouse: 300,
                touch: 400
            },
            L = {
                mouse: 500,
                touch: 600
            },
            T = p ? 5 : 16,
            M = 1,
            A = 0,
            P = 0,
            B = !1,
            D = !1,
            O = !1,
            q = !1;
        return {
            addActivationEvents: function() {
                var e = n;
                C.add(e, "dragstart", (function(e) {
                    return e.preventDefault()
                }), S).add(e, "touchmove", (function() {}), S).add(e, "touchend", (function() {})).add(e, "touchstart", m).add(e, "mousedown", m).add(e, "touchcancel", g).add(e, "contextmenu", g).add(e, "click", _, !0)
            },
            clickAllowed: function() {
                return !O
            },
            pointerDown: function() {
                return B
            },
            removeAllEvents: function() {
                C.removeAll(), E.removeAll()
            }
        }
    }

    function Vn(e, t, n) {
        var i, o, a = function(e) {
                return h = e, p
            },
            r = function(e) {
                return f = e, p
            },
            s = (i = 2, o = Math.pow(10, i), function(e) {
                return Math.round(e * o) / o
            }),
            c = Nn(0),
            l = Nn(0),
            u = Nn(0),
            d = 0,
            h = t,
            f = n,
            p = {
                direction: function() {
                    return d
                },
                seek: function(t) {
                    u.set(t).subtract(e);
                    var n, i, o, a, r = (n = u.get(), (o = 0) + (n - (i = 0)) / (100 - i) * (h - o));
                    return d = xn(u.get()), u.normalize().multiply(r).subtract(c), (a = u).divide(f), l.add(a), p
                },
                settle: function(t) {
                    var n = t.get() - e.get(),
                        i = !s(n);
                    return i && e.set(t), i
                },
                update: function() {
                    c.add(l), e.add(c), l.multiply(0)
                },
                useBaseMass: function() {
                    return r(n)
                },
                useBaseSpeed: function() {
                    return a(t)
                },
                useMass: r,
                useSpeed: a
            };
        return p
    }

    function zn(e, t, n, i, o) {
        var a = o.measure(10),
            r = o.measure(50),
            s = .85,
            c = !1;
        return {
            constrain: function(o) {
                if (!c && e.reachedAny(n.get()) && e.reachedAny(t.get())) {
                    var l = e.reachedMin(t.get()) ? "min" : "max",
                        u = In(e[l] - t.get()),
                        d = n.get() - t.get(),
                        h = Math.min(u / r, s);
                    n.subtract(d * h), !o && In(d) < a && (n.set(e.constrain(n.get())), i.useSpeed(10).useMass(3))
                }
            },
            toggleActive: function(e) {
                c = !e
            }
        }
    }

    function Kn(e, t, n, i) {
        var o = qn(-t + e, n[0]),
            a = n.map(o.constrain);
        return {
            snapsContained: function() {
                if (t <= e) return [o.max];
                if ("keepSnaps" === i) return a;
                var n, r, s = (n = a[0], r = Mn(a), qn(a.lastIndexOf(n), a.indexOf(r) + 1)),
                    c = s.min,
                    l = s.max;
                return a.slice(c, l)
            }()
        }
    }

    function Un(e, t, n, i) {
        var o = qn(t.min + .1, t.max + .1),
            a = o.reachedMin,
            r = o.reachedMax;
        return {
            loop: function(t) {
                if (function(e) {
                        return 1 === e ? r(n.get()) : -1 === e && a(n.get())
                    }(t)) {
                    var o = e * (-1 * t);
                    i.forEach((function(e) {
                        return e.add(o)
                    }))
                }
            }
        }
    }

    function Wn(e) {
        var t = e.max,
            n = e.length;
        return {
            get: function(e) {
                return (e - t) / -n
            }
        }
    }

    function Yn(e, t, n, i, o) {
        var a = function(e) {
                return e.concat().sort((function(e, t) {
                    return In(e) - In(t)
                }))[0]
            },
            r = function(t, i) {
                var o = [t, t + n, t - n];
                if (!e) return o[0];
                if (!i) return a(o);
                var r = o.filter((function(e) {
                    return xn(e) === i
                }));
                return a(r)
            },
            s = i.reachedAny,
            c = i.removeOffset,
            l = i.constrain;
        return {
            byDistance: function(n, i) {
                var a = o.get() + n,
                    u = function(n) {
                        var i = e ? c(n) : l(n);
                        return {
                            index: t.map((function(e) {
                                return e - i
                            })).map((function(e) {
                                return r(e, 0)
                            })).map((function(e, t) {
                                return {
                                    diff: e,
                                    index: t
                                }
                            })).sort((function(e, t) {
                                return In(e.diff) - In(t.diff)
                            }))[0].index,
                            distance: i
                        }
                    }(a),
                    d = u.index,
                    h = u.distance,
                    f = !e && s(a);
                if (!i || f) return {
                    index: d,
                    distance: n
                };
                var p = t[d] - h;
                return {
                    index: d,
                    distance: n + r(p, 0)
                }
            },
            byIndex: function(e, n) {
                var i = t[e] - o.get();
                return {
                    index: e,
                    distance: r(i, n)
                }
            },
            shortcut: r
        }
    }

    function jn(e, t, n) {
        var i = "x" === e.scroll ? function(e) {
                return "translate3d(".concat(e, "px,0px,0px)")
            } : function(e) {
                return "translate3d(0px,".concat(e, "px,0px)")
            },
            o = n.style,
            a = !1;
        return {
            clear: function() {
                a || (o.transform = "", n.getAttribute("style") || n.removeAttribute("style"))
            },
            to: function(e) {
                a || (o.transform = i(t.apply(e.get())))
            },
            toggleActive: function(e) {
                a = !e
            }
        }
    }

    function Xn(e, t, n, i, o, a, r, s, c) {
        var l, u, d = function(e, t) {
                return e.reduce((function(e, t) {
                    return e - o[t]
                }), t)
            },
            h = function(e, t) {
                return e.reduce((function(e, n) {
                    return d(e, t) > 0 ? e.concat([n]) : e
                }), [])
            },
            f = function(n, o) {
                var a = "start" === o,
                    l = a ? -i : i,
                    u = r.findSlideBounds([l]);
                return n.map((function(n) {
                    var o = a ? 0 : -i,
                        r = a ? i : 0,
                        l = u.filter((function(e) {
                            return e.index === n
                        }))[0][a ? "end" : "start"],
                        d = Nn(-1),
                        h = Nn(-1),
                        f = jn(e, t, c[n]);
                    return {
                        index: n,
                        location: h,
                        translate: f,
                        target: function() {
                            return d.set(s.get() > l ? o : r)
                        }
                    }
                }))
            },
            p = Tn(o),
            v = Tn(o).reverse(),
            m = (l = a[0] - 1, u = h(v, l), f(u, "end")).concat(function() {
                var e = n - a[0] - 1,
                    t = h(p, e);
                return f(t, "start")
            }());
        return {
            canLoop: function() {
                return m.every((function(e) {
                    var t = e.index,
                        i = p.filter((function(e) {
                            return e !== t
                        }));
                    return d(i, n) <= .1
                }))
            },
            clear: function() {
                m.forEach((function(e) {
                    return e.translate.clear()
                }))
            },
            loop: function() {
                m.forEach((function(e) {
                    var t = e.target,
                        n = e.translate,
                        i = e.location,
                        o = t();
                    o.get() !== i.get() && (0 === o.get() ? n.clear() : n.to(o), i.set(o))
                }))
            },
            loopPoints: m
        }
    }

    function Qn(e, t, n, i, o, a, r) {
        var s = function(t, o) {
                var a = t || d,
                    r = function(e) {
                        var t = e || 0;
                        return n.map((function(e) {
                            return qn(u, e - u).constrain(e * t)
                        }))
                    }(o);
                return a.reduce((function(t, o) {
                    var a = i.map((function(t, i) {
                        return {
                            start: t - n[i] + r[i] + o,
                            end: t + e - r[i] + o,
                            index: i
                        }
                    }));
                    return t.concat(a)
                }), [])
            },
            c = o.removeOffset,
            l = o.constrain,
            u = .5,
            d = a ? [0, t, -t] : [0],
            h = s(d, r);
        return {
            check: function(e, t) {
                var n = a ? c(e) : l(e);
                return (t || h).reduce((function(e, t) {
                    var i = t.index,
                        o = t.start,
                        a = t.end;
                    return !(-1 !== e.indexOf(i)) && (o < n && a > n) ? e.concat([i]) : e
                }), [])
            },
            findSlideBounds: s
        }
    }

    function Gn(e, t, n) {
        var i = Sn(n);
        return {
            groupSlides: function(o) {
                return i ? function(e, t) {
                    return Tn(e).filter((function(e) {
                        return e % t == 0
                    })).map((function(n) {
                        return e.slice(n, n + t)
                    }))
                }(o, n) : function(n) {
                    return Tn(n).reduce((function(n, i) {
                        var o = t.slice(Mn(n), i + 1).reduce((function(e, t) {
                            return e + t
                        }), 0);
                        return !i || o > e ? n.concat(i) : n
                    }), []).map((function(e, t, i) {
                        return n.slice(e, i[t + 1])
                    }))
                }(o)
            }
        }
    }

    function Zn(e, t, n, i, o) {
        var a, r, s, c, l = i.align,
            u = i.axis,
            d = i.direction,
            h = i.startIndex,
            f = i.inViewThreshold,
            p = i.loop,
            v = i.speed,
            m = i.dragFree,
            y = i.slidesToScroll,
            g = i.skipSnaps,
            _ = i.containScroll,
            b = t.getBoundingClientRect(),
            k = n.map((function(e) {
                return e.getBoundingClientRect()
            })),
            S = function(e) {
                var t = "rtl" === e ? -1 : 1;
                return {
                    apply: function(e) {
                        return e * t
                    }
                }
            }(d),
            w = function(e, t) {
                var n = "y" === e ? "y" : "x";
                return {
                    scroll: n,
                    cross: "y" === e ? "x" : "y",
                    startEdge: "y" === n ? "top" : "rtl" === t ? "right" : "left",
                    endEdge: "y" === n ? "bottom" : "rtl" === t ? "left" : "right",
                    measureSize: function(e) {
                        var t = e.width,
                            i = e.height;
                        return "x" === n ? t : i
                    }
                }
            }(u, d),
            C = w.measureSize(b),
            E = function(e) {
                return {
                    measure: function(t) {
                        return e * (t / 100)
                    }
                }
            }(C),
            I = On(l, C),
            x = !p && "" !== _,
            L = function(e, t, n, i, o) {
                var a = e.measureSize,
                    r = e.startEdge,
                    s = e.endEdge,
                    c = n[0] && o,
                    l = function() {
                        if (!c) return 0;
                        var e = n[0];
                        return In(t[r] - e[r])
                    }(),
                    u = function() {
                        if (!c) return 0;
                        var e = window.getComputedStyle(Mn(i));
                        return parseFloat(e.getPropertyValue("margin-".concat(s)))
                    }(),
                    d = n.map(a),
                    h = n.map((function(e, t, n) {
                        var i = !t,
                            o = t === An(n);
                        return i ? d[t] + l : o ? d[t] + u : n[t + 1][r] - e[r]
                    })).map(In);
                return {
                    slideSizes: d,
                    slideSizesWithGaps: h
                }
            }(w, b, k, n, p || "" !== _),
            T = L.slideSizes,
            M = L.slideSizesWithGaps,
            A = Gn(C, M, y),
            P = function(e, t, n, i, o, a, r) {
                var s, c = e.startEdge,
                    l = e.endEdge,
                    u = a.groupSlides,
                    d = u(i).map((function(e) {
                        return Mn(e)[l] - e[0][c]
                    })).map(In).map(t.measure),
                    h = i.map((function(e) {
                        return n[c] - e[c]
                    })).map((function(e) {
                        return -In(e)
                    })),
                    f = (s = Mn(h) - Mn(o), u(h).map((function(e) {
                        return e[0]
                    })).map((function(e, t, n) {
                        var i = !t,
                            o = t === An(n);
                        return r && i ? 0 : r && o ? s : e + d[t]
                    })));
                return {
                    snaps: h,
                    snapsAligned: f
                }
            }(w, I, b, k, M, A, x),
            B = P.snaps,
            D = P.snapsAligned,
            O = -Mn(B) + Mn(M),
            q = Kn(C, O, D, _).snapsContained,
            R = x ? q : D,
            F = function(e, t, n) {
                var i, o;
                return {
                    limit: (i = t[0], o = Mn(t), qn(n ? i - e : o, i))
                }
            }(O, R, p).limit,
            N = Rn(An(R), h, p),
            H = N.clone(),
            V = Tn(n),
            z = (a = function() {
                p || Z.scrollBounds.constrain(Z.dragHandler.pointerDown()), Z.scrollBody.seek(W).update();
                var e = Z.scrollBody.settle(W);
                e && !Z.dragHandler.pointerDown() && (Z.animation.stop(), o.emit("settle")), e || o.emit("scroll"), p && (Z.scrollLooper.loop(Z.scrollBody.direction()), Z.slideLooper.loop()), Z.translate.to(U), Z.animation.proceed()
            }, r = function(e, t) {
                return function() {
                    e === !!c && t()
                }
            }, s = function() {
                c = window.requestAnimationFrame(a)
            }, c = 0, {
                proceed: r(!0, s),
                start: r(!1, s),
                stop: r(!0, (function() {
                    window.cancelAnimationFrame(c), c = 0
                }))
            }),
            K = R[N.get()],
            U = Nn(K),
            W = Nn(K),
            Y = Vn(U, v, 1),
            j = Yn(p, R, O, F, W),
            X = function(e, t, n, i, o, a) {
                var r = function(i) {
                    var r = i.distance,
                        s = i.index !== t.get();
                    r && (e.start(), o.add(r)), s && (n.set(t.get()), t.set(i.index), a.emit("select"))
                };
                return {
                    distance: function(e, t) {
                        var n = i.byDistance(e, t);
                        r(n)
                    },
                    index: function(e, n) {
                        var o = t.clone().set(e),
                            a = i.byIndex(o.get(), n);
                        r(a)
                    }
                }
            }(z, N, H, j, W, o),
            Q = Qn(C, O, T, B, F, p, f),
            G = Hn(w, S, e, W, function(e) {
                var t, n, i = function(e) {
                        return "undefined" != typeof TouchEvent && e instanceof TouchEvent
                    },
                    o = function(e) {
                        return e.timeStamp
                    },
                    a = function(t, n) {
                        var o = n || e.scroll,
                            a = "client".concat("x" === o ? "X" : "Y");
                        return (i(t) ? t.touches[0] : t)[a]
                    },
                    r = 170;
                return {
                    isTouchEvent: i,
                    pointerDown: function(e) {
                        return t = e, n = e, a(e)
                    },
                    pointerMove: function(e) {
                        var i = a(e) - a(n),
                            s = o(e) - o(t) > r;
                        return n = e, s && (t = e), i
                    },
                    pointerUp: function(e) {
                        if (!t || !n) return 0;
                        var i = a(n) - a(t),
                            s = o(e) - o(t),
                            c = o(e) - o(n) > r,
                            l = i / s;
                        return s && !c && In(l) > .1 ? l : 0
                    },
                    readPoint: a
                }
            }(w), U, z, X, Y, j, N, o, E, p, m, g),
            Z = {
                containerRect: b,
                slideRects: k,
                animation: z,
                axis: w,
                direction: S,
                dragHandler: G,
                eventStore: Fn(),
                percentOfView: E,
                index: N,
                indexPrevious: H,
                limit: F,
                location: U,
                options: i,
                scrollBody: Y,
                scrollBounds: zn(F, U, W, Y, E),
                scrollLooper: Un(O, F, U, [U, W]),
                scrollProgress: Wn(F),
                scrollSnaps: R,
                scrollTarget: j,
                scrollTo: X,
                slideLooper: Xn(w, S, C, O, M, R, Q, U, n),
                slidesToScroll: A,
                slidesInView: Q,
                slideIndexes: V,
                target: W,
                translate: jn(w, S, t)
            };
        return Z
    }
    var Jn = {
        align: "center",
        axis: "x",
        container: null,
        slides: null,
        containScroll: "",
        direction: "ltr",
        slidesToScroll: 1,
        breakpoints: {},
        dragFree: !1,
        draggable: !0,
        inViewThreshold: 0,
        loop: !1,
        skipSnaps: !1,
        speed: 10,
        startIndex: 0,
        active: !0
    };

    function $n() {
        var e = function(e, t) {
            return Bn(e, t || {})
        };
        return {
            merge: e,
            areEqual: function(e, t) {
                return JSON.stringify(Pn(e.breakpoints || {})) === JSON.stringify(Pn(t.breakpoints || {})) && Dn(e, t)
            },
            atMedia: function(t) {
                var n = t.breakpoints || {},
               
                    i = Pn(n).filter((function(e) {
                        return window.matchMedia(e).matches
                    })).map((function(e) {
                        return n[e]
                    })).reduce((function(t, n) {
                        return e(t, n)
                    }), {});
                return e(t, i)
            }
        }
    }

    function ei(e, t, n) {
        var i, o, a, r, s = function(e, t) {
                var n = d();
                c(), C(f.merge({
                    startIndex: n
                }, e), t), v.emit("reInit")
            },
            c = function() {
                i.dragHandler.removeAllEvents(), i.animation.stop(), i.eventStore.removeAll(), i.translate.clear(), i.slideLooper.clear(), p.destroy()
            },
            l = function(e) {
                var t = i[e ? "target" : "location"].get(),
                    n = k.loop ? "removeOffset" : "constrain";
                return i.slidesInView.check(i.limit[n](t))
            },
            u = function(e, t, n) {
                k.active && !_ && (i.scrollBody.useBaseMass().useSpeed(t ? 100 : k.speed), i.scrollTo.index(e, n || 0))
            },
            d = function() {
                return i.index.get()
            },
            h = Fn(),
            f = $n(),
            p = function() {
                var e = function(e) {
                        var t = n(e.options);
                        return function() {
                            return !i(t, n(e.options))
                        }
                    },
                    t = $n(),
                    n = t.atMedia,
                    i = t.areEqual,
                    o = [],
                    a = [],
                    r = {
                        init: function(t, i) {
                            return a = t.map(e), (o = t.filter((function(e) {
                                return n(e.options).active
                            }))).forEach((function(e) {
                                return e.init(i)
                            })), t.reduce((function(e, t) {
                                var n;
                                return Object.assign(e, ((n = {})[t.name] = t, n))
                            }), {})
                        },
                        destroy: function() {
                            o = o.filter((function(e) {
                                return e.destroy()
                            }))
                        },
                        haveChanged: function() {
                            return a.some((function(e) {
                                return e()
                            }))
                        }
                    };
                return r
            }(),
            v = function() {
                var e = function(e) {
                        return t[e] || []
                    },
                    t = {},
                    n = {
                        emit: function(t) {
                            return e(t).forEach((function(e) {
                                return e(t)
                            })), n
                        },
                        off: function(i, o) {
                            return t[i] = e(i).filter((function(e) {
                                return e !== o
                            })), n
                        },
                        on: function(i, o) {
                            return t[i] = e(i).concat([o]), n
                        }
                    };
                return n
            }(),
            m = v.on,
            y = v.off,
            g = s,
            _ = !1,
            b = f.merge(Jn, ei.globalOptions),
            k = f.merge(b),
            S = [],
            w = 0;

        function C(t, n) {
            if (!_) {
                if (b = f.merge(b, t), k = f.atMedia(b), function() {
                        var t = k.container,
                            n = k.slides,
                            i = wn(t) ? e.querySelector(t) : t;
                        a = i || e.children[0];
                        var o = wn(n) ? a.querySelectorAll(n) : n;
                        r = [].slice.call(o || a.children)
                    }(), i = Zn(e, a, r, k, v), w = i.axis.measureSize(e.getBoundingClientRect()), !k.active) return c();
                if (i.translate.to(i.location), S = n || S, o = p.init(S, E), k.loop) {
                    if (!i.slideLooper.canLoop()) return c(), C({
                        loop: !1
                    }, n), void(b = f.merge(b, {
                        loop: !0
                    }));
                    i.slideLooper.loop()
                }
                k.draggable && a.offsetParent && r.length && i.dragHandler.addActivationEvents()
            }
        }
        var E = {
            canScrollNext: function() {
                return i.index.clone().add(1).get() !== d()
            },
            canScrollPrev: function() {
                return i.index.clone().add(-1).get() !== d()
            },
            clickAllowed: function() {
                return i.dragHandler.clickAllowed()
            },
            containerNode: function() {
                return a
            },
            internalEngine: function() {
                return i
            },
            destroy: function() {
                _ || (_ = !0, h.removeAll(), c(), v.emit("destroy"))
            },
            off: y,
            on: m,
            plugins: function() {
                return o
            },
            previousScrollSnap: function() {
                return i.indexPrevious.get()
            },
            reInit: g,
            rootNode: function() {
                return e
            },
            scrollNext: function(e) {
                var t = i.index.clone().add(1);
                u(t.get(), !0 === e, -1)
            },
            scrollPrev: function(e) {
                var t = i.index.clone().add(-1);
                u(t.get(), !0 === e, 1)
            },
            scrollProgress: function() {
                return i.scrollProgress.get(i.location.get())
            },
            scrollSnapList: function() {
                return i.scrollSnaps.map(i.scrollProgress.get)
            },
            scrollTo: u,
            selectedScrollSnap: d,
            slideNodes: function() {
                return r
            },
            slidesInView: l,
            slidesNotInView: function(e) {
                var t = l(e);
                return i.slideIndexes.filter((function(e) {
                    return -1 === t.indexOf(e)
                }))
            }
        };
        return C(t, n), h.add(window, "resize", (function() {
            var t = f.atMedia(b),
                n = !f.areEqual(t, k),
                o = i.axis.measureSize(e.getBoundingClientRect()),
                a = w !== o,
                r = p.haveChanged();
            (a || n || r) && s(), v.emit("resize")
        })), setTimeout((function() {
            return v.emit("init")
        }), 0), E
    }
    ei.globalOptions = void 0, ei.optionsHandler = $n;
    var ti = {
        active: !0,
        breakpoints: {},
        selected: "is-selected",
        draggable: "is-draggable",
        dragging: "is-dragging"
    };

    function ni(e, t) {
        var n = e.classList;
        t && n.contains(t) && n.remove(t)
    }

    function ii(e, t) {
        var n = e.classList;
        t && !n.contains(t) && n.add(t)
    }

    function oi(e) {
        var t, n, i, o, a = function(e) {
                "pointerDown" === e ? ii(i, t.dragging) : ni(i, t.dragging)
            },
            r = function() {
                var e = n.slidesInView(!0);
                n.slidesNotInView(!0).forEach((function(e) {
                    return ni(o[e], t.selected)
                })), e.forEach((function(e) {
                    return ii(o[e], t.selected)
                }))
            },
            s = ei.optionsHandler(),
            c = s.merge(ti, oi.globalOptions),
            l = ["select", "pointerUp"],
            u = ["pointerDown", "pointerUp"],
            d = {
                name: "classNames",
                options: s.merge(c, e),
                init: function(e) {
                    n = e, t = s.atMedia(d.options), i = n.rootNode(), o = n.slideNodes(), n.internalEngine().options.draggable && ii(i, t.draggable), t.dragging && u.forEach((function(e) {
                        return n.on(e, a)
                    })), t.selected && (l.forEach((function(e) {
                        return n.on(e, r)
                    })), r())
                },
                destroy: function() {
                    ni(i, t.draggable), u.forEach((function(e) {
                        return n.off(e, a)
                    })), l.forEach((function(e) {
                        return n.off(e, r)
                    })), o.forEach((function(e) {
                        return ni(e, t.selected)
                    }))
                }
            };
        return d
    }
    oi.globalOptions = void 0;
    var ai, ri, si, ci, li = "idle",
        ui = "running",
        di = "paused",
        hi = "resumed",
        fi = function() {
            "use strict";

            function e(t, n) {
                h(this, e), this.interval = n, this.callback = t, this.state = li, this.pausedTime = 0, this.remainingTime = 0
            }
            return p(e, [{
                key: "proxyCallback",
                value: function() {
                    this.lastFireTime = new Date, this.callback()
                }
            }, {
                key: "start",
                value: function() {
                    var e = this;
                    this.timerId = setInterval((function() {
                        return e.proxyCallback()
                    }), this.interval), this.lastFireTime = new Date, this.state = ui
                }
            }, {
                key: "pause",
                value: function() {
                    this.state !== ui && this.state !== hi || (this.remainingTime = this.interval - (new Date - this.lastFireTime) + this.pausedTime, this.lastPauseTime = new Date, clearInterval(this.timerId), clearTimeout(this.resumeId), this.state = di)
                }
            }, {
                key: "resume",
                value: function() {
                    var e = this;
                    this.state === di && (this.pausedTime += new Date - this.lastPauseTime, this.state = hi, this.resumeId = setTimeout((function() {
                        return e.timeoutCallback()
                    }), this.remainingTime))
                }
            }, {
                key: "timeoutCallback",
                value: function() {
                    this.state === hi && (this.pausedTime = 0, this.proxyCallback(), this.start())
                }
            }, {
                key: "stop",
                value: function() {
                    this.state !== li && (clearInterval(this.timerId), clearTimeout(this.resumeId), this.state = li)
                }
            }, {
                key: "setInterval",
                value: function(e) {
                    this.state === ui ? (this.pause(), this.interval = e, this.resume()) : this.interval = e
                }
            }]), e
        }(),
        pi = {};
    ai = pi, ri = "debounce", si = function() {
        return vi
    }, ci = function(e) {
        return vi = e
    }, Object.defineProperty(ai, ri, {
        get: si,
        set: ci,
        enumerable: !0,
        configurable: !0
    });
    var vi = function(e, t) {
            var n;
            return function() {
                for (var i = arguments.length, o = new Array(i), a = 0; a < i; a++) o[a] = arguments[a];
                clearTimeout(n), n = setTimeout((function() {
                    return e.apply(undefined, o)
                }), t)
            }
        },
        mi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                h(this, n), v(E(e = t.call(this)), "attributeChangedCallback", (function(t, n, i) {
                    n !== i && e.reInit()
                })), v(E(e), "_handleCarouselTargetKeyDown", (function(t) {
                    t.preventDefault();
                    var n = e.focusableTargets.findIndex((function(e) {
                            return e === t.target
                        })),
                        i = e.focusableTargets[n],
                        o = e.focusableTargets[n + 1],
                        a = e.focusableTargets[n - 1];
                    9 === t.keyCode && (t.preventDefault(), document.activeElement === i && e.focusScroll(i), t.shiftKey || (o ? e.focusScroll(o) : document.activeElement.blur()), t.shiftKey && (a ? e.focusScroll(a) : document.activeElement.blur()))
                })), v(E(e), "_handleCarouselResize", (0, pi.debounce)((function() {
                    if (e._isEditorMode) {
                        var t = mn() ? "mobile" : "desktop";
                        e.lastViewModeIsMobile !== t && e.forceStopped && (e.forcePlay(), e.changePlayState(!0)), e.lastViewModeIsMobile = t
                    }
                    e.reInit()
                }), 100)), v(E(e), "focusScroll", (function(t) {
                    var n = e.slides.findIndex((function(e) {
                        return e.contains(t)
                    })); - 1 !== n && (e.embla.scrollTo(n, !0), e.forceStop()), t.focus()
                })), v(E(e), "_handleCarouselEnter", (function() {
                    mn() || e.changePlayState(!1)
                })), v(E(e), "_handleCarouselSelect", (function() {
                    e.isTouchOnCarousel && e.forceStop()
                })), v(E(e), "_handleCarouselPointerUp", (function() {
                    e.isTouchOnCarousel = !1
                })), v(E(e), "_handleCarouselPointerDown", (function() {
                    e.isTouchOnCarousel = !0
                })), v(E(e), "_handleCarouselLeave", (function() {
                    mn() || e.changePlayState(!0)
                })), v(E(e), "_handleKeydown", (function(t) {
                    var n = t.key || t.keyCode,
                        i = Z(n),
                        o = G(n);
                    i && e.embla.scrollPrev(), o && e.embla.scrollNext()
                })), v(E(e), "_handleBlockSelect", (function(t) {
                    var n = t.detail,
                        i = n.sectionId,
                        o = n.blockId,
                        a = n.load;
                    if (e.dataset.sectionId === i) {
                        var r = e.embla.slideNodes().findIndex((function(e) {
                            var t;
                            return (null === (t = e.attributes["block-id"]) || void 0 === t ? void 0 : t.value) === o
                        })); - 1 !== r && (e.embla.scrollTo(r, a), e.forceStop())
                    }
                })), v(E(e), "_handleSectionLoad", (function(t) {
                    var n = t.detail.sectionId;
                    e.dataset.sectionId === n && e.reInit()
                })), v(E(e), "_getOptions", (function() {
                    return {
                        loop: "infinite" === e.dataset.loop,
                        dragFree: e.dataset.dragFree,
                        draggable: !e.hasAttribute("data-draggable") || "true" === e.dataset.draggable,
                        skipSnaps: e.dataset.skipSnaps || !0,
                        align: e.dataset.align || "start",
                        inViewThreshold: +(e.dataset.inViewThreshhold || 0) || .75,
                        containScroll: e.hasAttribute("data-contain-scroll") ? e.dataset.containScroll : "trimSnaps",
                        axis: "vertical" === e.dataset.axis ? "y" : "x",
                        speed: e._getSpeed()
                    }
                })), v(E(e), "_getPlugins", (function() {
                    return [e._getClassNamesPlugin()]
                })), v(E(e), "changePlayState", (function(t) {
                    e.withAutoplay && (e.forceStopped || (e.isPlay = t, t ? e.autoplay.play() : e.autoplay.pause(), e.emit("changePlayState", {})))
                })), v(E(e), "reInit", (function() {
                    var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                        n = m({}, e._getOptions(), t),
                        i = e._getPlugins();
                    e.embla.reInit(n, i)
                })), v(E(e), "scrollNext", (function() {
                    e.embla.scrollNext()
                })), v(E(e), "scrollPrev", (function() {
                    e.embla.scrollPrev()
                })), v(E(e), "canScrollNext", (function() {
                    return e.embla.canScrollNext()
                })), v(E(e), "canScrollPrev", (function() {
                    return e.embla.canScrollPrev()
                }));
                var i = +(e.dataset.autoplayInterval || 0);
                return e.withAutoplay = i > 0, e.isPlay = i > 0, e.forceStopped = !1, e.resizeObserver = new ResizeObserver(e._handleCarouselResize), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this;
                    this._setCarousel(), this.focusableTargets = S(this.querySelectorAll(Y())), this.focusableTargets.forEach((function(t) {
                        t.addEventListener("keydown", e._handleCarouselTargetKeyDown)
                    })), K(this, "mouseenter", this._handleCarouselEnter), K(this, "mouseleave", this._handleCarouselLeave), K(this, "keydown", this._handleKeydown), this.resizeObserver.observe(this), this.embla.on("select", this._handleCarouselSelect), this.embla.on("pointerUp", this._handleCarouselPointerUp), this.embla.on("pointerDown", this._handleCarouselPointerDown), this._isEditorMode && (this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect), this._editor.subscribe("SECTION_LOAD", this._handleSectionLoad))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    var e = this;
                    this.focusableTargets.forEach((function(t) {
                        t.removeEventListener("keydown", e._handleCarouselTargetKeyDown)
                    })), this.resizeObserver.disconnect(), U(this, "mouseenter", this._handleCarouselEnter), U(this, "mouseleave", this._handleCarouselLeave), U(this, "keydown", this._handleKeydown), this.embla.off("select", this._handleCarouselSelect), this.embla.off("pointerUp", this._handleCarouselPointerUp), this.embla.off("pointerDown", this._handleCarouselPointerDown), this._isEditorMode && this._editor.destroy(), this.embla.destroy()
                }
            }, {
                key: "_setCarousel",
                value: function() {
                    var e, t, n, i = this.querySelector("[data-carousel-viewport]");
                    i && (this.embla = ei(i, this._getOptions(), this._getPlugins()), this.withAutoplay && (this.autoplay = (e = this.embla, t = 1e3 * this.autoplayInterval, n = new fi((function() {
                        var t = e.scrollSnapList().length - 1;
                        e.selectedScrollSnap() === t ? e.scrollTo(0) : e.scrollNext()
                    }), t), {
                        play: function() {
                            n.resume()
                        },
                        stop: function() {
                            n.stop()
                        },
                        start: function() {
                            n.start()
                        },
                        pause: function() {
                            n.pause()
                        }
                    }), this.autoplay.start()))
                }
            }, {
                key: "_getClassNamesPlugin",
                value: function() {
                    return oi()
                }
            }, {
                key: "_getSpeed",
                value: function() {
                    return yn() || "fade" === this.dataset.animation ? 100 : 10
                }
            }, {
                key: "forceStop",
                value: function() {
                    this.withAutoplay && (this.autoplay.stop(), this.isPlay = !1, this.forceStopped = !0, this.emit("forceChangePlayState", {}))
                }
            }, {
                key: "forcePlay",
                value: function() {
                    this.withAutoplay && (this.forceStopped = !1, this.isPlay = !0, this.autoplay.start(), this.changePlayState(!1), this.emit("forceChangePlayState", {}))
                }
            }, {
                key: "autoplayInterval",
                get: function() {
                    return +(this.dataset.autoplayInterval || 0)
                }
            }, {
                key: "slides",
                get: function() {
                    return S(this.embla.slideNodes())
                }
            }]), n
        }(ee),
        yi = mi,
        gi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleCarouselChangePlayState", (function() {
                    e.updatePlayState()
                })), v(E(e), "_handleButtonClick", (function(t) {
                    (t.stopPropagation(), e._carousel) && (e._carousel.forceStopped ? e._carousel.forcePlay() : e._carousel.forceStop())
                })), e.button = e.querySelector("[data-carousel-play-button]"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.updatePlayState(), this.button && this.button.addEventListener("click", this._handleButtonClick), this._carousel && (customElements.upgrade(this._carousel), this._carousel.subscribe("forceChangePlayState", this._handleCarouselChangePlayState))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.button && this.button.removeEventListener("click", this._handleButtonClick), this._carousel && this._carousel.unsubscribe("forceChangePlayState", this._handleCarouselChangePlayState)
                }
            }, {
                key: "updatePlayState",
                value: function() {
                    if (this._carousel && this.button) {
                        var e = this._carousel.forceStopped;
                        this.button.setAttribute("data-autoplay-stopped", e ? "true" : "false")
                    }
                }
            }, {
                key: "_carousel",
                get: function() {
                    return this.closest("carousel-component")
                }
            }]), n
        }(ee);

    function _i() {
        return _i = Object.assign || function(e) {
            for (var t = 1; t < arguments.length; t++) {
                var n = arguments[t];
                for (var i in n) Object.prototype.hasOwnProperty.call(n, i) && (e[i] = n[i])
            }
            return e
        }, _i.apply(this, arguments)
    }

    function bi(e, t) {
        if (e.length !== t.length) throw new Error("vectors must be same length");
        return e.map((function(e, n) {
            return e + t[n]
        }))
    }

    function ki(e) {
        return Math.max.apply(Math, e.map(Math.abs))
    }

    function Si(e) {
        return Object.freeze(e), Object.values(e).forEach((function(e) {
            null === e || "object" != typeof e || Object.isFrozen(e) || Si(e)
        })), e
    }
    var wi = [1, 18, "undefined" != typeof window && window.innerHeight || 800];
    var Ci = [-1, -1, -1];
    var Ei = function(e) {
            return _i({}, e, {
                axisDelta: e.axisDelta.map((function(e) {
                    return t = e, n = -700, i = 700, Math.min(Math.max(n, t), i);
                    var t, n, i
                }))
            })
        },
        Ii = Si({
            preventWheelAction: !0,
            reverseSign: [!0, !0, !1]
        }),
        xi = 400;

    function Li() {
        return {
            isStarted: !1,
            isStartPublished: !1,
            isMomentum: !1,
            startTime: 0,
            lastAbsDelta: 1 / 0,
            axisMovement: [0, 0, 0],
            axisVelocity: [0, 0, 0],
            accelerationFactors: [],
            scrollPoints: [],
            scrollPointsToMerge: [],
            willEndTimeout: xi
        }
    }
    var Ti = function(e) {
            void 0 === e && (e = {});
            var t, n, i, o = function() {
                    var e = function(e, n) {
                            t[e] = (t[e] || []).filter((function(e) {
                                return e !== n
                            }))
                        },
                        t = {};
                    return Si({
                        on: function(n, i) {
                            return t[n] = (t[n] || []).concat(i),
                                function() {
                                    return e(n, i)
                                }
                        },
                        off: e,
                        dispatch: function(e, n) {
                            e in t && t[e].forEach((function(e) {
                                return e(n)
                            }))
                        }
                    })
                }(),
                a = o.on,
                r = o.off,
                s = o.dispatch,
                c = Ii,
                l = Li(),
                u = !1,
                d = function(e) {
                    Array.isArray(e) ? e.forEach((function(e) {
                        return p(e)
                    })) : p(e)
                },
                h = function(e) {
                    return void 0 === e && (e = {}), Object.values(e).some((function(e) {
                        return null == e
                    })) ? c : c = Si(_i({}, Ii, c, e))
                },
                f = function(e) {
                    var i = _i({
                        event: t,
                        isStart: !1,
                        isEnding: !1,
                        isMomentumCancel: !1,
                        isMomentum: l.isMomentum,
                        axisDelta: [0, 0, 0],
                        axisVelocity: l.axisVelocity,
                        axisMovement: l.axisMovement,
                        get axisMovementProjection() {
                            return bi(i.axisMovement, i.axisVelocity.map((function(e) {
                                return void 0 === t && (t = .996), e * t / (1 - t);
                                var t
                            })))
                        }
                    }, e);
                    s("wheel", _i({}, i, {
                        previous: n
                    })), n = i
                },
                p = function(e) {
                    var n = Ei(function(e, t) {
                            if (!t) return e;
                            var n = !0 === t ? Ci : t.map((function(e) {
                                return e ? -1 : 1
                            }));
                            return _i({}, e, {
                                axisDelta: e.axisDelta.map((function(e, t) {
                                    return e * n[t]
                                }))
                            })
                        }(function(e) {
                            var t = e.deltaX * wi[e.deltaMode],
                                n = e.deltaY * wi[e.deltaMode],
                                i = (e.deltaZ || 0) * wi[e.deltaMode];
                            return {
                                timeStamp: e.timeStamp,
                                axisDelta: [t, n, i]
                            }
                        }(e), c.reverseSign)),
                        i = n.axisDelta,
                        o = n.timeStamp,
                        a = ki(i);
                    e.preventDefault && function(e, t) {
                        var n = c.preventWheelAction,
                            i = t[0],
                            o = t[1],
                            a = t[2];
                        if ("boolean" == typeof n) return n;
                        switch (n) {
                            case "x":
                                return Math.abs(i) >= e;
                            case "y":
                                return Math.abs(o) >= e;
                            case "z":
                                return Math.abs(a) >= e;
                            default:
                                return !1
                        }
                    }(a, i) && e.preventDefault(), l.isStarted ? l.isMomentum && a > Math.max(2, 2 * l.lastAbsDelta) && (C(!0), S()) : S(), 0 === a && Object.is && Object.is(e.deltaX, -0) ? u = !0 : (t = e, l.axisMovement = bi(l.axisMovement, i), l.lastAbsDelta = a, l.scrollPointsToMerge.push({
                        axisDelta: i,
                        timeStamp: o
                    }), v(), f({
                        axisDelta: i,
                        isStart: !l.isStartPublished
                    }), l.isStartPublished = !0, w())
                },
                v = function() {
                    var e;
                    2 === l.scrollPointsToMerge.length ? (l.scrollPoints.unshift({
                        axisDeltaSum: l.scrollPointsToMerge.map((function(e) {
                            return e.axisDelta
                        })).reduce(bi),
                        timeStamp: (e = l.scrollPointsToMerge.map((function(e) {
                            return e.timeStamp
                        })), e.reduce((function(e, t) {
                            return e + t
                        })) / e.length)
                    }), y(), l.scrollPointsToMerge.length = 0, l.scrollPoints.length = 1, l.isMomentum || b()) : l.isStartPublished || m()
                },
                m = function() {
                    var e;
                    l.axisVelocity = (e = l.scrollPointsToMerge, e[e.length - 1]).axisDelta.map((function(e) {
                        return e / l.willEndTimeout
                    }))
                },
                y = function() {
                    var e = l.scrollPoints,
                        t = e[0],
                        n = e[1];
                    if (n && t) {
                        var i = t.timeStamp - n.timeStamp;
                        if (!(i <= 0)) {
                            var o = t.axisDeltaSum.map((function(e) {
                                    return e / i
                                })),
                                a = o.map((function(e, t) {
                                    return e / (l.axisVelocity[t] || 1)
                                }));
                            l.axisVelocity = o, l.accelerationFactors.push(a), g(i)
                        }
                    }
                },
                g = function(e) {
                    var t = 12 * Math.ceil(e / 10);
                    l.isMomentum || (t = Math.max(100, 2 * t)), l.willEndTimeout = Math.min(1e3, Math.round(t))
                },
                _ = function(e) {
                    return 0 === e || e <= .96 && e >= .6
                },
                b = function() {
                    if (l.accelerationFactors.length >= 5) {
                        if (u && (u = !1, ki(l.axisVelocity) >= .2)) return void k();
                        var e = l.accelerationFactors.slice(-5);
                        e.every((function(e) {
                            var t = !!e.reduce((function(e, t) {
                                    return e && e < 1 && e === t ? 1 : 0
                                })),
                                n = e.filter(_).length === e.length;
                            return t || n
                        })) && k(), l.accelerationFactors = e
                    }
                },
                k = function() {
                    l.isMomentum = !0
                },
                S = function() {
                    (l = Li()).isStarted = !0, l.startTime = Date.now(), n = void 0, u = !1
                },
                w = function() {
                    clearTimeout(i), i = setTimeout(C, l.willEndTimeout)
                },
                C = function(e) {
                    void 0 === e && (e = !1), l.isStarted && (l.isMomentum && e ? f({
                        isEnding: !0,
                        isMomentumCancel: !0
                    }) : f({
                        isEnding: !0
                    }), l.isMomentum = !1, l.isStarted = !1)
                },
                E = function(e) {
                    var t = [],
                        n = function(n) {
                            n.removeEventListener("wheel", e), t = t.filter((function(e) {
                                return e !== n
                            }))
                        };
                    return Si({
                        observe: function(i) {
                            return i.addEventListener("wheel", e, {
                                    passive: !1
                                }), t.push(i),
                                function() {
                                    return n(i)
                                }
                        },
                        unobserve: n,
                        disconnect: function() {
                            t.forEach(n)
                        }
                    })
                }(d),
                I = E.observe,
                x = E.unobserve,
                L = E.disconnect;
            return h(e), Si({
                on: a,
                off: r,
                observe: I,
                unobserve: x,
                disconnect: L,
                feedWheel: d,
                updateOptions: h
            })
        },
        Mi = {
            active: !0,
            breakpoints: {},
            wheelDraggingClass: "is-wheel-dragging",
            forceWheelAxis: void 0,
            target: void 0
        };
    Pi.globalOptions = void 0;
    var Ai = !1;

    function Pi(e) {
        var t, n = ei.optionsHandler(),
            i = n.merge(Mi, Pi.globalOptions),
            o = function() {},
            a = {
                name: "wheelGestures",
                options: n.merge(i, e),
                init: function(e) {
                    var i, r;
                    t = n.atMedia(a.options);
                    var s, c = e.internalEngine(),
                        l = null != (i = t.target) ? i : e.containerNode().parentNode,
                        u = null != (r = t.forceWheelAxis) ? r : c.options.axis,
                        d = Ti({
                            preventWheelAction: u,
                            reverseSign: [!0, !0, !1]
                        }),
                        h = d.observe(l),
                        f = d.on("wheel", (function(e) {
                            var n = e.axisDelta,
                                i = n[0],
                                a = n[1],
                                r = "x" === u ? i : a,
                                c = "x" === u ? a : i,
                                d = e.isMomentum && e.previous && !e.previous.isMomentum,
                                h = e.isEnding && !e.isMomentum || d;
                            Math.abs(r) > Math.abs(c) && !p && !e.isMomentum && function(e) {
                                try {
                                    g(s = new MouseEvent("mousedown", e.event))
                                } catch (e) {
                                    return Ai && console.warn("Legacy browser requires events-polyfill (https://github.com/xiel/embla-carousel-wheel-gestures#legacy-browsers)"), o()
                                }
                                p = !0, document.documentElement.addEventListener("mousemove", m, !0), document.documentElement.addEventListener("mouseup", m, !0), void document.documentElement.addEventListener("mousedown", m, !0), t.wheelDraggingClass && l.classList.add(t.wheelDraggingClass)
                            }(e);
                            if (!p) return;
                            h ? function(e) {
                                p = !1, g(y("mouseup", e)), v(), t.wheelDraggingClass && l.classList.remove(t.wheelDraggingClass)
                            }(e) : g(y("mousemove", e))
                        })),
                        p = !1;

                    function v() {
                        document.documentElement.removeEventListener("mousemove", m, !0), document.documentElement.removeEventListener("mouseup", m, !0), document.documentElement.removeEventListener("mousedown", m, !0)
                    }

                    function m(e) {
                        p && e.isTrusted && e.stopImmediatePropagation()
                    }

                    function y(e, t) {
                        var n, i;
                        if (u === c.options.axis) {
                            var o = t.axisMovement;
                            n = o[0], i = o[1]
                        } else {
                            var a = t.axisMovement;
                            i = a[0], n = a[1]
                        }
                        return new MouseEvent(e, {
                            clientX: s.clientX + n,
                            clientY: s.clientY + i,
                            screenX: s.screenX + n,
                            screenY: s.screenY + i,
                            movementX: n,
                            movementY: i,
                            button: 0,
                            bubbles: !0,
                            cancelable: !0,
                            composed: !0
                        })
                    }

                    function g(t) {
                        e.containerNode().dispatchEvent(t)
                    }
                    o = function() {
                        h(), f(), v()
                    }
                },
                destroy: function() {
                    return o()
                }
            };
        return a
    }
    var Bi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleDotCarouselSettle", (function() {
                    e.updateDots()
                })), v(E(e), "_handleCarouselReInit", (function() {
                    e.embla.reInit(e._getOptions(), e._getPlugins())
                })), v(E(e), "_handleCarouselResize", (0, pi.debounce)((function() {
                    e.embla.reInit(e._getOptions(), e._getPlugins()), e.updateDots()
                }), 100)), v(E(e), "_handleCarouselSelect", (function() {
                    if (e._carousel) {
                        var t = S(e.embla.slideNodes()),
                            n = e._carousel.embla.selectedScrollSnap();
                        t.forEach((function(e) {
                            var t = +e.dataset.dotIndex === n;
                            e.classList.toggle("is-primary", t)
                        })), e.embla.scrollTo(n)
                    }
                })), v(E(e), "_getOptions", (function() {
                    return {
                        inViewThreshold: +(e.dataset.inViewThreshhold || 0) || .5,
                        containScroll: e.hasAttribute("data-contain-scroll") ? e.dataset.containScroll : "keepSnaps",
                        align: e.dataset.align || "center",
                        speed: e._getSpeed(),
                        skipSnaps: e.hasAttribute("data-skip-snaps"),
                        draggable: e.hasAttribute("is-draggable"),
                        axis: e._axis
                    }
                })), v(E(e), "_getPlugins", (function() {
                    var t = [],
                        n = oi();
                    if (t.push(n), e.hasAttribute("data-with-wheel-gestures")) {
                        var i = Pi({
                            forceWheelAxis: e._axis
                        });
                        t.push(i)
                    }
                    return t
                })), v(E(e), "scrollNext", (function() {
                    e._carousel && e._carousel.embla.scrollNext()
                })), v(E(e), "scrollPrev", (function() {
                    e._carousel && e._carousel.embla.scrollPrev()
                })), v(E(e), "canScrollNext", (function() {
                    return !!e._carousel && e._carousel.embla.canScrollNext()
                })), v(E(e), "canScrollPrev", (function() {
                    return !!e._carousel && e._carousel.embla.canScrollPrev()
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._init(), this.updateDots(), this._carousel && (this._carousel.embla.on("reInit", this._handleCarouselReInit), this._carousel.embla.on("select", this._handleCarouselSelect)), this.embla.on("resize", this._handleCarouselResize), this.embla.on("settle", this._handleDotCarouselSettle)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._carousel && (this._carousel.embla.off("reInit", this._handleCarouselReInit), this._carousel.embla.off("select", this._handleCarouselSelect)), this.embla.off("settle", this._handleDotCarouselSettle), this.embla.off("resize", this._handleCarouselResize), this.embla.destroy()
                }
            }, {
                key: "_getSpeed",
                value: function() {
                    return yn() ? 100 : 80
                }
            }, {
                key: "_init",
                value: function() {
                    var e = this.querySelector("[data-carousel-viewport]");
                    e && (this.embla = ei(e, this._getOptions(), this._getPlugins()))
                }
            }, {
                key: "updateDots",
                value: function() {
                    var e = S(this.embla.slideNodes()),
                        t = e.map((function(e, t) {
                            return t
                        })),
                        n = this.embla.slidesInView();
                    e.forEach((function(e, i) {
                        e.classList.remove("is-prev-prev");
                        var o = n[0],
                            a = n[n.length - 1],
                            r = t[0],
                            s = t[t.length - 1];
                        !(i === o) && !(i === a) || i === s || i === r || e.classList.add("is-prev-prev")
                    }))
                }
            }, {
                key: "_carousel",
                get: function() {
                    return this.closest("carousel-component")
                }
            }, {
                key: "_axis",
                get: function() {
                    return "vertical" === this.dataset.axis ? "y" : "x"
                }
            }]), n
        }(ee),
        Di = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleCarouselForceChangePlayState", (function() {
                    if (e._autoplayLoader && e._carousel) {
                        var t = e._carousel.forceStopped;
                        e._autoplayLoader.setAttribute("data-autoplay-stopped", t ? "true" : "false")
                    }
                })), v(E(e), "_handleCarouselChangePlayState", (function() {
                    e._updateAutoplayIndicator()
                })), v(E(e), "_handleDotClick", (function() {
                    e.scroll()
                })), v(E(e), "_handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e.scroll())
                })), e._autoplayLoader = e.querySelector("[data-autoplay-indicator]"), e._dotsCarousel = e.closest("carousel-dots"), e.dotIndex = +e.dataset.dotIndex, e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._updateAutoplayIndicator(), this._carousel && (customElements.upgrade(this._carousel), this._carousel.subscribe("changePlayState", this._handleCarouselChangePlayState), this._carousel.subscribe("forceChangePlayState", this._handleCarouselForceChangePlayState)), this.addEventListener("keydown", this._handleKeyDown), this.addEventListener("click", this._handleDotClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._carousel && (this._carousel.unsubscribe("changePlayState", this._handleCarouselChangePlayState), this._carousel.unsubscribe("forceChangePlayState", this._handleCarouselForceChangePlayState)), this.removeEventListener("keydown", this._handleKeyDown), this.removeEventListener("click", this._handleDotClick)
                }
            }, {
                key: "_updateAutoplayIndicator",
                value: function() {
                    if (this._carousel) {
                        var e = this._carousel.isPlay;
                        this._autoplayLoader && this._autoplayLoader.setAttribute("data-play-state", e ? "true" : "false")
                    }
                }
            }, {
                key: "scroll",
                value: function() {
                    this._carousel && (this._carousel.embla.scrollTo(this.dotIndex), this._carousel.forceStop())
                }
            }, {
                key: "_carousel",
                get: function() {
                    return this.closest("carousel-component")
                }
            }]), n
        }(ee),
        Oi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function() {
                    e.trigger()
                })), v(E(e), "_handleCarouselReInit", (function() {
                    e._update()
                })), v(E(e), "_handleCarouselSelect", (function() {
                    e._update()
                })), v(E(e), "_handleCarouselScroll", (0, pi.debounce)((function() {
                    e._update()
                }), 100)), v(E(e), "_handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e.trigger())
                })), v(E(e), "_updateDisabled", (function() {
                    e.toggleAttribute("disabled", !e._canScroll())
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._update(), this._carousel && (this._carousel.embla.on("reInit", this._handleCarouselReInit), this._carousel.embla.on("select", this._handleCarouselSelect), this._carousel.embla.on("scroll", this._handleCarouselScroll)), this.addEventListener("keydown", this._handleKeyDown), this.addEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._carousel && (this._carousel.embla.off("reInit", this._handleCarouselReInit), this._carousel.embla.off("select", this._handleCarouselSelect), this._carousel.embla.off("scroll", this._handleCarouselScroll)), this.removeEventListener("keydown", this._handleKeyDown), this.removeEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "_update",
                value: function() {
                    this._updateDisabled(), this._updateVisible()
                }
            }, {
                key: "_updateVisible",
                value: function() {
                    if (this._carousel) {
                        var e = S(Array(this._carousel.embla.slideNodes().length).keys()).length - 1,
                            t = this._carousel.embla.slidesInView(),
                            n = "next" === this.dataset.scrollDirection ? t.includes(e) : t.includes(0);
                        this.toggleAttribute("has-not-slides-not-in-view", n)
                    }
                }
            }, {
                key: "_canScroll",
                value: function() {
                    return !!this._carousel && ("next" === this.dataset.scrollDirection ? this._carousel.canScrollNext() : this._carousel.canScrollPrev())
                }
            }, {
                key: "trigger",
                value: function() {
                    if (this._carousel) {
                        var e = this._carousel,
                            t = e.scrollNext,
                            n = e.scrollPrev;
                        "next" === this.dataset.scrollDirection ? t() : n()
                    }
                }
            }, {
                key: "_carousel",
                get: function() {
                    var e = this.closest("carousel-dots"),
                        t = this.closest("carousel-component");
                    return e || t
                }
            }]), n
        }(ee),
        qi = Oi,
        Ri = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleProgress", (function() {
                    e.updateProgressBar()
                })), v(E(e), "_handleCarouselReInit", (function() {
                    e.updateProgressBar()
                })), e._eventSetProgress = "scroll" === e.dataset.target ? "scroll" : "settle", e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.updateProgressBar(), this._carousel && (this._carousel.embla.on(this._eventSetProgress, this._handleProgress), this._carousel.embla.on("reInit", this._handleCarouselReInit))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._carousel && (this._carousel.embla.off(this._eventSetProgress, this._handleProgress), this._carousel.embla.off("reInit", this._handleCarouselReInit))
                }
            }, {
                key: "updateProgressBar",
                value: function() {
                    var e = this.querySelector("[data-carousel-progress-indicator]");
                    if (e) {
                        var t = this.getProgress(),
                            n = "vertical" === this.dataset.axis;
                        e.style.transform = n ? "translate3d(0, ".concat(t, "%, 0)") : "translate3d(".concat(t, "%, 0, 0)")
                    }
                }
            }, {
                key: "getProgress",
                value: function() {
                    return "scroll" === this.dataset.target ? this.getProgressByScroll() : this.getProgressBySlideInView()
                }
            }, {
                key: "getProgressBySlideInView",
                value: function() {
                    if (!this._carousel) return 0;
                    var e = this._carousel.embla.slideNodes().length,
                        t = this._carousel.embla.slidesInView(),
                        n = t[t.length - 1] + 1,
                        i = 100 / e;
                    return Math.ceil(i * n)
                }
            }, {
                key: "getProgressByScroll",
                value: function() {
                    if (!this._carousel) return 0;
                    var e = this._carousel.embla.scrollProgress();
                    return 100 * Math.max(0, Math.min(1, e))
                }
            }, {
                key: "_carousel",
                get: function() {
                    return this.closest("carousel-component")
                }
            }]), n
        }(ee),
        Fi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleResize", (0, pi.debounce)((function() {
                    e._setHidden(!1), e.updatePosition();
                    var t = e._headerSection.getBoundingClientRect();
                    e.headerSectionBottom = t.bottom
                }), 100)), v(E(e), "_handleScroll", (function() {
                    mn() && e._updateVisibleAfterScroll(), e._setScrollStatus()
                })), v(E(e), "_handleDrodpownHide", (function() {
                    e.classList.remove("header--light-bordered")
                })), v(E(e), "_handleDropdownShow", (function() {
                    e.classList.add("header--light-bordered")
                })), e._lastScrollPosition = 0, e._resizeObserver = new ResizeObserver(e._handleResize), e._dropdowns = S(e.querySelectorAll("[data-header-dropdown]")), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this;
                    this._setSticky(), this.updatePosition(), K(window, "scroll", this._handleScroll), this._dropdowns.forEach((function(t) {
                        customElements.upgrade(t), t.subscribe("show", e._handleDropdownShow), t.subscribe("hide", e._handleDrodpownHide)
                    })), this._resizeObserver.observe(this)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    var e = this;
                    U(window, "scroll", this._handleScroll), this._dropdowns.forEach((function(t) {
                        t.unsubscribe("show", e._handleDropdownShow), t.unsubscribe("hide", e._handleDrodpownHide)
                    })), this._resizeObserver.disconnect()
                }
            }, {
                key: "_setScrollStatus",
                value: function() {
                    if (this._headerSection) {
                        var e = Math.abs(parseInt(document.body.style.top || "0")),
                            t = (window.scrollY || e) > this.headerSectionBottom;
                        this._headerSection.toggleAttribute("scrolled", t)
                    }
                }
            }, {
                key: "_updateVisibleAfterScroll",
                value: function() {
                    if (this._headerSection) {
                        var e = window.scrollY,
                            t = this._lastScrollPosition < e,
                            n = e > this.headerSectionBottom,
                            i = t && n;
                        this._setHidden(i), 0 !== e && (this._lastScrollPosition = e)
                    }
                }
            }, {
                key: "_setHidden",
                value: function(e) {
                    this._headerSection && this._headerSection.setAttribute("aria-hidden", e ? "true" : "false")
                }
            }, {
                key: "_setSticky",
                value: function() {
                    this._headerSection && (this._headerSection.setAttribute("mobile-sticky", ""), this._headerSection.toggleAttribute("desktop-sticky", this._isSticky))
                }
            }, {
                key: "updatePosition",
                value: function() {
                    if (this._headerSection) {
                        var e, t, n = this.getBoundingClientRect();
                        e = "header-bottom-side", t = "".concat(n.bottom, "px"), document.documentElement.style.setProperty("--gsc-".concat(e), t)
                    }
                }
            }, {
                key: "_isSticky",
                get: function() {
                    return this.hasAttribute("is-sticky")
                }
            }, {
                key: "_headerSection",
                get: function() {
                    return document.querySelector(".shopify-section-header")
                }
            }]), n
        }(ee),
        Ni = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleSectionLoad", (function() {})), v(E(e), "_handleSectionSelect", (function(t) {
                    var n = t.detail.sectionId;
                    e.isVisible && e.dataset.sectionId === n && (e.mount(), e.reset())
                })), v(E(e), "_handleSectionDeselect", (function(t) {
                    var n = t.detail.sectionId;
                    e.isVisible && e.dataset.sectionId === n && (e.reset(), e.hide(!0))
                })), v(E(e), "_handleBlockSelect", (function(t) {
                    var n = t.detail,
                        i = n.blockId,
                        o = n.sectionId;
                    if (e.dataset.sectionId === o) {
                        var a = e.pages.find((function(e) {
                            return e.getAttribute("block-id") === i
                        }));
                        if (!a) return;
                        e.open(), e.setPage(a)
                    }
                })), v(E(e), "_handleBlockDeselect", (function(t) {
                    var n = t.detail,
                        i = n.blockId,
                        o = n.sectionId;
                    if (e.dataset.sectionId === o) {
                        if (!e.pages.find((function(e) {
                                return e.getAttribute("block-id") === i
                            }))) return;
                        e.hide(!0)
                    }
                })), v(E(e), "handlePageKeydown", (function(t) {
                    var n = t.target,
                        i = n.closest("drawer-menu-page");
                    if (i) {
                        var o = i.querySelectorAll(Y()),
                            a = n === o[o.length - 1],
                            r = n === o[0],
                            s = t.shiftKey;
                        9 === t.keyCode && (s && r || !s && a) && (t.preventDefault(), e.focusOnToggler())
                    }
                })), e.header = document.querySelector("header-component"), e.pages = S(e.element.querySelectorAll("drawer-menu-page")), e.pageMap = e.generatePageMap(), e.homePage = e.pageMap.Menu, e.toggler = document.getElementById("DrawerMenuToggler"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this;
                    on(A(n.prototype), "connectedCallback", this).call(this), this.mountBlocks(), this.pages.forEach((function(t) {
                        t.addEventListener("keydown", e.handlePageKeydown)
                    })), this._isEditorMode && (this._editor.subscribe("BLOCK_SELECT", this._handleBlockSelect), this._editor.subscribe("BLOCK_DESELECT", this._handleBlockDeselect), this._editor.subscribe("SECTION_SELECT", this._handleSectionSelect), this._editor.subscribe("SECTION_DESELECT", this._handleSectionDeselect))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    var e = this;
                    on(A(n.prototype), "disconnectedCallback", this).call(this), this.pages.forEach((function(t) {
                        t.removeEventListener("keydown", e.handlePageKeydown)
                    })), this._isEditorMode && this._editor.destroy()
                }
            }, {
                key: "focusOnToggler",
                value: function() {
                    this.toggler && (this.toggler.focus(), this.hide())
                }
            }, {
                key: "generatePageMap",
                value: function() {
                    return this.pages.reduce((function(e, t) {
                        var n = t.dataset.pageId;
                        return n ? ce(m({}, e), v({}, n, t)) : e
                    }), {})
                }
            }, {
                key: "setPage",
                value: function(e) {
                    var t, n = e.dataset.pageId === (null === (t = this.openedPage) || void 0 === t ? void 0 : t.dataset.prevPageId),
                        i = e.hasAttribute("data-empty-menu");
                    this.openedPage && (n || i) && this.setPageVisible(this.openedPage, !1);
                    var o = e.querySelector(Y());
                    o && o.focus(), this.setPageVisible(e, !0), this.openedPage = e
                }
            }, {
                key: "reset",
                value: function() {
                    var e = this;
                    this.pages.forEach((function(t) {
                        e.setPageVisible(t, !1)
                    })), this.setPageVisible(this.homePage, !0), this.openedPage = this.homePage
                }
            }, {
                key: "setPageVisible",
                value: function(e, t) {
                    e.setAttribute("aria-hidden", t ? "false" : "true")
                }
            }, {
                key: "open",
                value: function() {
                    return this.header && this.header.updatePosition(), on(A(n.prototype), "open", this).call(this)
                }
            }, {
                key: "hide",
                value: function(e) {
                    return this.reset(), on(A(n.prototype), "hide", this).call(this, e)
                }
            }, {
                key: "mountBlocks",
                value: function() {
                    var e = this.element.querySelectorAll("[data-drawer-menu-target-block-id]"),
                        t = this.element.querySelector("#drawer-menu-blocks-template"),
                        n = fe(t);
                    e.forEach((function(e) {
                        var t = e.getAttribute("data-drawer-menu-target-block-id"),
                            i = n.querySelector('[data-drawer-menu-block-id="'.concat(t, '"]'));
                        i && (e.className = "".concat(e.className, " ").concat(i.className), e.innerHTML = i.innerHTML)
                    }))
                }
            }, {
                key: "getPage",
                value: function(e) {
                    return this.pageMap[e]
                }
            }, {
                key: "isVisible",
                get: function() {
                    var e = matchMedia("(max-width: 1016px)").matches;
                    return this.hasAttribute("data-drawer-menu-is-section") || e
                }
            }]), n
        }(vn),
        Hi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleBlockScroll", (function() {
                    if (e.block) {
                        var t = e.block.scrollTop > 0;
                        e.toggleAttribute("header-shadow-visible", t)
                    }
                })), e.block = e.querySelector("[data-drawer-menu-content]"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.block && this.block.addEventListener("scroll", this._handleBlockScroll)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.block && this.block.removeEventListener("scroll", this._handleBlockScroll)
                }
            }]), n
        }(ee),
        Vi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handlePageLinkClick", (function(t) {
                    t.preventDefault(), e.setPage()
                })), v(E(e), "_handleKeyUp", (function(t) {
                    t.preventDefault();
                    var n = t.key || t.keyCode;
                    Q(n) && e.setPage()
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this, "click", this._handlePageLinkClick), K(this, "keyup", this._handleKeyUp)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this, "click", this._handlePageLinkClick), U(this, "keyup", this._handleKeyUp)
                }
            }, {
                key: "setPage",
                value: function() {
                    var e = this.closest("drawer-menu"),
                        t = this.dataset.pageId;
                    if (t && e) {
                        var n = e.getPage(t);
                        n && e.setPage(n)
                    }
                }
            }]), n
        }(ee),
        zi = Vi,
        Ki = function() {
            "use strict";

            function e(t) {
                h(this, e), this._element = t
            }
            return p(e, [{
                key: "show",
                value: function() {
                    this._element.classList.remove("hidden")
                }
            }, {
                key: "hide",
                value: function() {
                    this._element.classList.add("hidden")
                }
            }]), e
        }(),
        Ui = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), (e = t.call(this)).cache = {}, e
            }
            return p(n, [{
                key: "updateTargetsFromHTML",
                value: function(e) {
                    if (this.dataset.containerId) {
                        var t = e.getElementById(this.dataset.containerId),
                            n = document.getElementById(this.dataset.containerId);
                        if (t && n) t.querySelectorAll(".".concat(this.dataset.target)).forEach((function(e) {
                            return n.appendChild(e)
                        }))
                    }
                }
            }, {
                key: "updateResultsFromHTML",
                value: function(e) {
                    if (this.dataset.containerId) {
                        var t = e.getElementById(this.dataset.containerId),
                            n = document.getElementById(this.dataset.containerId);
                        t && n && (n.innerHTML = t.innerHTML, n.scrollIntoView({
                            behavior: "smooth"
                        }))
                    }
                }
            }, {
                key: "updateFromHTML",
                value: function(e) {
                    var t = e.querySelector("pagination-component");
                    t && (this.innerHTML = t.innerHTML)
                }
            }, {
                key: "loadingOverlay",
                get: function() {
                    var e = document.getElementById(this.dataset.overlayId || "");
                    return new Ki(e)
                }
            }]), n
        }(ee),
        Wi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function() {
                    e._fetchResults()
                })), v(E(e), "_handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e._fetchResults())
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("keydown", this._handleKeyDown), this.addEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("keydown", this._handleKeyDown), this.removeEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "_fetchResults",
                value: function() {
                    var e = this,
                        t = this.dataset.url;
                    t && (this._setLoadingStatus(!0), fetch(t).then((function(e) {
                        return e.text()
                    })).then((function(t) {
                        var n = me(t);
                        e._setLoadingStatus(!1), e._updateFromHTML(n), e._updatePaginationFromHTML(n)
                    })).catch((function() {
                        C.notification && C.notification.show("Error in pagination load button component", "warning")
                    })))
                }
            }, {
                key: "_updatePaginationFromHTML",
                value: function(e) {
                    var t = this.closest("pagination-component");
                    t && (t.updateTargetsFromHTML(e), t.updateFromHTML(e))
                }
            }, {
                key: "_setPaginationUrl",
                value: function(e) {
                    this.dataset.url = e.dataset.url
                }
            }, {
                key: "_removePagination",
                value: function() {
                    var e = this.closest("pagination-component");
                    e && e.remove()
                }
            }, {
                key: "_updateFromHTML",
                value: function(e) {
                    var t = e.querySelector("pagination-load-button");
                    t ? this._setPaginationUrl(t) : this._removePagination()
                }
            }, {
                key: "_setLoadingStatus",
                value: function(e) {
                    this.toggleAttribute("disabled", e), this.classList.toggle("loading", e)
                }
            }]), n
        }(ee),
        Yi = Wi,
        ji = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleLinkClick", (function() {
                    e._fetchResults()
                })), v(E(e), "_handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e._fetchResults())
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("keydown", this._handleKeyDown), this.addEventListener("click", this._handleLinkClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("keydown", this._handleKeyDown), this.removeEventListener("click", this._handleLinkClick)
                }
            }, {
                key: "_fetchResults",
                value: function() {
                    var e = this.closest("pagination-component"),
                        t = this.dataset.url;
                    e && t && (e.cache[t] ? this._updatePaginationFromHTML(e.cache[t]) : this._getFromUrl(t))
                }
            }, {
                key: "_getFromUrl",
                value: function(e) {
                    var t = this,
                        n = this.closest("pagination-component");
                    n && (n.loadingOverlay.show(), fetch(e).then((function(e) {
                        return e.text()
                    })).then((function(i) {
                        var o = me(i);
                        n.loadingOverlay.hide(), n.cache[e] = o, t._updatePaginationFromHTML(o)
                    })).catch((function() {
                        C.notification && C.notification.show("Error in pagination link component", "warning")
                    })))
                }
            }, {
                key: "_updatePaginationFromHTML",
                value: function(e) {
                    var t = this.closest("pagination-component");
                    t && (t.updateResultsFromHTML(e), t.updateFromHTML(e))
                }
            }]), n
        }(ee),
        Xi = ji,
        Qi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleIntersectionObserve", (function(t) {
                    var n = e.dataset.url;
                    if (n) {
                        if (!t[0].isIntersecting) return;
                        e._preloaderComponent.show(), fetch(n).then((function(e) {
                            return e.text()
                        })).then((function(t) {
                            var n = me(t),
                                i = e.closest("pagination-component");
                            e._preloaderComponent.hide(), e._updateFromHTML(n), i && i.updateTargetsFromHTML(n)
                        })).catch((function() {
                            C.notification && C.notification.show("Error in infinite scroll component", "warning")
                        }))
                    }
                })), e._observerOptions = {
                    root: null,
                    rootMargin: "-35% 0px -35% 0px"
                }, e._preloaderSelector = ".loading-spinner", e._preloader = e.querySelector(e._preloaderSelector), e._preloaderComponent = new Ki(e._preloader), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._intersectionObserver = new IntersectionObserver(this._handleIntersectionObserve, this._observerOptions), this._intersectionObserver.observe(this)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._intersectionObserver.disconnect()
                }
            }, {
                key: "_updateFromHTML",
                value: function(e) {
                    var t = e.querySelector("pagination-infinite-scroll");
                    if (t) {
                        var n = t.dataset.url;
                        n ? this._setPaginationUrl(n) : this._intersectionObserver.unobserve(this)
                    }
                }
            }, {
                key: "_setPaginationUrl",
                value: function(e) {
                    this.dataset.url = e
                }
            }]), n
        }(ee),
        Gi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleCarouselSelect", (function() {
                    e._removeVideo()
                })), v(E(e), "_handlePosterClick", (function() {
                    e.loadContent()
                })), e._poster = e.querySelector('[id^="Deferred-Poster-"]'), e._carousel = e.closest("carousel-component"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.hasAttribute("data-autoplay") && this.loadContent(), K(this._poster, "click", this._handlePosterClick), this._carousel && this._carousel.embla.on("select", this._handleCarouselSelect)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this._poster, "click", this._handlePosterClick), this._carousel && this._carousel.embla.off("select", this._handleCarouselSelect)
                }
            }, {
                key: "loadContent",
                value: function() {
                    this.getAttribute("loaded") || (this._addVideo(), this.setAttribute("loaded", "true"))
                }
            }, {
                key: "_removeVideo",
                value: function() {
                    var e = this.querySelector("video,  iframe");
                    e && (e.remove(), this.removeAttribute("loaded"))
                }
            }, {
                key: "_addVideo",
                value: function() {
                    var e = document.createElement("div"),
                        t = this.querySelector("template"),
                        n = null == t ? void 0 : t.content;
                    if (n && n.firstElementChild) {
                        var i = n.firstElementChild.cloneNode(!0);
                        e.appendChild(i);
                        var o = e.querySelector("video, model-viewer, iframe");
                        o && (this.appendChild(o), "VIDEO" === o.tagName && o.play())
                    }
                }
            }]), n
        }(ee),
        Zi = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                return h(this, n), t.apply(this, arguments)
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.fetchAvailability()
                }
            }, {
                key: "fetchAvailability",
                value: function() {
                    var e = this,
                        t = "".concat(this.dataset.baseUrl, "variants/").concat(this.dataset.variantId, "/?section_id=pickup-availability");
                    fetch(t).then((function(e) {
                        return e.text()
                    })).then((function(t) {
                        var n = me(t).querySelector(".shopify-section");
                        e.updateSidebarFromHTML(n), e.updateContentFromHTML(n)
                    })).catch((function() {
                        C.notification && C.notification.show("Error in pickup availability component", "warning")
                    }))
                }
            }, {
                key: "updateVariantId",
                value: function(e) {
                    this.dataset.variantId = e
                }
            }, {
                key: "updateContentFromHTML",
                value: function(e) {
                    var t = this.querySelector("pickup-availability-content"),
                        n = e.querySelector("pickup-availability-content");
                    t && n && (t.innerHTML = n.innerHTML)
                }
            }, {
                key: "updateSidebarFromHTML",
                value: function(e) {
                    var t = document.querySelector("#pickup-availability-sidebar"),
                        n = e.querySelector("#pickup-availability-sidebar template");
                    t && n && t.updateTemplate(n)
                }
            }]), n
        }(ee),
        Ji = Zi,
        $i = function() {
            "use strict";

            function e(t) {
                h(this, e), this._element = t, this._text = this._element.querySelector("[data-button-text]")
            }
            return p(e, [{
                key: "setDisable",
                value: function(e) {
                    this._element.toggleAttribute("disabled", e)
                }
            }, {
                key: "setLoading",
                value: function(e) {
                    this._element.classList.toggle("loading", e)
                }
            }, {
                key: "setText",
                value: function(e) {
                    this._text && (this._text.textContent = e)
                }
            }]), e
        }(),
        eo = window.routes,
        to = function() {
            "use strict";

            function e() {
                h(this, e)
            }
            return p(e, [{
                key: "change",
                value: function(e) {
                    return fetch(eo.cart_change_url, e).then((function(e) {
                        return e.text()
                    }))
                }
            }, {
                key: "add",
                value: function(e) {
                    console.log(e)
                    return fetch(eo.cart_add_url, e).then((function(e) {
                        return e.text()
                    }))
                }
            }, {
                key: "update",
                value: function(e) {
                    return fetch("".concat(eo.cart_update_url), e)
                }
            }, {
                key: "get",
                value: function() {
                    return fetch(eo.cart_url).then((function(e) {
                        return e.text()
                    }))
                }
            }]), e
        }(),
        no = function() {
            return {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/".concat(arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "json")
                }
            }
        },
        io = function(e) {
            var t = {},
                n = new FormData(e),
                i = !0,
                o = !1,
                a = void 0;
            try {
                for (var r, s = n.keys()[Symbol.iterator](); !(i = (r = s.next()).done); i = !0) {
                    var c = r.value,
                        l = /(?:^(properties\[))(.*?)(?:\]$)/;
                    l.test(c) ? (t.properties = t.properties || {}, t.properties[l.exec(c)[2]] = n.get(c)) : t[c] = n.get(c)
                }
            } catch (e) {
                o = !0, a = e
            } finally {
                try {
                    i || null == s.return || s.return()
                } finally {
                    if (o) throw a
                }
            }
            return JSON.stringify(t)
        },
        oo = new(function() {
            "use strict";

            function e(t) {
                var n = this;
                h(this, e), v(this, "requestProductFromUrl", (function(e, t) {
                    n._element && n._element.requestProductFromUrl(e, t)
                })), v(this, "openAndRenderProductByUrl", (function(e) {
                    n._element && n._element.openAndRenderProductByUrl(e)
                })), this._element = document.querySelector("#".concat(t))
            }
            return p(e, [{
                key: "hide",
                value: function() {
                    return this._element ? this._element.hide() : V()
                }
            }, {
                key: "isOpen",
                get: function() {
                    return !!this._element && this._element.isOpen
                }
            }]), e
        }())("Quick-view"),
        ao = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleFormSubmit", (function(t) {
                    t.preventDefault();
                    var n = e._getQueryConfig();
                    window.customSetCookie();
                    e.setDisable(!0), e.setLoading(!0), e._cartApi.add(n).then((function(t) {
                        var n = JSON.parse(t);
                        if (e.setDisable(!1), e.setLoading(!1), n.description) {
                            if (!C.notification) return;
                            var i = Object.keys(n.description).map((function(e) {
                                return "".concat(e, ": ").concat(n.description[e])
                            })).join(" , ");
                            C.notification.show(n.description, "warning")
                        } else {
                            if (e.cart) return e._cartApi.get();
                            e.sidebar ? e.updateSidebarCartByParsedState(n) : e.updatePopupByParsedState(n)
                        }
                    })).then((function(t) {
                        if (e.cart && t) {
                            var n = me(t);
                            e.updateCartByHTML(n)
                        }
                    })).catch((function() {
                        C.notification && C.notification.show("Error in product form component", "warning")
                    }))
                })), e.sidebar = document.querySelector("#sidebar-component-for-cart"), e.cart = document.querySelector("#cart-page-component"), e.cartNotificationPopup = document.querySelector("#CartNotificationPopup"), e.formSelector = "form", e.variantInputSelector = "[data-product-form-variant]", e.form = e.querySelector(e.formSelector), e.form && (e.variantInput = e.form.querySelector(e.variantInputSelector)), e._cartApi = new to, e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this.form, "submit", this._handleFormSubmit)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this.form, "submit", this._handleFormSubmit)
                }
            }, {
                key: "updateCartByHTML",
                value: function(e) {
                    this.cart && (this.cart.updateByHTML(e), this.cart.updateEmptyStatus(!1), this.showCallbackAfterCloseDialogWindow((function() {})))
                }
            }, {
                key: "updateSidebarCartByParsedState",
                value: function(e) {
                    var t = this;
                    if (this.sidebar) {
                        this.sidebar.updateEmptyStatus(!1);
                        this.showCallbackAfterCloseDialogWindow((function() {
                            t.sidebar && t.sidebar.purchaseHandler(e)
                        }))
                    }
                }
            }, {
                key: "updatePopupByParsedState",
                value: function(e) {
                    var t = this;
                    this.showCallbackAfterCloseDialogWindow((function() {
                        t.cartNotificationPopup && t.cartNotificationPopup.showProductFromParsedState(e, e.id)
                    }))
                }
            }, {
                key: "showCallbackAfterCloseDialogWindow",
                value: function(e) {
                    return V(0).then((function() {
                        oo.isOpen || e(), oo.isOpen && oo.hide().then(e)
                    }))
                }
            }, {
                key: "_getFormData",
                value: function() {
                    return JSON.parse(io(this.form))
                }
            }, {
                key: "_getQueryConfig",
                value: function() {
                    var e = no("javascript"),
                        t = ["cart-count", this.sidebar ? this.sidebar.sectionId : "cart-drawer", "cart-notification-popup-content"];
                    return e.headers["X-Requested-With"] = "XMLHttpRequest", e.body = JSON.stringify(ce(m({}, this._getFormData()), {
                        sections: t,
                        sections_url: window.location.pathname
                    })), e
                }
            }, {
                key: "setLoading",
                value: function(e) {
                    this.querySelectorAll('button[type="submit"]').forEach((function(t) {
                        new $i(t).setLoading(e)
                    }))
                }
            }, {
                key: "setDisable",
                value: function(e) {
                    this.querySelectorAll('button[type="submit"]').forEach((function(t) {
                        new $i(t).setDisable(e)
                    }))
                }
            }, {
                key: "setButtonText",
                value: function(e) {
                    this.querySelectorAll('button[type="submit"]').forEach((function(t) {
                        new $i(t).setText(e)
                    }))
                }
            }]), n
        }(ee),
        ro = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleWindowScroll", (function() {
                    if (e.button && e.form) {
                        var t = window.scrollY,
                            n = e.form.offsetTop + e.form.offsetHeight,
                            i = e.footer ? e.footer.offsetTop : 0,
                            o = window.innerHeight + t < i && t > n;
                        e.toggleAttribute("visible", o), document.body.toggleAttribute("is-product-form-button-fixed", o)
                    }
                })), e.button = e.querySelector("[data-product-form-button]"), e.footer = document.querySelector(".shopify-section.shopify-section-footer"), e.form = e.closest("product-form"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    window.addEventListener("scroll", this._handleWindowScroll)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    window.removeEventListener("scroll", this._handleWindowScroll)
                }
            }]), n
        }(ee),
        so = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), (e = t.call(this)).blockSelector = "[data-product-block-item]", e.containerSelector = "[data-product-block-container]", e.activeTemplate = e.querySelector(e.blockSelector), e.activeTemplateContainer = e.querySelector(e.containerSelector), e
            }
            return p(n, [{
                key: "updateByVariantId",
                value: function(e) {
                    var t = this.querySelector('[data-product-block-template="'.concat(e, '"]'));
                    if (this.activeTemplate && this.activeTemplateContainer) {
                        var n = pe(t);
                        n && (this.activeTemplate.remove(), this.activeTemplate = n, this.activeTemplateContainer.appendChild(n))
                    }
                }
            }]), n
        }(ee),
        co = window.Shopify,
        lo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handlePosterClick", (function() {
                    e._loadContent()
                })), v(E(e), "_handleCarouselSelect", (function() {
                    e._carousel && e._setCarouselDraggable(!0)
                })), e._poster = e.querySelector('[id^="Deferred-Poster-"]'), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this._poster, "click", this._handlePosterClick), this._carousel && this._carousel.embla.on("select", this._handleCarouselSelect)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this._poster, "click", this._handlePosterClick), this._carousel && this._carousel.embla.off("select", this._handleCarouselSelect)
                }
            }, {
                key: "_loadContent",
                value: function() {
                    this.getAttribute("loaded") || (this._addModel(), this.setAttribute("loaded", !0), this._carousel && this._setCarouselDraggable(!1)), co.loadFeatures([{
                        name: "model-viewer-ui",
                        version: "1.0",
                        onLoad: this.setupModelViewerUI.bind(this)
                    }])
                }
            }, {
                key: "_addModel",
                value: function() {
                    var e = this.querySelector("template");
                    if (e && e.content) {
                        var t = e.content,
                            n = document.createElement("div");
                        n.appendChild(t.firstElementChild.cloneNode(!0));
                        var i = n.querySelector("model-viewer");
                        this.appendChild(i)
                    }
                }
            }, {
                key: "setupModelViewerUI",
                value: function(e) {
                    e || (this.modelViewerUI = new co.ModelViewerUI(this.querySelector("model-viewer")))
                }
            }, {
                key: "_setCarouselDraggable",
                value: function(e) {
                    var t = this.querySelector(".shopify-model-viewer-ui");
                    this._carousel.dataset.draggable = e ? "true" : "false", this._carousel.reInit(), e && t && (t.remove(), this.removeAttribute("loaded"))
                }
            }, {
                key: "_carousel",
                get: function() {
                    return this.closest("carousel-component")
                }
            }]), n
        }(ee);
    window.ProductModel = {
        loadShopifyXR: function() {
            co.loadFeatures([{
                name: "shopify-xr",
                version: "1.0",
                onLoad: this.setupShopifyXR.bind(this)
            }])
        },
        setupShopifyXR: function(e) {
            var t = this;
            e || (window.ShopifyXR ? (document.querySelectorAll('[id^="ProductJSON-"]').forEach((function(e) {
                window.ShopifyXR.addModels(JSON.parse(e.textContent)), e.remove()
            })), window.ShopifyXR.setupXRElements()) : document.addEventListener("shopify_xr_initialized", (function() {
                return t.setupShopifyXR()
            })))
        }
    }, window.addEventListener("DOMContentLoaded", (function() {
        co.designMode && document.querySelectorAll("[data-shopify-xr-hidden]").forEach((function(e) {
            return e.classList.add("hidden")
        })), window.ProductModel && window.ProductModel.loadShopifyXR()
    }));
    var uo = function() {
            "use strict";

            function e(t) {
                h(this, e), this.element = t
            }
            return p(e, [{
                key: "show",
                value: function() {
                    var e = this;
                    this.element.classList.remove("hidden"), V(2500).then((function() {
                        e.element.classList.add("hidden")
                    }))
                }
            }]), e
        }(),
        ho = function() {
            "use strict";

            function e(t) {
                h(this, e), this.element = t
            }
            return p(e, [{
                key: "setDisable",
                value: function(e) {
                    this.element.setDisable(e)
                }
            }]), e
        }(),
        fo = function() {
            "use strict";

            function e(t) {
                h(this, e), this.element = t
            }
            return p(e, [{
                key: "setLoading",
                value: function(e) {
                    this.element.toggleAttribute("is-loading", e)
                }
            }]), e
        }(),
        po = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "removeFromCart", (function() {
                    e.expand().then((function() {
                        return e.collapse()
                    })).then((function() {
                        return e.remove()
                    }))
                })), v(E(e), "expand", (function() {
                    return e._setMaxHeight(e.scrollHeight), V(e._transitionDuration)
                })), v(E(e), "collapse", (function() {
                    return e._setMaxHeight(0), V(e._transitionDuration)
                })), v(E(e), "showCheckmark", (function() {
                    var t = e.querySelector(e._checkmarkSelector);
                    t && new uo(t).show()
                })), v(E(e), "setLoading", (function(t) {
                    var n = e.querySelector(e._totalsSelector);
                    n && new fo(n).setLoading(t)
                })), v(E(e), "_handleCartItemResize", (function() {
                    e._setMaxHeight(e.scrollHeight)
                })), e._checkmarkSelector = "[data-cart-item-checkmark]", e._bodySelector = "[data-cart-item-body]", e._totalsSelector = "[data-cart-item-totals]", e._quantitySelector = "[data-cart-item-quantity]", e.styles = getComputedStyle(E(e)), e.resizeObserver = new ResizeObserver(e._handleCartItemResize), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this.querySelector(this._bodySelector);
                    e && this.resizeObserver.observe(e)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.resizeObserver.disconnect()
                }
            }, {
                key: "_setMaxHeight",
                value: function(e) {
                    this.style.maxHeight = "".concat(e, "px")
                }
            }, {
                key: "setQuantityDisabled",
                value: function(e) {
                    var t = this.querySelector(this._quantitySelector);
                    t && new ho(t).setDisable(e)
                }
            }, {
                key: "_transitionDuration",
                get: function() {
                    return 1e3 * parseFloat(this.styles.transitionDuration)
                }
            }]), n
        }(ee),
        vo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleCartItemChange", (function(t) {
                    var n = e.querySelector("#CartItem-".concat(+t.target.dataset.index));
                    n && n.setLoading(!0)
                })), v(E(e), "_handleCartChange", (0, pi.debounce)((function(t) {
                    e.updateItem(+t.target.dataset.index, t.target.value)
                }), 500)), e._cartApi = new to, e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this, "change", this._handleCartChange), K(this, "change", this._handleCartItemChange)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this, "change", this._handleCartChange), U(this, "change", this._handleCartItemChange)
                }
            }, {
                key: "getConfigByItemIndexAndQuantity",
                value: function(e, t) {
                    return ce(m({}, no()), {
                        body: JSON.stringify({
                            line: e + 1,
                            quantity: t
                        })
                    })
                }
            }, {
                key: "updateItem",
                value: function(e, t) {
                    var n = this,
                        i = this.getConfigByItemIndexAndQuantity(e, t),
                        o = this.querySelector("#CartItem-".concat(e));
                    if (o) {
                        var a = +t; + (o.dataset.quantity || 0) !== a ? (0 === a && (this.updateEmptyStatus(1 === this._cartItemCount), o.removeFromCart()), this.setButtonLoading(!0), o.setQuantityDisabled(!0), this._cartApi.change(i).then((function() {
                            return n._cartApi.get()
                        })).then((function(e) {
                            var t = me(e);
                            n.setButtonLoading(!1), o.setQuantityDisabled(!1), o.setLoading(!1), n.updateByHTML(t)
                        })).catch((function() {
                            n._showError()
                        }))) : o.setLoading(!1)
                    }
                }
            }, {
                key: "_showError",
                value: function() {
                    if (C.notification) {
                        var e = window.cartStrings;
                        C.notification.show(e.error, "warning")
                    }
                }
            }, {
                key: "updateEmptyStatus",
                value: function(e) {
                    this._updateCartEmptyStatus(e), this._updateSubtotalEmptyStatus(e)
                }
            }, {
                key: "_updateCartEmptyStatus",
                value: function(e) {
                    this.classList.toggle("is-empty", e)
                }
            }, {
                key: "_updateSubtotalEmptyStatus",
                value: function(e) {
                    var t = document.getElementById(this.sectionIds.local.subtotal);
                    t && t.classList.toggle("is-empty", e)
                }
            }, {
                key: "updateByHTML",
                value: function(e) {
                    this.updateFreeShippingBarByHTML(e), ["#".concat(this.sectionIds.local.cartItems, " [data-cart-page-items]"), "#CartCount", "#StickyCartCount", "#".concat(this.sectionIds.local.subtotal, " [data-cart-page-subtotal-price]")].forEach((function(t) {
                        var n = document.querySelector(t),
                            i = e.querySelector(t);
                        n && i && (n.innerHTML = i.innerHTML)
                    }))
                }
            }, {
                key: "updateFreeShippingBarByHTML",
                value: function(e) {
                    var t = "#".concat(this.sectionIds.local.cartItems, " [data-cart-page-free-shipping-bar] cart-free-shipping-bar"),
                        n = document.querySelector(t),
                        i = e.querySelector(t);
                    if (n && i) {
                        var o = j(i),
                            a = i.dataset.cartTotal || 0;
                        n.updateProgressByCartTotal(+a), X(o)
                    }
                }
            }, {
                key: "setButtonLoading",
                value: function(e) {
                    var t = document.getElementById(this.sectionIds.local.subtotal);
                    if (t) {
                        var n = t.querySelector("[data-cart-page-checkout-button]");
                        n && (n.toggleAttribute("disabled", e), n.classList.toggle("loading", e))
                    }
                }
            }, {
                key: "_cartItemCount",
                get: function() {
                    return this.querySelectorAll("cart-item").length
                }
            }, {
                key: "sectionIds",
                get: function() {
                    return {
                        local: {
                            subtotal: "CartPage-SubtotalSection",
                            cartItems: "CartPage-CartItemsSection"
                        }
                    }
                }
            }]), n
        }(ee),
        mo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleCartItemChange", (function(t) {
                    var n = e.querySelector("#CartItem-".concat(+t.target.dataset.index));
                    n && n.setLoading(!0)
                })), v(E(e), "_handleCartChange", (0, pi.debounce)((function(t) {
                    e.updateItem(+t.target.dataset.index, t.target.value)
                }), 500)), v(E(e), "_handleViewportScroll", (function() {
                    if (e.viewport) {
                        var t = e.checkContentOverflow(),
                            n = e.viewport.scrollTop > 0;
                        e.toggleAttribute("header-shadow-visible", t && n)
                    }
                })), v(E(e), "_handleContentResultsResize", (function() {
                    e.updateViewport()
                })), e.sectionId = e.dataset.sectionId || "cart-drawer", e._sections = ["cart-count", e.sectionId], e.resultsSelector = "[data-sidebar-cart-results]", e.viewportSelector = "[data-sidebar-cart-viewport]", e.headerSelector = "[data-sidebar-cart-header]", e.footerSelector = "[data-sidebar-cart-footer]", e.viewport = e.element.querySelector(e.viewportSelector), e.results = e.element.querySelector(e.resultsSelector), e.header = e.element.querySelector(e.headerSelector), e.footer = e.element.querySelector(e.footerSelector), e._cartApi = new to, e._resizeObserver = new ResizeObserver(e._handleContentResultsResize), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    on(A(n.prototype), "connectedCallback", this).call(this), K(this, "change", this._handleCartChange), K(this, "change", this._handleCartItemChange), this.viewport && this.viewport.addEventListener("scroll", this._handleViewportScroll), this.results && this._resizeObserver.observe(this.results)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    on(A(n.prototype), "disconnectedCallback", this).call(this), U(this, "change", this._handleCartChange), U(this, "change", this._handleCartItemChange), this.viewport && this.viewport.removeEventListener("scroll", this._handleViewportScroll), this._resizeObserver.disconnect()
                }
            }, {
                key: "updateItem",
                value: function(e, t) {
                    var n = this,
                        i = this.querySelector("#CartItem-".concat(e)),
                        o = this.element.querySelector("[data-cart-checkout-button]");
                    if (i && o) {
                        var a = this._getQueryConfig(e, t),
                            r = new $i(o),
                            s = +t; + (i.dataset.quantity || 0) !== s || selling_plan ? (r.setLoading(!0), r.setDisable(!0), i.setQuantityDisabled(!0), 0 === s && (this.updateEmptyStatus(1 === this._cartItemCount), i.removeFromCart()), this._cartApi.change(a).then((function(e) {
                            var t = JSON.parse(e);
                            r.setLoading(!1), r.setDisable(!1), i.setLoading(!1), i.setQuantityDisabled(!1), n.updateByParsedState(t)
                        })).catch((function() {
                            n._showError()
                        }))) : i.setLoading(!1)
                    }
                }
            }, {
                key: "updateCustomItem",
                value: function(e, t, selling_plan) {
                    var n = this,
                        i = this.querySelector("#CartItem-".concat(e)),
                        o = this.element.querySelector("[data-cart-checkout-button]");
                    if (i && o) {
                        var a = this._getCustomQueryConfig(e, t, selling_plan),
                            r = new $i(o),
                            s = +t; true ? (r.setLoading(!0), r.setDisable(!0), i.setQuantityDisabled(!0), 0 === s && (this.updateEmptyStatus(1 === this._cartItemCount), i.removeFromCart()), this._cartApi.change(a).then((function(e) {
                            var t = JSON.parse(e);
                            r.setLoading(!1), r.setDisable(!1), i.setLoading(!1), i.setQuantityDisabled(!1), n.updateByParsedState(t)
                        })).catch((function() {
                            n._showError()
                        }))) : i.setLoading(!1)
                    }
                }
            }, {
                key: "updateViewport",
                value: function() {
                    var e = this.checkContentOverflow();
                    this.toggleAttribute("footer-shadow-visible", e)
                }
            }, {
                key: "checkContentOverflow",
                value: function() {
                    return !(!this.results || !this.viewport) && this.results.offsetHeight > this.viewport.offsetHeight
                }
            }, {
                key: "_showError",
                value: function() {
                    var e = this.querySelector("#SidebarCartNotification");
                    if (e) {
                        var t = new w(e),
                            n = window.cartStrings;
                        t.show(n.error, "warning")
                    }
                }
            }, {
                key: "updateByParsedState",
                value: function(e) {
                    var t = me(e.sections[this.sectionId]).querySelector("#CartInSidebar"),
                        n = pe(t),
                        i = j(n);
                    this.mount(), this.updateHeaderFromNode(n), this.updateFreeShippingBarFromNode(n), this.updateCartItemsFromNode(n), this.updateFooterFromNode(n), this._updateCartCountInHeader(e), X(i)
                }
            }, {
                key: "purchaseHandler",
                value: function(e) {
                    var t = this,
                        n = me(e.sections[this.sectionId]).querySelector("#CartInSidebar"),
                        i = pe(n),
                        o = j(i);
                    this.mount(), this.updateHeaderFromNode(i), this.updateCartItemsFromNode(i), this.updateFooterFromNode(i), this._updateCartCountInHeader(e), X(o);
                    var a = this.element.querySelector('cart-item[data-variant-id="'.concat(e.id, '"]'));
                    a && (1 === e.quantity ? a.collapse().then((function() {
                        return t.open()
                    })).then((function() {
                        return a.expand()
                    })).then((function() {
                        t.updateFreeShippingBarFromNode(i), a.showCheckmark()
                    })) : this.open().then((function() {
                        t.updateFreeShippingBarFromNode(i), a.showCheckmark()
                    })))
                }
            }, {
                key: "updateHeaderFromNode",
                value: function(e) {
                    this.updateElementBySelectorFromNode("[data-sidebar-cart-header]", e)
                }
            }, {
                key: "updateEmptyStatus",
                value: function(e) {
                    this.toggleAttribute("is-empty", e)
                }
            }, {
                key: "updateFooterFromNode",
                value: function(e) {
                    this.updateElementBySelectorFromNode("[data-sidebar-cart-footer]", e)
                }
            }, {
                key: "updateCartItemsFromNode",
                value: function(e) {
                    this.updateElementBySelectorFromNode("[data-sidebar-cart-items]", e)
                }
            }, {
                key: "updateFreeShippingBarFromNode",
                value: function(e) {
                    var t = "[data-sidebar-cart-free-shipping-bar] cart-free-shipping-bar",
                        n = this.element.querySelector(t),
                        i = e.querySelector(t);
                    if (n && i) {
                        var o = i.dataset.cartTotal || 0;
                        n.updateProgressByCartTotal(+o)
                    }
                }
            }, {
                key: "updateElementBySelectorFromNode",
                value: function(e, t) {
                    var n = t.querySelector(e),
                        i = this.element.querySelector(e);
                    i && n && (i.innerHTML = n.innerHTML)
                }
            }, {
                key: "_updateCartCountInHeader",
                value: function(e) {
                    var t = me(e.sections["cart-count"]),
                        n = document.getElementById("CartCount"),
                        i = document.getElementById("StickyCartCount"),
                        o = t.querySelector("#CartCount");
                    i && o && (i.innerHTML = o.innerHTML), n && o && (n.innerHTML = o.innerHTML)
                }
            }, {
                key: "_getQueryConfig",
                value: function(e, t) {
                    return ce(m({}, no()), {
                        body: JSON.stringify({
                            line: e + 1,
                            quantity: t,
                            sections: this._sections,
                            sections_url: window.location.pathname
                        })
                    })
                }
            }, {
                key: "_getCustomQueryConfig",
                value: function(e, t, selling_plan) {
                    const data = {
                        line: e + 1,
                        quantity: t,
                        sections: this._sections,
                        sections_url: window.location.pathname
                    }
                    if (selling_plan) {
                        data.selling_plan = selling_plan
                    }
                    return ce(m({}, no()), {
                        body: JSON.stringify(data)
                    })
                }
            }, {
                key: "_cartItemCount",
                get: function() {
                    return this.element.querySelectorAll("cart-item").length
                }
            }]), n
        }(vn),
        yo = window.Shopify,
        go = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "setProgress", (function(t) {
                    e.style.setProperty("--gsc-free-shipping-progress", "".concat(t, "%"))
                })), v(E(e), "setMessage", (function(t) {
                    var n = e.querySelector(e.messageNodeSelector);
                    n && (n.innerHTML = t)
                })), e.messageNodeSelector = "[data-cart-free-shipping-bar-message]", e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this.dataset.cartTotal || 0;
                    this.updateProgressByCartTotal(+e)
                }
            }, {
                key: "updateProgressByCartTotal",
                value: function(e) {
                    var t = this.dataset.currencyFormat || "",
                        n = +(this.dataset.threshold || 0),
                        i = +yo.currency.rate,
                        o = this.dataset.progressMessage || "",
                        a = this.dataset.achievedMessage || "",
                        r = n * i,
                        s = +(r - e).toFixed(2),
                        c = r / 100;
                    if (s > 0) {
                        var l = t.replace(/{{.+?}}/g, "".concat(s));
                        this.setMessage(o.replace("[value]", l)), this.setProgress(e / c)
                    } else this.setMessage(a), this.setProgress(100)
                }
            }]), n
        }(ee),
        _o = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                return h(this, n), t.apply(this, arguments)
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.setReady()
                }
            }, {
                key: "updateFirstMediaByVariant",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if (e && e.featured_media) {
                        var n = this.querySelector('[data-media-id="'.concat(e.featured_media.id, '"]'));
                        n && n.scrollIntoView({
                            behavior: t ? "auto" : "smooth"
                        })
                    }
                }
            }, {
                key: "setReady",
                value: function() {
                    this.setAttribute("ready", "")
                }
            }]), n
        }(ee),
        bo = _o,
        ko = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), (e = t.call(this)).carouselSelector = "[data-product-media-carousel-component]", e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.setReady()
                }
            }, {
                key: "updateFirstMediaByVariant",
                value: function(e) {
                    var t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1],
                        n = this.querySelector(this.carouselSelector);
                    if (e && e.featured_media && n) {
                        var i = n.embla.slideNodes().findIndex((function(t) {
                            return !!t.dataset.mediaId && +t.dataset.mediaId == +e.featured_media.id
                        }));
                        n.embla.scrollTo(i, t)
                    }
                }
            }, {
                key: "setReady",
                value: function() {
                    this.setAttribute("ready", "")
                }
            }]), n
        }(ee),
        So = ko,
        wo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleVariantChange", (function() {
                    e._updateForm(), e._setInventoryStatusAvailable(e.variant), e.variant ? (e._form.setDisable(!0), e._form.setLoading(!0), e._pickupAvailability && e._updatePickupAvailability(), e._updateURL(), e._updateVariantInput(), e._updateProduct(), e._updateFirstMediaByVariant(e.variant)) : e._setButtonsUnavailable()
                })), v(E(e), "_handleLabelFocus", (function(t) {
                    var n = t.target.getAttribute("for");
                    e.querySelector('input[id="'.concat(n, '"]')).dispatchEvent(new MouseEvent("click", {
                        button: 0,
                        which: 1
                    })), document.addEventListener("keydown", e._handleLabelKeydown)
                })), v(E(e), "_handleLabelKeydown", (function(t) {
                    var n = t.target.closest("[data-variant-picker-option-labels]");
                    if ("ArrowLeft" === t.key || "ArrowRight" === t.key || "ArrowUp" === t.key || "ArrowDown" === t.key)
                        if (n) {
                            var i = S(n.querySelectorAll("label")),
                                o = i.findIndex((function(e) {
                                    return e === t.target
                                })),
                                a = i[o],
                                r = i[0],
                                s = i[i.length - 1],
                                c = i[o + 1],
                                l = i[o - 1];
                            1 !== i.length && t.preventDefault();
                            var u = function(e) {
                                    a.removeAttribute("tabindex"), e.setAttribute("tabindex", 0), e.focus()
                                },
                                d = function() {
                                    u(c || r)
                                },
                                h = function() {
                                    u(l || s)
                                };
                            (0, {
                                ArrowLeft: h,
                                ArrowRight: d,
                                ArrowUp: h,
                                ArrowDown: d
                            }[t.key])()
                        } else document.removeEventListener("keydown", e._handleLabelKeydown)
                })), e._pickupAvailability = document.getElementById("product-pickup-availability-".concat(e.dataset.productId, "-").concat(e.dataset.section)), e._elements = ["sticky-product-buy-btn", "product-buy-btn", "product-quantity"], e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this;
                    this._updateVariant(), setTimeout((function() {
                        e._updateOptionsAvailable(), e.setFocusListeners()
                    }), 100), this.dataset.selectedVariantId && this._updateFirstMediaByVariant(this.variant, !0), K(this, "change", this._handleVariantChange)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this, "change", this._handleVariantChange)
                }
            }, {
                key: "_updateLabels",
                value: function() {
                    var e = this,
                        t = this.querySelectorAll("[data-variant-picker-option-inputs]"),
                        n = this.querySelectorAll("[data-variant-picker-option-labels]");
                    t.forEach((function(t, i) {
                        var o = S(n[i].querySelectorAll("label")),
                            a = S(t.querySelectorAll("input")),
                            r = e.getCheckedInput(a),
                            s = n[i].querySelector("[data-dropdown-variant-picker-label]");
                        o.forEach((function(e) {
                            var t = e.getAttribute("for") === r.id;
                            if (s && t) {
                                var n = s.closest("dropdown-opener");
                                s.innerHTML = e.innerHTML, n.trigger()
                            }
                            e.classList.toggle("selected", t)
                        }))
                    }))
                }
            }, {
                key: "_setInventoryStatusAvailable",
                value: function(e) {
                    var t = document.getElementById("product-stock-inner-".concat(this.dataset.productId, "-").concat(this.dataset.section));
                    t && t.classList.toggle("hidden", !e)
                }
            }, {
                key: "_setButtonsUnavailable",
                value: function() {
                    this._form.setDisable(!0), this._form.setText(window.variantStrings.unavailable)
                }
            }, {
                key: "_updateVariant",
                value: function() {
                    var e = this,
                        t = this.querySelectorAll("[data-variant-picker-option-inputs]"),
                        n = this._getVariants(),
                        i = S(t).map((function(t) {
                            var n = S(t.querySelectorAll("input"));
                            return e.getCheckedInput(n).value
                        }));
                    this.variant = n.find((function(e) {
                        return !e.options.map((function(e, t) {
                            return i[t] === e
                        })).includes(!1)
                    }))
                }
            }, {
                key: "setFocusListeners",
                value: function() {
                    if ("dropdown" === this.dataset.type) {
                        var e = S(this.querySelectorAll("float-element")).map((function(e) {
                            return S(e.element.querySelectorAll("label"))
                        })).reduce((function(e, t) {
                            return S(e).concat(S(t))
                        }), []);
                        this.setListenersForLabels(e)
                    } else {
                        var t = S(this.querySelectorAll("label"));
                        this.setListenersForLabels(t)
                    }
                }
            }, {
                key: "setListenersForLabels",
                value: function(e) {
                    var t = this;
                    e.forEach((function(e) {
                        e.addEventListener("focus", t._handleLabelFocus)
                    }))
                }
            }, {
                key: "removeListenersForLabels",
                value: function(e) {
                    var t = this;
                    e.forEach((function(e) {
                        e.addEventListener("focus", t._handleLabelFocus)
                    }))
                }
            }, {
                key: "_updateOptionsAvailable",
                value: function() {
                    var e = this,
                        t = this.querySelectorAll("[data-variant-picker-option-inputs]"),
                        n = function(e) {
                            return t[e] ? S(t[e].querySelectorAll("input")) : null
                        },
                        i = n(0),
                        o = n(1),
                        a = n(2),
                        r = this._getVariants(),
                        s = function() {
                            for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++) t[n] = arguments[n];
                            return r.reduce((function(e, n) {
                                var i = !t || t.every((function(e) {
                                    return n.options.includes(e.value)
                                }));
                                return n.available && i ? S(e).concat([n.options]) : e
                            }), [])
                        },
                        c = function(t, n) {
                            var i = !0,
                                o = !1,
                                a = void 0;
                            try {
                                for (var r, s = function() {
                                        var t = r.value,
                                            i = t.value,
                                            o = !1;
                                        n.forEach((function(e) {
                                            e.includes(i) && (o = !0)
                                        }));
                                        var a, s = 'label[for="'.concat(t.id, '"]');
                                        (e.querySelector(s) ? e.querySelector(s) : (a = s, S(e.querySelectorAll("float-element")).find((function(e) {
                                            return e.element.querySelector(a)
                                        })).element.querySelector(a))).toggleAttribute("no-available", !o)
                                    }, c = t[Symbol.iterator](); !(i = (r = c.next()).done); i = !0) s()
                            } catch (e) {
                                o = !0, a = e
                            } finally {
                                try {
                                    i || null == c.return || c.return()
                                } finally {
                                    if (o) throw a
                                }
                            }
                        };
                    (c(i, s()), o) && c(o, s(this.getCheckedInput(i)));
                    a && c(a, s(this.getCheckedInput(i), this.getCheckedInput(o)))
                }
            }, {
                key: "_getVariants",
                value: function() {
                    var e = this.querySelector("[data-variant-picker-variants]");
                    return JSON.parse(e.textContent)
                }
            }, {
                key: "_updateFirstMediaByVariant",
                value: function(e, t) {
                    document.querySelectorAll("#product-media-".concat(this.dataset.productId, "-").concat(this.dataset.section)).forEach((function(n) {
                        return n.updateFirstMediaByVariant(e, t)
                    }))
                }
            }, {
                key: "_updateForm",
                value: function() {
                    this._updateLabels(), this._updateVariant(), this._updateOptionsAvailable()
                }
            }, {
                key: "_updateURL",
                value: function() {
                    if (this.variant && "true" === this.dataset.updateUrl) {
                        var e = "".concat(this.dataset.url, "?variant=").concat(this.variant.id);
                        window.history.replaceState({}, "", e)
                    }
                }
            }, {
                key: "_updateVariantInput",
                value: function() {
                    var e = this._form.variantInput;
                    e.value = this.variant.id, e.dispatchEvent(new Event("change", {
                        bubbles: !0
                    }))
                }
            }, {
                key: "_updatePickupAvailability",
                value: function() {
                    this._pickupAvailability.updateVariantId(this.variant.id), this._pickupAvailability.fetchAvailability()
                }
            }, {
                key: "_updateProduct",
                value: function() {
                    var e = this,
                        t = "".concat(this.dataset.url, "?variant=").concat(this.variant.id, "&section_id=").concat(this.dataset.sectionIdWithoutPrefix);
                    this._updateBlocksByVariantId(this.variant.id), fetch(t).then((function(e) {
                        return e.text()
                    })).then((function(t) {
                        var n = me(t),
                            i = e.variant.available;
                        e._form.setDisable(!i), e._form.setLoading(!1), e._updateElements(n)
                    })).catch((function() {
                        C.notification && C.notification.show("Error in variant picker component", "warning")
                    }))
                }
            }, {
                key: "_updateElements",
                value: function(e) {
                    var t = this;
                    this._elements.forEach((function(n) {
                        var i = "".concat(n, "-").concat(t.dataset.productId, "-").concat(t.dataset.section),
                            o = document.getElementById(i);
                        o && (o.innerHTML = e.getElementById(i).innerHTML)
                    }))
                }
            }, {
                key: "_updateBlocksByVariantId",
                value: function(e) {
                    var t = this;
                    ["product-price", "product-sku", "product-stock"].forEach((function(n) {
                        var i = document.getElementById("".concat(n, "-").concat(t.dataset.productId, "-").concat(t.dataset.section));
                        i && i.updateByVariantId(e)
                    }))
                }
            }, {
                key: "getCheckedInput",
                value: function(e) {
                    return e.find((function(e) {
                        return e.checked
                    }))
                }
            }, {
                key: "_form",
                get: function() {
                    return document.getElementById("product-form-component-".concat(this.dataset.productId, "-").concat(this.dataset.section))
                }
            }]), n
        }(ee),
        Co = wo,
        Eo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleClick", (function() {
                    e.updateSelected()
                })), v(E(e), "_handleMouseEnter", (function(t) {
                    e.updateActiveValue(t.target.dataset.value)
                })), v(E(e), "_handleMouseLeave", (function() {
                    e.updateSelected()
                })), e.activeValueSelector = "[data-color-swatches-picker-active-value]", e.activeValue = e.querySelector(e.activeValueSelector), e.labelSelector = "[data-color-swatches-picker-label]", e.labels = S(e.querySelectorAll(e.labelSelector)), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this;
                    this.addEventListener("click", this._handleClick), this.labels.forEach((function(t) {
                        t.addEventListener("mouseenter", e._handleMouseEnter), t.addEventListener("mouseleave", e._handleMouseLeave)
                    }))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    var e = this;
                    this.removeEventListener("click", this._handleClick), this.labels.forEach((function(t) {
                        t.removeEventListener("mouseenter", e._handleMouseEnter), t.removeEventListener("mouseleave", e._handleMouseLeave)
                    }))
                }
            }, {
                key: "updateSelected",
                value: function() {
                    var e = this.querySelector("".concat(this.labelSelector, ".selected"));
                    if (e) {
                        var t = e.getAttribute("data-value") || "";
                        this.updateActiveValue(t)
                    }
                }
            }, {
                key: "updateActiveValue",
                value: function(e) {
                    this.activeValue && (this.activeValue.innerHTML = e)
                }
            }]), n
        }(ee),
        Io = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleKeydown", (function(t) {
                    var n = t.key || t.keyCode;
                    (n === H.ESCAPE_STRING_KEY || n === H.ESCAPE_NUMBER_KEY) && (e.isZoomed ? e.zoomedImage.reset() : e.hide())
                })), v(E(e), "_handleCarouselInit", (function() {
                    e._updateCarouselDraggableState()
                })), v(E(e), "_handleCarouselSelect", (function() {
                    e.updateSelectedSlideNumber()
                })), e.selectors = {
                    carousel: "[data-product-modal-carousel]",
                    carouselButtons: "[data-product-modal-carousel-button]",
                    carouselSlide: "[data-product-modal-slide]",
                    carouselSelectedSlideNumber: "[data-product-modal-selected-slide-number]",
                    carouselSlideNumber: "[data-product-modal-slide-number]",
                    zoomCursor: "zoom-cursor"
                }, e.element && (e.carousel = e.element.querySelector(e.selectors.carousel), e.carouselButtons = e.carousel.querySelectorAll(e.selectors.carouselButtons), e._slides = S(e.element.querySelectorAll(e.selectors.carouselSlide)), e._selectedSlideNumber = e.element.querySelector(e.selectors.carouselSelectedSlideNumber), e._slideNumber = e.element.querySelector(e.selectors.carouselSlideNumber)), e._zoomCursor = document.querySelector(e.selectors.zoomCursor), e.mediaIndexMap = e._createMediaIndexMap(), e.isZoomed = !1, e
            }
            return p(n, [{
                key: "openAndShowMediaById",
                value: function(e) {
                    if (this.show(), this.carousel) {
                        var t = this.mediaIndexMap[e];
                        this.carousel.embla.scrollTo(t, !0), this.carouselButtons[0] && this.carouselButtons[0].focus(), this.updateSelectedSlideNumber()
                    }
                }
            }, {
                key: "_initCarousel",
                value: function() {
                    this.carousel && (this.carousel.embla.on("select", this._handleCarouselSelect), this.carousel.embla.on("init", this._handleCarouselInit))
                }
            }, {
                key: "_resetCarousel",
                value: function() {
                    this.carousel && (this.carousel.embla.off("select", this._handleCarouselSelect), this.carousel.embla.off("init", this._handleCarouselInit))
                }
            }, {
                key: "hide",
                value: function() {
                    this._resetCarousel(), on(A(n.prototype), "hide", this).call(this), this.isZoomed = !1, this.updateModal(), this.emit("hide", {})
                }
            }, {
                key: "show",
                value: function() {
                    on(A(n.prototype), "show", this).call(this), this._initCarousel()
                }
            }, {
                key: "updateSelectedSlideNumber",
                value: function() {
                    if (this._selectedSlideNumber && this.carousel) {
                        var e = this.carousel.embla.selectedScrollSnap() + 1;
                        this._selectedSlideNumber.innerHTML = "".concat(e)
                    }
                }
            }, {
                key: "updateModal",
                value: function() {
                    this._updateCarouselDraggableState(), this._updateZoomCursorState(), this._updateZoomState()
                }
            }, {
                key: "_createMediaIndexMap",
                value: function() {
                    return this._slides.reduce((function(e, t, n) {
                        return t.dataset.mediaId ? ce(m({}, e), v({}, t.dataset.mediaId, n)) : e
                    }), {})
                }
            }, {
                key: "_updateCarouselDraggableState",
                value: function() {
                    this.carousel && (mn() ? this.carousel.reInit({
                        draggable: !this.isZoomed
                    }) : this.carousel.reInit({
                        draggable: !1
                    }))
                }
            }, {
                key: "_updateZoomCursorState",
                value: function() {
                    this._zoomCursor && this._zoomCursor.updateState(this.isZoomed)
                }
            }, {
                key: "_updateZoomState",
                value: function() {
                    this.toggleAttribute("zoom-enabled", this.isZoomed)
                }
            }]), n
        }(en),
        xo = Io,
        Lo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleImageLoad", (function() {
                    e.setPreloaderVisible(!1)
                })), v(E(e), "_handleModalHide", (function() {
                    e.reset()
                })), v(E(e), "_handleCarouselSelect", (function() {
                    e.reset()
                })), v(E(e), "_handleTouchStart", (function(t) {
                    t.preventDefault(), e.fingers = t.touches.length, e.firstMove = !0, e.detectDoubleTap(t)
                })), v(E(e), "_handleTouchMove", (function(t) {
                    if (t.preventDefault(), !e._isDoubleTapped) {
                        if (e.firstMove) e.updateGesture(t), e.startMoveTouches = t.touches.length;
                        else if (e._lastGesture) switch (e._lastGesture) {
                            case "zoom":
                                2 === e.startMoveTouches && 2 === t.touches.length && e.pinch(t);
                                break;
                            case "drag":
                                if (1 === e.startMoveTouches && 1 === t.touches.length) {
                                    var n = t.targetTouches[0],
                                        i = n.clientX,
                                        o = n.clientY;
                                    e.drag(i, o)
                                }
                        } else e.setGesture("none", t);
                        e.firstMove = !1
                    }
                })), v(E(e), "_handleTouchEnd", (function(t) {
                    t.preventDefault(), e.fingers = t.touches.length, e.updateGesture(t)
                })), v(E(e), "_handleMouseDown", (function(t) {
                    t.preventDefault(), e.startDrag(t.clientX, t.clientY), e.setDragging(!0)
                })), v(E(e), "_handleMouseUp", (function(t) {
                    e.setDragging(!1);
                    var n = e._modal.isZoomed ? 75 : 0;
                    e.zoomTimeoutId = setTimeout((function() {
                        e.touchZoom(t.clientX, t.clientY)
                    }), n)
                })), v(E(e), "_handleMouseMove", (function(t) {
                    if (t.preventDefault(), clearTimeout(e.zoomTimeoutId), e._isDragging && e._modal.isZoomed) {
                        var n = t.clientX,
                            i = t.clientY;
                        e.drag(n, i)
                    }
                })), e._image = e.querySelector("img"), e._modal = e.closest("product-modal"), e._carousel = e._modal.carousel, e._preloader = e.querySelector("[data-product-modal-image-preloader]"), e._currentScale = 1, e._isDragging = !1, e._offsetX = 0, e._offsetY = 0, e._startDragPoint = {
                    x: 0,
                    y: 0
                }, e._maxScale = 3, e._minScale = 1, e._isTapped = !1, e._tapTimeout = 300, e._lastGesture = null, e.setZoomCursorVisible(!0), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    W.observe(this._preloader), this._image.addEventListener("mousedown", this._handleMouseDown), this._image.addEventListener("mouseup", this._handleMouseUp), this._image.addEventListener("mousemove", this._handleMouseMove), this._image.addEventListener("touchstart", this._handleTouchStart), this._image.addEventListener("touchend", this._handleTouchEnd), this._image.addEventListener("touchmove", this._handleTouchMove), this._image.addEventListener("load", this._handleImageLoad), customElements.upgrade(this._modal), this._modal.subscribe("hide", this._handleModalHide), this._carousel.embla.on("select", this._handleCarouselSelect)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    W.unobserve(this._preloader), this._image.removeEventListener("mousedown", this._handleMouseDown), this._image.removeEventListener("mouseup", this._handleMouseUp), this._image.removeEventListener("mousemove", this._handleMouseMove), this._image.removeEventListener("touchstart", this._handleTouchStart), this._image.removeEventListener("touchend", this._handleTouchEnd), this._image.removeEventListener("touchmove", this._handleTouchMove), this._image.removeEventListener("load", this._handleImageLoad), this._modal.unsubscribe("hide", this._handleModalHide), this._carousel.embla.off("select", this._handleCarouselSelect)
                }
            }, {
                key: "detectDoubleTap",
                value: function(e) {
                    var t = this;
                    if (this._isTappedTimeout && 1 === this.fingers) switch (clearTimeout(this._isTappedTimeout), this._isTappedTimeout = null, this._isDoubleTapped = !0, this.touchZoom(e.changedTouches[0].clientX, e.changedTouches[0].clientY), this._lastGesture) {
                        case "zoom":
                            this.setPinchScaling(!1);
                            break;
                        case "drag":
                            this.setDragging(!1)
                    } else this._isTappedTimeout = setTimeout((function() {
                        t._isTappedTimeout = null, t._isDoubleTapped = !1
                    }), this._tapTimeout)
                }
            }, {
                key: "updateGesture",
                value: function(e) {
                    2 === this.fingers ? this.setGesture("zoom") : 1 === this.fingers ? this.setGesture("drag", e) : this.setGesture("none", e)
                }
            }, {
                key: "setGesture",
                value: function(e, t) {
                    if (this._lastGesture !== e) {
                        if (this._lastGesture && !e) switch (this._lastGesture) {
                            case "zoom":
                                this.setPinchScaling(!1);
                                break;
                            case "drag":
                                this.setDragging(!1)
                        }
                        switch (e) {
                            case "zoom":
                                this.setPinchScaling(!0);
                                break;
                            case "drag":
                                this.startDrag(t.changedTouches[0].clientX, t.changedTouches[0].clientY), this.setDragging(!0);
                                break;
                            case "none":
                                this.setDragging(!1), this.setPinchScaling(!1)
                        }
                    }
                    this._lastGesture = e
                }
            }, {
                key: "pinch",
                value: function(e) {
                    var t = this.getDistanceBetweenTouches(e),
                        n = t > this.lastDistanceBetweenTouches,
                        i = n ? .125 : -.125,
                        o = this.getNewScale(this.currentScale + i),
                        a = this.getTouchCenter(e),
                        r = (a.x - this._offsetX) / this.currentScale,
                        s = (a.y - this._offsetY) / this.currentScale;
                    this.lastDistanceBetweenTouches = t, n || 1 !== o ? this.setTransform({
                        scale: o,
                        offsetX: a.x - r * o,
                        offsetY: a.y - s * o
                    }) : this.reset()
                }
            }, {
                key: "getDistanceBetweenTouches",
                value: function(e) {
                    return Math.hypot(e.touches[0].pageX - e.touches[1].pageX, e.touches[0].pageY - e.touches[1].pageY)
                }
            }, {
                key: "startDrag",
                value: function(e, t) {
                    this._startDragPoint = {
                        x: e - this._offsetX,
                        y: t - this._offsetY
                    }, this.dragStartPointX = e, this.dragStartPointY = t
                }
            }, {
                key: "drag",
                value: function(e, t) {
                    var n = this.dragStartPointX > e,
                        i = this.dragStartPointY > t,
                        o = this.getNewScale(this.currentScale),
                        a = e - this._startDragPoint.x,
                        r = t - this._startDragPoint.y,
                        s = this.getIntersectBounds({
                            isRightDrag: n,
                            isBottomDrag: i
                        });
                    (s.right || s.left) && (a = this._offsetX), (s.bottom || s.top) && (r = this._offsetY), this.setTransform({
                        scale: o,
                        offsetX: a,
                        offsetY: r
                    })
                }
            }, {
                key: "getIntersectBounds",
                value: function(e) {
                    var t = e.isRightDrag,
                        n = e.isBottomDrag,
                        i = this._image.getBoundingClientRect(),
                        o = t ? -8 : 8,
                        a = n ? -8 : 8;
                    return {
                        right: t && i.right + o < window.innerWidth,
                        left: !t && i.left + o > 0,
                        bottom: n && i.bottom + a < window.innerHeight,
                        top: !n && i.top + a > 0
                    }
                }
            }, {
                key: "getTouchCenter",
                value: function(e) {
                    var t = function(e, t) {
                            return e + t
                        },
                        n = S(e.touches),
                        i = n.length;
                    return {
                        x: n.map((function(e) {
                            return e.pageX
                        })).reduce(t) / i,
                        y: n.map((function(e) {
                            return e.pageY
                        })).reduce(t) / i
                    }
                }
            }, {
                key: "setTransform",
                value: function(e) {
                    var t = e.offsetX,
                        n = e.offsetY,
                        i = e.scale;
                    this.style.transform = "translate3d(".concat(t, "px, ").concat(n, "px, 0) scale3d(").concat(i, ", ").concat(i, ", 1)"), this._offsetX = t, this._offsetY = n, this.currentScale = i
                }
            }, {
                key: "touchZoom",
                value: function(e, t) {
                    var n, i, o, a = (e - this._offsetX) / this.currentScale,
                        r = (t - this._offsetY) / this.currentScale;
                    this._modal.isZoomed ? (n = this.getNewScale(1), i = 0, o = 0) : (i = e - a * (n = this.getNewScale(3)), o = t - r * n), this.style.cursor = this._modal.isZoomed ? "" : "grab", this.setZoomCursorVisible(this._modal.isZoomed), this.setTransform({
                        scale: n,
                        offsetX: i,
                        offsetY: o
                    })
                }
            }, {
                key: "reset",
                value: function() {
                    this.setTransform({
                        scale: 1,
                        offsetX: 0,
                        offsetY: 0
                    })
                }
            }, {
                key: "getNewScale",
                value: function(e) {
                    return Math.max(this._minScale, Math.min(this._maxScale, e))
                }
            }, {
                key: "setPinchScaling",
                value: function(e) {
                    this.toggleAttribute("is-pinch-scaling", e), this._isPinchScaling = e
                }
            }, {
                key: "setDragging",
                value: function(e) {
                    this.toggleAttribute("is-dragging", e), this._isDragging = e
                }
            }, {
                key: "setZoomCursorVisible",
                value: function(e) {
                    this._image.toggleAttribute("data-zoom-cursor-target", e)
                }
            }, {
                key: "setModalZoom",
                value: function(e) {
                    this._modal.isZoomed = e, this._modal.isZoomed && (this._modal.zoomedImage = this), this._modal.updateModal()
                }
            }, {
                key: "setPreloaderVisible",
                value: function(e) {
                    this._preloader.classList.toggle("hidden", !e), this._image.toggleAttribute("is-loaded", !e)
                }
            }, {
                key: "currentScale",
                get: function() {
                    return this._currentScale
                },
                set: function(e) {
                    this._currentScale !== e && (this.setModalZoom(e > 1), this._currentScale = e)
                }
            }]), n
        }(ee),
        To = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                return h(this, n), t.apply(this, arguments)
            }
            return p(n, [{
                key: "showModal",
                value: function() {
                    if (this.dataset.modal) {
                        var e = document.querySelector(this.dataset.modal);
                        e && e.openAndShowMediaById(this.dataset.mediaId)
                    }
                }
            }]), n
        }(ln),
        Mo = To,
        Ao = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleIntersectionObserve", (function(t, n) {
                    if (t[0].isIntersecting) {
                        n.unobserve(E(e));
                        var i = e.dataset.url;
                        i && fetch(i).then((function(e) {
                            return e.text()
                        })).then((function(t) {
                            var n = me(t);
                            e._updateByHTML(n)
                        })).catch((function() {
                            C.notification && C.notification.show("Error in product recommendations component", "warning")
                        }))
                    }
                })), e._intersectionObserver = new IntersectionObserver(e._handleIntersectionObserve, {
                    rootMargin: "0px 0px 200px 0px"
                }), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._intersectionObserver.observe(this)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._intersectionObserver.disconnect()
                }
            }, {
                key: "_updateByHTML",
                value: function(e) {
                    var t = e.querySelector("product-recommendations");
                    t && (this.innerHTML = t.innerHTML)
                }
            }]), n
        }(ee),
        Po = window.routes,
        Bo = function() {
            "use strict";

            function e() {
                h(this, e)
            }
            return p(e, [{
                key: "get",
                value: function(e) {
                    var t = this._prepareQuery(e);
                    return fetch(t).then((function(e) {
                        return e.text()
                    }))
                }
            }, {
                key: "_prepareQuery",
                value: function(e) {
                    var t = e.searchQuery,
                        n = e.sectionId,
                        i = Po.predictive_search_url,
                        o = "section_id=".concat(n);
                    return "".concat(i, "?q=").concat(t, "&").concat("resources[limit]=999", "&").concat(o)
                }
            }]), e
        }(),
        Do = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleInputChange", (0, pi.debounce)((function() {
                    e._searchQuery ? e._renderResults() : e._resetResults()
                }), 500)), e._cache = {}, e.sidebar = e.closest("#SearchSidebar"), e.inputComponentSelector = "[data-sidebar-search-input-component]", e.contentResults = "[data-sidebar-search-content-results]", e.footerSelector = "[data-sidebar-search-footer]", e.itemSelector = "[data-sidebar-search-item]", e.sidebar && (e._results = e.sidebar.element.querySelector(e.contentResults)), e._predictiveSearchAPI = new Bo, e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this._inputComponent, "input", this._handleInputChange)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this._inputComponent, "input", this._handleInputChange)
                }
            }, {
                key: "_renderResults",
                value: function() {
                    this._cache[this._searchQuery] ? this._renderFromCache(this._searchQuery) : this._renderFromUrl(this._searchQuery)
                }
            }, {
                key: "_resetResults",
                value: function() {
                    this.sidebar && this._updateResultsFromHTML(this.sidebar.defaultStateElement)
                }
            }, {
                key: "_renderFromCache",
                value: function(e) {
                    try {
                        this._updateResultsFromHTML(this._cache[e])
                    } catch (e) {
                        if (!C.notification) return;
                        C.notification.show("Error in search component when try update from cache", "warning")
                    }
                }
            }, {
                key: "_renderFromUrl",
                value: function(e) {
                    var t, n = this,
                        i = (null === (t = this.sidebar) || void 0 === t ? void 0 : t.dataset.sectionId) || "search-sidebar";
                    this._predictiveSearchAPI.get({
                        searchQuery: this._searchQuery,
                        sectionId: i
                    }).then((function(t) {
                        var i = me(t);
                        n._cache[e] = i, n._updateResultsFromHTML(i)
                    })).catch((function() {
                        C.notification && C.notification.show("Error in search component", "warning")
                    }))
                }
            }, {
                key: "_updateResultsFromHTML",
                value: function(e) {
                    var t = e.getElementById("SearchSidebar");
                    if (t) {
                        var n = t.querySelector("template"),
                            i = pe(n).querySelector(this.contentResults);
                        this.updateResultsHTML(i.innerHTML), this.updateFooterVisible()
                    }
                }
            }, {
                key: "updateResultsHTML",
                value: function(e) {
                    this._results && (this._results.innerHTML = e)
                }
            }, {
                key: "updateFooterVisible",
                value: function() {
                    if (this.sidebar) {
                        var e = this.sidebar.element.querySelector(this.footerSelector),
                            t = this.sidebar.element.querySelectorAll(this.itemSelector);
                        e && e.classList.toggle("hidden", 0 === t.length)
                    }
                }
            }, {
                key: "_searchQuery",
                get: function() {
                    return this._inputComponent ? this._inputComponent.value.trim() : ""
                }
            }, {
                key: "_inputComponent",
                get: function() {
                    return this.sidebar ? this.sidebar.querySelector(this.inputComponentSelector) : null
                }
            }]), n
        }(ee),
        Oo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function() {
                    e.update()
                })), v(E(e), "_handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e.update())
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("keydown", this._handleKeyDown), this.addEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("keydown", this._handleKeyDown), this.removeEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "update",
                value: function() {
                    var e = this.closest("cart-component, sidebar-cart"),
                        t = this.dataset.index;
                    e && t && e.updateItem(+t, 0)
                }
            }]), n
        }(ee),
        qo = Oo,
        UpdateItemSubscription = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function() {
                    e.update()
                })), v(E(e), "_handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e.update())
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("keydown", this._handleKeyDown), this.addEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("keydown", this._handleKeyDown), this.removeEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "update",
                value: function() {
                    var e = this.closest("cart-component, sidebar-cart"),
                        t = this.dataset.index;
                    e && t && e.updateCustomItem(+t, +this.dataset.quantity, this.dataset.selling_plan_id)
                }
            }]), n
        }(ee),
        UpdateItemSubscriptionPlan = function(e) {
            "use strict";
            L(n, e);
            var l = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = l.apply(this, arguments)), "handleSellingPlanChange", (function(ev) {
                    const f = ev?.detail?.sellingPlanId;
                    if(f) {
                        e.update(f)
                    }
                })),e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("sellingPlanchanged", this.handleSellingPlanChange)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                   this.removeEventListener("sellingPlanchanged", this.handleSellingPlanChange)
                }
            }, 
            {
                key: "update",
                value: function(sellingPlanId) {
                    var e = this.closest("cart-component, sidebar-cart"),
                        h = this.closest("cart-item");
                        t = this.dataset.index;
                    e && t && e.updateCustomItem(+t, +h.dataset.quantity, sellingPlanId)
                }
            }]), n
        }(ee),
        Ro = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function() {
                    e._copy()
                })), v(E(e), "_copy", (function() {
                    var t = e.dataset.value;
                    t && navigator.clipboard && navigator.clipboard.writeText(t).then((function() {
                        e._showTooltip()
                    }))
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this, "click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this, "click", this._handleButtonClick)
                }
            }, {
                key: "_showTooltip",
                value: function() {
                    var e = this.dataset.tooltipId;
                    if (e) {
                        var t = document.querySelector("#".concat(e));
                        t && (t.show(), V(1e3).then((function() {
                            t.hide()
                        })))
                    }
                }
            }]), n
        }(ee),
        Fo = Ro,
        No = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                h(this, n), v(E(e = t.call(this)), "_init", (function() {
                    e._target && Pt(e._target, E(e), (function() {
                        Bt(e._target, e, e._getOptions()).then((function(t) {
                            e._updatePosition(t), e._updateArrow(t)
                        }))
                    }))
                })), v(E(e), "show", (function() {
                    e._mount(), e._setVisible(!0), e.emit("show", {})
                })), v(E(e), "hide", (function() {
                    e._setVisible(!1), e._unmount(), e.emit("hide", {})
                }));
                var i = e.querySelector("template");
                return e.element = pe(i), e._arrow = e.element.querySelector("[data-float-element-arrow]"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._init()
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._unmount()
                }
            }, {
                key: "_updatePosition",
                value: function(e) {
                    var t = e.x,
                        n = e.y;
                    Object.assign(this.style, {
                        left: "".concat(t, "px"),
                        top: "".concat(n, "px")
                    })
                }
            }, {
                key: "_getOptions",
                value: function() {
                    return {
                        placement: this._placement,
                        middleware: this._getMiddleware(),
                        strategy: "absolute"
                    }
                }
            }, {
                key: "_getMiddleware",
                value: function() {
                    var e = this.dataset.alignmentAxisOffset || 0,
                        t = this.dataset.mainAxisOffset || 0,
                        n = [Qe({
                            alignmentAxis: +e,
                            mainAxis: +t
                        }), Ye(), Je()];
                    return this._arrow && n.push(He({
                        element: this._arrow
                    })), n
                }
            }, {
                key: "_updateArrow",
                value: function(e) {
                    var t = e.placement,
                        n = e.middlewareData;
                    if (this._arrow) {
                        var i = n.arrow,
                            o = i.x,
                            a = i.y,
                            r = {
                                top: "bottom",
                                right: "left",
                                bottom: "top",
                                left: "right"
                            }[t.split("-")[0]];
                        Object.assign(this._arrow.style, v({
                            left: null != o ? "".concat(o, "px") : "",
                            top: null != a ? "".concat(a, "px") : "",
                            right: "",
                            bottom: ""
                        }, r, "-5px"))
                    }
                }
            }, {
                key: "_mount",
                value: function() {
                    this.contains(this.element) || this.appendChild(this.element)
                }
            }, {
                key: "_unmount",
                value: function() {
                    this.element && this.element.remove()
                }
            }, {
                key: "_setVisible",
                value: function(e) {
                    this.setAttribute("aria-hidden", e ? "false" : "true")
                }
            }, {
                key: "_target",
                get: function() {
                    return document.querySelector('[data-clipboard-button-tooltip-target-id="'.concat(this.id, '"]'))
                }
            }, {
                key: "_placement",
                get: function() {
                    return this.dataset.placement || "bottom-end"
                }
            }]), n
        }(ee),
        Ho = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                return h(this, n), t.apply(this, arguments)
            }
            return p(n, [{
                key: "setImagesAttributes",
                value: function() {
                    var e = this.querySelectorAll("img"),
                        t = [80, 160, 300, 400, 500, 680, 900];
                    e.forEach((function(e) {
                        var n = t.map((function(t) {
                            return "".concat(e.dataset.imageUrl, "&width=").concat(t, " ").concat(t, "w")
                        })).join(",");
                        e.dataset.srcset = n
                    }))
                }
            }]), n
        }(ee),
        Vo = Ho,
        zo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "handleMouseEnter", (function() {
                    var t = e.dataset.url,
                        n = e.dataset.id;
                    t && n && oo.requestProductFromUrl(t, n)
                })), v(E(e), "handleQuickViewBtnClick", (function() {
                    var t = e.dataset.url;
                    t && oo.openAndRenderProductByUrl(t)
                })), v(E(e), "handleResize", (0, pi.debounce)((function() {
                    e.buttons && e.setButtonsOverflow(), e.mediaTabs && e.mediaTabs.update(), e.colorSwatches && e.colorSwatches.update()
                }), 100)), v(E(e), "handleImageLoad", (function() {
                    var t;
                    e.loadedImageCount += 1, e.loadedImageCount === (null === (t = e.images) || void 0 === t ? void 0 : t.length) && (e.removePreloader(), e.showImages())
                })), e.resizeObserver = new ResizeObserver(e.handleResize), e.lastButtonsWidth = 0, e.quickViewBtnSelector = "[data-product-card-quick-view-button]", e.preloaderSelector = "[data-product-card-preloader]", e.imagesContainerSelector = "[data-product-card-media-container]", e.buttonsSelector = "[data-product-card-buttons]", e.imagesSelector = "[data-product-card-featured-image]", e.mediaTabsSelector = "[data-product-card-media-tabs]", e.colorSwatchesSelector = "[data-product-card-color-swatches]", e.quickViewBtn = e.querySelector(e.quickViewBtnSelector), e.preloader = e.querySelector(e.preloaderSelector), e.imagesContainer = e.querySelector(e.imagesContainerSelector), e.buttons = e.querySelector(e.buttonsSelector), e.buttonList = S(e.querySelectorAll("[data-product-card-button]")), e.images = S(e.querySelectorAll(e.imagesSelector)), e.mediaTabs = e.querySelector(e.mediaTabsSelector), e.colorSwatches = e.querySelector(e.colorSwatchesSelector), e.loadedImageCount = 0, e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this;
                    this.setImagesAttributes(), this.images.forEach((function(t) {
                        t.addEventListener("load", e.handleImageLoad)
                    })), this.resizeObserver.observe(this), W.observe(this), this.addEventListener("mouseenter", this.handleMouseEnter), this.quickViewBtn && this.quickViewBtn.addEventListener("click", this.handleQuickViewBtnClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    var e = this;
                    this.images.forEach((function(t) {
                        t.removeEventListener("load", e.handleImageLoad)
                    })), this.resizeObserver.disconnect(), W.unobserve(this), this.removeEventListener("mouseenter", this.handleMouseEnter), this.quickViewBtn && this.quickViewBtn.removeEventListener("click", this.handleQuickViewBtnClick)
                }
            }, {
                key: "setButtonsOverflow",
                value: function() {
                    if (this.buttons) {
                        var e = this.getButtonsWidth(),
                            t = this.buttons.offsetWidth < e;
                        t && (this.lastButtonsWidth = this.buttons.offsetWidth), this.buttons.classList.toggle("product-card__btns--overflowed", t)
                    }
                }
            }, {
                key: "getButtonsWidth",
                value: function() {
                    return this.buttonList.reduce((function(e, t) {
                        var n = t.querySelector("[data-product-card-button-text]");
                        return e + (20 + ((n ? n.offsetWidth : 0) + 8) + 10) + 8
                    }), this.buttonList.length > 1 ? 8 : 0)
                }
            }, {
                key: "removePreloader",
                value: function() {
                    this.preloader && (this.preloader.remove(), W.unobserve(this))
                }
            }, {
                key: "showImages",
                value: function() {
                    this.imagesContainer && this.imagesContainer.setAttribute("visible", "")
                }
            }]), n
        }(Vo),
        Ko = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleResize", (0, pi.debounce)((function() {
                    e._setMaxLines()
                }), 100)), e._resizeObserver = new ResizeObserver(e._handleResize), e.targetSelector = "[data-quote-line-clamp-target]", e.lineClampSelector = "[data-quote-line-clamp]", e._lineClamp = e.querySelector(e.lineClampSelector), e._target = e.querySelector(e.targetSelector), e.styles = getComputedStyle(e._target), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._resizeObserver.observe(this)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this._resizeObserver.disconnect()
                }
            }, {
                key: "_setMaxLines",
                value: function() {
                    var e = this._getMaxLines();
                    e && this._target && (this._target.style.setProperty("--gsc-max-lines", "".concat(e)), this.setAttribute("data-line-clamp-setter-is-ready", ""))
                }
            }, {
                key: "_getMaxLines",
                value: function() {
                    if (!this._lineClamp || !this._target) return 0;
                    var e = this.styles.lineHeight,
                        t = this._lineClamp.offsetHeight;
                    return Math.floor(t / parseFloat(e))
                }
            }]), n
        }(ee),
        Uo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleItemClick", (function(t) {
                    e._input && e._dropdownBtnLabel && e._dropdown && (e._input.setAttribute("value", t.target.dataset.value), e._setActiveItem(t.target.dataset.value), e._dropdownBtnLabel.innerHTML = t.target.dataset.value, e._dropdown.hide())
                })), e._input = e.querySelector("input"), e._dropdown = e.querySelector("float-element"), e._dropdownBtnLabel = e.querySelector(".dropdown__toggle-label"), e._createItems(), e._items = S(e.querySelectorAll(".dropdown__item")), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this;
                    this._items.forEach((function(t) {
                        K(t, "click", e._handleItemClick)
                    }))
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    var e = this;
                    this._items.forEach((function(t) {
                        U(t, "click", e._handleItemClick)
                    }))
                }
            }, {
                key: "_setActiveItem",
                value: function(e) {
                    this._items.forEach((function(t) {
                        t.classList.toggle("active", t.dataset.value === e)
                    }))
                }
            }, {
                key: "_createItems",
                value: function() {
                    var e = this;
                    this.querySelectorAll("option").forEach((function(t) {
                        if (e._dropdown) {
                            var n = document.createElement("div");
                            n.classList.add("dropdown__item"), n.dataset.value = t.value, n.dataset.provinces = t.dataset.provinces, n.innerHTML = t.innerHTML, e._dropdown.appendChild(n)
                        }
                    }))
                }
            }]), n
        }(ee),
        Wo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleWindowClick", (function(t) {
                    var n = t.target,
                        i = n.closest("search-input");
                    !(e._input === n) && !i && e._updateResetButtonVisible()
                })), v(E(e), "_handleInputChange", (function() {
                    e._updateResetButtonVisible()
                })), v(E(e), "_handleResetBtnClick", (function(t) {
                    t.preventDefault(), e.reset()
                })), e._inputSelector = "[data-search-field-input]", e._resetBtnSelector = "[data-search-field-reset-button]", e._input = e.querySelector(e._inputSelector), e._resetBtn = e.querySelector(e._resetBtnSelector), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this._input, "input", this._handleInputChange), K(window, "click", this._handleWindowClick), K(this._resetBtn, "click", this._handleResetBtnClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this._input, "input", this._handleInputChange), U(window, "click", this._handleWindowClick), U(this._resetBtn, "click", this._handleResetBtnClick)
                }
            }, {
                key: "reset",
                value: function() {
                    if (this._input) {
                        var e = new Event("input", {
                            bubbles: !0
                        });
                        this._input.value = "", this._input.dispatchEvent(e), this._input.focus()
                    }
                }
            }, {
                key: "_updateResetButtonVisible",
                value: function() {
                    if (this._resetBtn) {
                        var e = this._hasInputValue();
                        this._resetBtn.classList.toggle("hidden", !e)
                    }
                }
            }, {
                key: "_hasInputValue",
                value: function() {
                    return !!this._input && this._input.value.trim().length > 0
                }
            }, {
                key: "value",
                get: function() {
                    return this._input ? this._input.value : ""
                }
            }]), n
        }(ee),
        Yo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleButtonClick", (function() {
                    e._togglePasswordVisible()
                })), e._inputSelector = "[data-password-field-input]", e._buttonSelector = "[data-password-field-button]", e._input = e.querySelector(e._inputSelector), e._button = e.querySelector(e._buttonSelector), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this._button, "click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this._button, "click", this._handleButtonClick)
                }
            }, {
                key: "_togglePasswordVisible",
                value: function() {
                    if (this._input) {
                        var e = "password" === this._input.getAttribute("type"),
                            t = e ? "text" : "password";
                        this._input.setAttribute("type", t), this._setButton(e)
                    }
                }
            }, {
                key: "_setButton",
                value: function(e) {
                    this._button && this._button.toggleAttribute("password-visible", e)
                }
            }]), n
        }(ee),
        jo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleMutations", (function(t) {
                    t.forEach((function(t) {
                        if ("attributes" === t.type) {
                            var n = t.target.matches(e.zoomTargetSelector);
                            e._setVisible(n)
                        }
                    }))
                })), v(E(e), "_handleMouseMove", (function(t) {
                    var n = t.target,
                        i = !!n.closest(e.zoomTargetSelector),
                        o = mn();
                    e._isVisible && (e.style.top = "".concat(t.clientY, "px"), e.style.left = "".concat(t.clientX, "px")), o || (e._setVisible(i), i && e.mutationObserver.observe(n, {
                        attributes: !0
                    }))
                })), e.zoomTargetSelector = "[data-zoom-cursor-target]", e.mutationObserver = new MutationObserver(e._handleMutations), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._autoCheckTargets()
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(window, "mousemove", this._handleMouseMove), this.mutationObserver.disconnect(), clearInterval(this.checkTargetsIntervalID)
                }
            }, {
                key: "_setVisible",
                value: function(e) {
                    this.toggleAttribute("visible", e), document.body.style.cursor = e ? "none" : ""
                }
            }, {
                key: "updateState",
                value: function(e) {
                    this.toggleAttribute("zoomed", e)
                }
            }, {
                key: "_autoCheckTargets",
                value: function() {
                    var e = this;
                    this.checkTargetsIntervalID = setInterval((function() {
                        document.querySelectorAll(e.zoomTargetSelector).length && !e.isHandlerSetted && (K(window, "mousemove", e._handleMouseMove), e.isHandlerSetted = !0)
                    }), 1e3)
                }
            }, {
                key: "_isVisible",
                get: function() {
                    return this.hasAttribute("visible")
                }
            }]), n
        }(ee),
        Xo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleHistoryChange", (function(t) {
                    var n = t.state.searchParams || e._searchParamsInitial;
                    n !== e._searchParamsPrev && e.updateBySearchParams(n)
                })), e._cache = {}, e._searchParamsInitial = window.location.search.slice(1), e._searchParamsPrev = window.location.search.slice(1), e.sortQuery = "", e.filterQuery = "", e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(window, "popstate", this._handleHistoryChange)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(window, "popstate", this._handleHistoryChange)
                }
            }, {
                key: "_formatParams",
                value: function(e) {
                    this._searchParamsPrev = e;
                    var t = this.dataset.baseParams || "";
                    return "".concat(t).concat(e)
                }
            }, {
                key: "updateBySearchParams",
                value: function(e) {
                    this.updateShopBySearchParams(e), this.updateFiltersBySearchParams(e)
                }
            }, {
                key: "updateShopBySearchParams",
                value: function(e) {
                    var t = this,
                        n = this._createUrl(e);
                    this._cache[n] ? this._updateElements(this._cache[n]) : this._getFromUrl(n).then((function(e) {
                        return t._updateElements(e)
                    })), this._updateURL(e, n)
                }
            }, {
                key: "updateFiltersBySearchParams",
                value: function(e) {
                    var t = this._createUrl(e),
                        n = document.querySelector("#SidebarFiltersMobile"),
                        i = document.querySelector("#SidebarFiltersDesktop");
                    if (n && i) {
                        var o = [n, i];
                        o.forEach((function(e) {
                            e.loadingOverlay.show()
                        }));
                        var a = function(e) {
                            o.forEach((function(t) {
                                t.updateHTML(e), t.loadingOverlay.hide()
                            }))
                        };
                        this._cache[t] ? a(this._cache[t]) : this._getFromUrl(t).then((function(e) {
                            return a(e)
                        }))
                    }
                }
            }, {
                key: "_getFromUrl",
                value: function(e) {
                    var t = this,
                        n = this.querySelector("#ShopProductsOverlay"),
                        i = n ? new Ki(n) : null;
                    i && i.show();
                    var o = "".concat(e, "&section_id=").concat(this.dataset.sectionId);
                    return fetch(o).then((function(e) {
                        return e.text()
                    })).then((function(n) {
                        var o = me(n);
                        return t._cache[e] = o, i && i.hide(), o
                    })).catch((function() {
                        C.notification && C.notification.show("Error in shop component", "warning")
                    }))
                }
            }, {
                key: "_updateURL",
                value: function(e, t) {
                    history.pushState({
                        searchParams: e
                    }, "", t)
                }
            }, {
                key: "_createUrl",
                value: function(e) {
                    var t = this._formatParams(e) || "";
                    return "".concat(window.location.pathname, "?").concat(t)
                }
            }, {
                key: "_updateElements",
                value: function(e) {
                    ["ShopProducts", "ShopProductCount", "ShopSortList", "ShopActiveFilters"].forEach((function(t) {
                        var n = document.getElementById(t),
                            i = e.getElementById(t);
                        n && i && (n.innerHTML = i.innerHTML)
                    }))
                }
            }, {
                key: "resetQueries",
                value: function() {
                    this.sortQuery = "", this.filterQuery = ""
                }
            }]), n
        }(ee),
        Qo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), (e = t.call(this)).optionsSelector = "[data-shop-active-filters-options]", e.removeBtnSelector = "[data-shop-active-filters-remove-btn]", e
            }
            return p(n, [{
                key: "reset",
                value: function() {
                    this.innerHTML = ""
                }
            }, {
                key: "setDisable",
                value: function() {
                    this.options && this.options.setAttribute("disabled", "")
                }
            }, {
                key: "options",
                get: function() {
                    return this.querySelector(this.optionsSelector)
                }
            }, {
                key: "buttons",
                get: function() {
                    return S(this.querySelectorAll(this.removeBtnSelector))
                }
            }]), n
        }(ee),
        Go = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleFormScroll", (function() {
                    if (e.form) {
                        var t = e.form.scrollTop > 0;
                        e.toggleAttribute("header-shadow-visible", t)
                    }
                })), v(E(e), "_handleClick", (function(e) {
                    var t = e.target.closest("[data-filters-checkbox]");
                    t && t.setAttribute("selected", "")
                })), v(E(e), "_handleInputChange", (function(t) {
                    "INPUT" === t.target.tagName && e._change()
                })), e.form = e.element.querySelector("[data-filters-form]"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    on(A(n.prototype), "connectedCallback", this).call(this), K(this.form, "scroll", this._handleFormScroll), K(this, "change", this._handleInputChange), K(this, "click", this._handleClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    on(A(n.prototype), "disconnectedCallback", this).call(this), U(this.form, "scroll", this._handleFormScroll), U(this, "change", this._handleInputChange), U(this, "click", this._handleClick)
                }
            }, {
                key: "_change",
                value: function() {}
            }, {
                key: "_createFilterQuery",
                value: function() {
                    if (this._form && this._shop) {
                        var e = new FormData(this._form),
                            t = new URLSearchParams(e).toString();
                        this._shop.filterQuery = t
                    }
                }
            }, {
                key: "updateHTML",
                value: function(e) {
                    var t = this.getAttribute("id"),
                        n = t ? e.getElementById(t) : null,
                        i = n ? n.querySelector("template") : null;
                    if (i) {
                        var o = pe(i);
                        this.updateFormFromElement(o), this.updateHeaderFromElement(o)
                    }
                }
            }, {
                key: "updateHeaderFromElement",
                value: function(e) {
                    var t = this.element.querySelector("[data-filters-header]"),
                        n = e.querySelector("[data-filters-header]");
                    t && n && (t.innerHTML = n.innerHTML)
                }
            }, {
                key: "updateFormFromElement",
                value: function(e) {
                    var t = this.element.querySelector("[data-filters-form]"),
                        n = e.querySelector("[data-filters-form]");
                    t && n && (t.innerHTML = n.innerHTML)
                }
            }, {
                key: "_form",
                get: function() {
                    return this.element.querySelector("form")
                }
            }, {
                key: "_shop",
                get: function() {
                    return this.element.closest("shop-component")
                }
            }, {
                key: "_searchParams",
                get: function() {
                    return this._shop ? [this._shop.filterQuery, this._shop.sortQuery].join("&") : ""
                }
            }, {
                key: "loadingOverlay",
                get: function() {
                    var e = this.element.querySelector("[data-filters-loading-overlay]");
                    return e ? new Ki(e) : null
                }
            }]), n
        }(vn),
        Zo = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                return h(this, n), t.apply(this, arguments)
            }
            return p(n, [{
                key: "_change",
                value: function() {
                    this._shop && (this._createFilterQuery(), this._shop.updateBySearchParams(this._searchParams))
                }
            }]), n
        }(Go),
        Jo = Zo,
        $o = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                return h(this, n), t.apply(this, arguments)
            }
            return p(n, [{
                key: "_change",
                value: function() {
                    this._shop && (this._createFilterQuery(), this._shop.updateFiltersBySearchParams(this._searchParams), this._setButtonForReset())
                }
            }, {
                key: "_setButtonForReset",
                value: function() {
                    var e = this.element.querySelector("filter-remove-btn");
                    e && (e.classList.contains("hidden") && ue(e))
                }
            }]), n
        }(Go),
        ea = $o,
        ta = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function() {
                    e.update()
                })), v(E(e), "_handleKeyDown", (function(t) {
                    Q(t.key || t.keyCode) && (t.preventDefault(), e.update())
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("keydown", this._handleKeyDown), this.addEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("keydown", this._handleKeyDown), this.removeEventListener("click", this._handleButtonClick)
                }
            }, {
                key: "update",
                value: function() {
                    var e = this.closest("shop-active-filters"),
                        t = this.closest("shop-component"),
                        n = this.dataset.url;
                    if (e) {
                        var i = this.hasAttribute("data-shop-active-filters-remove-btn");
                        if (this.hasAttribute("data-shop-active-filters-reset") && e.reset(), i) 1 === e.buttons.length ? e.reset() : (e.setDisable(), this.remove())
                    }
                    if (n && t) {
                        var o = -1 === n.indexOf("?") ? "" : n.slice(n.indexOf("?") + 1);
                        t.resetQueries(), t.updateBySearchParams(o)
                    }
                }
            }]), n
        }(ee),
        na = ta,
        ia = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleFormSubmit", (0, pi.debounce)((function(t) {
                    t.preventDefault();
                    var n = e.closest("shop-component"),
                        i = e.closest("sidebar-component"),
                        o = t.target;
                    if (i && i.hide(), n && o) {
                        var a = e._getSortQuery(o),
                            r = [n.filterQuery, a].join("&");
                        n.sortQuery = a, n.updateBySearchParams(r)
                    }
                }), 250)), v(E(e), "_handleLabelKeyDown", (function(e) {
                    if (Q(e.key || e.keyCode)) {
                        e.preventDefault();
                        var t = e.target.querySelector("input");
                        if (t) {
                            var n = new MouseEvent("click", {
                                button: 0,
                                which: 1
                            });
                            t.dispatchEvent(n)
                        }
                    }
                })), e.labelSelector = "[data-sort-list-label]", e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.setListenersForLabels(), K(this._form, "input", this._handleFormSubmit)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeListenersForLabels(), U(this._form, "input", this._handleFormSubmit)
                }
            }, {
                key: "_getSortQuery",
                value: function(e) {
                    var t = e.closest("form");
                    if (t) {
                        var n = new FormData(t);
                        return new URLSearchParams(n).toString()
                    }
                    return ""
                }
            }, {
                key: "setListenersForLabels",
                value: function() {
                    var e = this;
                    S(this.querySelectorAll(this.labelSelector)).forEach((function(t) {
                        t.addEventListener("keydown", e._handleLabelKeyDown)
                    }))
                }
            }, {
                key: "removeListenersForLabels",
                value: function() {
                    var e = this;
                    S(this.querySelectorAll(this.labelSelector)).forEach((function(t) {
                        t.removeEventListener("keydown", e._handleLabelKeyDown)
                    }))
                }
            }, {
                key: "_form",
                get: function() {
                    return this.querySelector("form")
                }
            }]), n
        }(ee),
        oa = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleRangeInput", (function(t) {
                    var n = e.querySelector("[data-price-range-max-input]"),
                        i = e.querySelector("[data-price-range-min-input]");
                    if (e._progress && i && n) {
                        var o = e._progress.offsetLeft + e._progress.offsetWidth / 2,
                            a = t.offsetX < o;
                        i.toggleAttribute("targeted", a), n.toggleAttribute("targeted", !a)
                    }
                })), v(E(e), "_handleNumberChange", (function() {
                    if (e._minNumberInput && e._maxNumberInput) {
                        var t = parseInt(e._minNumberInput.value),
                            n = parseInt(e._maxNumberInput.value);
                        e._updateMinRangeInput(t), e._updateMaxRangeInput(n)
                    }
                })), v(E(e), "_handleRangeChange", (function() {
                    if (e._minRangeInput && e._maxRangeInput) {
                        var t = parseInt(e._minRangeInput.value),
                            n = parseInt(e._maxRangeInput.value);
                        e._updateMaxPriceInput(n), e._updateMaxRangeInput(n), e._updateMinPriceInput(t), e._updateMinRangeInput(t)
                    }
                })), e._minNumberInput = e.querySelector("[data-price-min-range-number]"), e._maxNumberInput = e.querySelector("[data-price-max-range-number]"), e._rangeWrapper = e.querySelector("[data-price-range-inputs-wrapper]"), e._minRangeInput = e.querySelector("[data-price-min-range-input]"), e._maxRangeInput = e.querySelector("[data-price-max-range-input]"), e._progress = e.querySelector("[data-price-range-progress]"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this._minRangeInput && this._updateMinRangeInput(+this._minRangeInput.value), this._maxRangeInput && this._updateMaxRangeInput(+this._maxRangeInput.value), K(this._minNumberInput, "input", this._handleNumberChange), K(this._maxNumberInput, "input", this._handleNumberChange), K(this._minRangeInput, "input", this._handleRangeChange), K(this._maxRangeInput, "input", this._handleRangeChange), K(this._rangeWrapper, "mouseenter", this._handleRangeInput), K(this._rangeWrapper, "mousemove", this._handleRangeInput)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this._minNumberInput, "input", this._handleNumberChange), U(this._maxNumberInput, "input", this._handleNumberChange), U(this._minRangeInput, "input", this._handleRangeChange), U(this._maxRangeInput, "input", this._handleRangeChange), U(this._rangeWrapper, "mouseenter", this._handleRangeInput), U(this._rangeWrapper, "mousemove", this._handleRangeInput)
                }
            }, {
                key: "_updateMaxRangeInput",
                value: function(e) {
                    if (this._maxRangeInput && this._progress) {
                        var t = 100 - e / +this._maxRangeInput.max * 100;
                        this._maxRangeInput.value = "".concat(e), this._progress.style.right = "".concat(t, "%")
                    }
                }
            }, {
                key: "_updateMinRangeInput",
                value: function(e) {
                    if (this._minRangeInput && this._progress) {
                        var t = e / +this._minRangeInput.max * 100;
                        this._minRangeInput.value = "".concat(e), this._progress.style.left = "".concat(t, "%")
                    }
                }
            }, {
                key: "_updateMaxPriceInput",
                value: function(e) {
                    this._maxNumberInput && (this._maxNumberInput.value = e.toFixed(2))
                }
            }, {
                key: "_updateMinPriceInput",
                value: function(e) {
                    this._minNumberInput && (this._minNumberInput.value = e.toFixed(2))
                }
            }]), n
        }(ee),
        aa = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleSectionLoad", (function(t) {
                    e.dataset.sectionId === t.detail.sectionId && e.reset()
                })), v(E(e), "_handleItemClick", (function(t) {
                    var n = t.target.closest(e.itemSelector);
                    if (n) {
                        var i = +(n.dataset.value || 1);
                        e._switch(i)
                    }
                })), v(E(e), "_handleKeyDown", (function(t) {
                    if (Q(t.key || t.keyCode)) {
                        t.preventDefault();
                        var n = t.target.closest(e.itemSelector);
                        if (n) {
                            var i = +(n.dataset.value || 1);
                            e._switch(i)
                        }
                    }
                })), e.itemSelector = "[data-column-switcher-item]", e.targetSelector = "[data-column-switcher-target]", e.items = S(e.querySelectorAll(e.itemSelector)), e._cssVariable = e.dataset.columnSwitcherCssVariable || "", e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    var e = this;
                    this._init(), this.items.forEach((function(t) {
                        K(t, "keydown", e._handleKeyDown), K(t, "click", e._handleItemClick)
                    })), this._isEditorMode && this._editor.subscribe("SECTION_LOAD", this._handleSectionLoad)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    var e = this;
                    this.items.forEach((function(t) {
                        U(t, "keydown", e._handleKeyDown), U(t, "click", e._handleItemClick)
                    })), this._isEditorMode && this._editor.destroy()
                }
            }, {
                key: "updateByColumnCount",
                value: function(e) {
                    this._selectSwitch(e), this._updateColumnCount(e)
                }
            }, {
                key: "_selectSwitch",
                value: function(e) {
                    this.items.forEach((function(t) {
                        var n = +(t.getAttribute("data-value") || 1);
                        t.classList.toggle("selected", n === e)
                    }))
                }
            }, {
                key: "_updateColumnCount",
                value: function(e) {
                    var t = this.closest(this.targetSelector);
                    t && (t.style.setProperty("--gsc-".concat(this._cssVariable), e.toString()), localStorage.setItem("products-".concat(this._cssVariable), e.toString()))
                }
            }, {
                key: "_init",
                value: function() {
                    var e = localStorage.getItem("products-".concat(this._cssVariable));
                    if (e && "null" !== e) {
                        var t = Number(e);
                        t > 0 && this.updateByColumnCount(t)
                    }
                }
            }, {
                key: "_switch",
                value: function(e) {
                    this.updateByColumnCount(e)
                }
            }, {
                key: "reset",
                value: function() {
                    this.dataset.default && this._switch(Number(this.dataset.default))
                }
            }]), n
        }(ee),
        ra = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.apply(this, arguments)), "_handleButtonClick", (function() {
                    var t = e.closest("shop-component"),
                        n = e.closest("#SidebarFiltersMobile");
                    if (t) {
                        var i = [t.filterQuery, t.sortQuery].join("&");
                        t.updateShopBySearchParams(i)
                    }
                    n && n.hide()
                })), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    K(this, "click", this._handleButtonClick)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this, "click", this._handleButtonClick)
                }
            }]), n
        }(ee),
        sa = ra,
        ca = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleButtonMouseDown", (function(t) {
                    t.preventDefault(), e.startMove()
                })), v(E(e), "_handleButtonMouseUp", (function() {
                    e.endMove()
                })), v(E(e), "_handleMouseMove", (function(t) {
                    e._isMoved && e.moveSeparator(t.pageX)
                })), v(E(e), "_handleButtonKeyUp", (function(t) {
                    if (e._btn) {
                        var n = t.key || t.keyCode,
                            i = Z(n),
                            o = G(n);
                        if (i || o) {
                            var a = e._btn.getBoundingClientRect(),
                                r = a.right - a.width / 2,
                                s = i ? r - e._movingStep : r + e._movingStep;
                            e.moveSeparator(s)
                        }
                    }
                })), v(E(e), "_handleTouchStart", (function() {
                    e.startMove()
                })), v(E(e), "_handleTouchEnd", (function() {
                    e.endMove()
                })), v(E(e), "_handleTouchMove", (function(t) {
                    e._isMoved && (t.preventDefault(), e.moveSeparator(t.targetTouches[0].clientX))
                })), e._btnSelector = "[data-before-after-images-button]", e._btn = e.querySelector(e._btnSelector), e._isMoved = !1, e._movingStep = 20, e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.setSeparatorPosition(Number(this.dataset.initialDragPosition)), K(this._btn, "keyup", this._handleButtonKeyUp), K(this._btn, "mousedown", this._handleButtonMouseDown), K(document, "mouseup", this._handleButtonMouseUp), K(document, "mousemove", this._handleMouseMove), K(this._btn, "touchstart", this._handleTouchStart), K(this, "touchmove", this._handleTouchMove), K(document, "touchend", this._handleTouchEnd)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    U(this._btn, "keyup", this._handleButtonKeyUp), U(this._btn, "mousedown", this._handleButtonMouseDown), U(document, "mouseup", this._handleButtonMouseUp), U(document, "mousemove", this._handleMouseMove), U(this._btn, "touchstart", this._handleTouchStart), U(this, "touchmove", this._handleTouchMove), U(document, "touchend", this._handleTouchEnd)
                }
            }, {
                key: "startMove",
                value: function() {
                    this._isMoved = !0
                }
            }, {
                key: "endMove",
                value: function() {
                    this._isMoved = !1
                }
            }, {
                key: "setSeparatorPosition",
                value: function(e) {
                    this.style.setProperty("--gsc-drag-position", "".concat(e, "%"))
                }
            }, {
                key: "moveSeparator",
                value: function(e) {
                    var t = this.getBoundingClientRect();
                    if (e <= t.left) this.setSeparatorPosition(0);
                    else if (e >= t.right) this.setSeparatorPosition(100);
                    else {
                        var n = Math.floor((e - t.left) / this.offsetWidth * 1e3) / 10;
                        this.setSeparatorPosition(n)
                    }
                }
            }]), n
        }(ee),
        la = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleFormScroll", (function() {
                    if (e.viewport) {
                        var t = e.viewport.scrollTop > 0;
                        e.toggleAttribute("header-shadow-visible", t)
                    }
                })), e.viewport = e.element.querySelector("[data-product-information-drawer-viewport]"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    on(A(n.prototype), "connectedCallback", this).call(this), K(this.viewport, "scroll", this._handleFormScroll)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    on(A(n.prototype), "disconnectedCallback", this).call(this), U(this.viewport, "scroll", this._handleFormScroll)
                }
            }]), n
        }(vn),
        ua = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), (e = t.call(this)).content = e.querySelector("[data-tabs-element-content]"), e.styles = getComputedStyle(E(e)), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.updateMaxHeight(this.isVisible)
                }
            }, {
                key: "show",
                value: function() {
                    return this.setVisible(!0), V(this.transitionDuration)
                }
            }, {
                key: "hide",
                value: function() {
                    return this.setVisible(!1), V(this.transitionDuration)
                }
            }, {
                key: "setVisible",
                value: function(e) {
                    this.setAttribute("aria-hidden", e ? "false" : "true"), this.updateMaxHeight(e)
                }
            }, {
                key: "updateMaxHeight",
                value: function(e) {
                    if (this.content) {
                        var t = e ? this.content.offsetHeight : 0;
                        this.style.maxHeight = "".concat(t, "px")
                    }
                }
            }, {
                key: "isVisible",
                get: function() {
                    return "false" === this.getAttribute("aria-hidden")
                }
            }, {
                key: "transitionDuration",
                get: function() {
                    return 1e3 * parseFloat(this.styles.transitionDuration)
                }
            }]), n
        }(ee),
        da = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), v(E(e = t.call(this)), "_handleWindowScroll", (function() {
                    e._lastScrollPosition || (e._lastScrollPosition = window.scrollY), e.updateVisibleStatus(), e.updateExtendStatus()
                })), v(E(e), "updateExtendStatus", (0, pi.debounce)((function() {
                    if (Math.abs(window.scrollY - e._lastScrollPosition) > 24) {
                        var t = e._lastScrollPosition > window.scrollY;
                        e.toggleAttribute("is-extended", t)
                    }
                    e._lastScrollPosition = 0
                }), 50)), e.products = document.getElementById("ShopProducts"), e.footer = document.querySelector(".shopify-section-footer"), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    on(A(n.prototype), "connectedCallback", this).call(this), window.addEventListener("scroll", this._handleWindowScroll)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    on(A(n.prototype), "disconnectedCallback", this).call(this), window.removeEventListener("scroll", this._handleWindowScroll)
                }
            }, {
                key: "updateVisibleStatus",
                value: function() {
                    var e = this.footer ? this.footer.offsetTop : 0,
                        t = this.products.getBoundingClientRect(),
                        n = window.innerHeight + window.scrollY < e,
                        i = t.top < 0,
                        o = n && i;
                    this.toggleAttribute("is-visible", o), document.body.toggleAttribute("is-filters-button-fixed", o)
                }
            }]), n
        }(pn),
        ha = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                var e;
                return h(this, n), (e = t.call(this)).checkbox = e.querySelector("[data-recipient-form-checkbox]"), e.timezoneInput = e.querySelector("[data-recipient-form-timezone-input]"), e.inputs = e.querySelectorAll("[data-recipient-form-input], [data-recipient-form-timezone-input]"), e.fields = e.querySelector("[data-recipient-form-fields]"), e.timezoneInput.value = (new Date).getTimezoneOffset(), e
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.addEventListener("change", this.handleChange)
                }
            }, {
                key: "disconnectedCallback",
                value: function() {
                    this.removeEventListener("change", this.handleChange)
                }
            }, {
                key: "handleChange",
                value: function() {
                    var e = this.checkbox.checked;
                    this.updateMaxHeight(e), this.updateInputDisable(!e), e || this.clearInputs()
                }
            }, {
                key: "clearInputs",
                value: function() {
                    this.inputs.forEach((function(e) {
                        e.value = ""
                    }))
                }
            }, {
                key: "updateInputDisable",
                value: function(e) {
                    this.inputs.forEach((function(t) {
                        t.disabled = e
                    }))
                }
            }, {
                key: "reset",
                value: function() {
                    this.checkbox.checked = !1, this.clearInputs()
                }
            }, {
                key: "updateMaxHeight",
                value: function(e) {
                    if (this.fields) {
                        var t = e ? this.fields.scrollHeight : 0;
                        this.fields.style.maxHeight = "".concat(t, "px")
                    }
                }
            }]), n
        }(ee),
        fa = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                return h(this, n), t.apply(this, arguments)
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.setImagesAttributes()
                }
            }]), n
        }(Vo),
        pa = fa,
        va = function(e) {
            "use strict";
            L(n, e);
            var t = D(n);

            function n() {
                return h(this, n), t.apply(this, arguments)
            }
            return p(n, [{
                key: "connectedCallback",
                value: function() {
                    this.setImagesAttributes()
                }
            }]), n
        }(Vo),
        ma = [{
            tag: "login-component",
            component: te
        }, {
            tag: "back-to-top-button",
            component: ne
        }, {
            tag: "sticky-cart-button",
            component: ie
        }, {
            tag: "quantity-component",
            component: oe
        }, {
            tag: "quantity-btn",
            component: ae
        }, {
            tag: "localization-selector",
            component: re
        }, {
            tag: "notification-component",
            component: se
        }, {
            tag: "tabs-component",
            component: ye
        }, {
            tag: "tab-component",
            component: ua
        }, {
            tag: "list-component",
            component: ge
        }, {
            tag: "list-btn",
            component: be
        }, {
            tag: "float-element",
            component: Ot
        }, {
            tag: "float-element-btn",
            component: Ut
        }, {
            tag: "dropdown-opener",
            component: Wt
        }, {
            tag: "tooltip-trigger",
            component: jt
        }, {
            tag: "accordeon-component",
            component: Xt
        }, {
            tag: "accordeon-btn",
            component: Gt
        }, {
            tag: "product-media-tabs",
            component: Zt
        }, {
            tag: "color-swatches",
            component: $t
        }, {
            tag: "modal-component",
            component: en
        }, {
            tag: "password-modal",
            component: an
        }, {
            tag: "cart-notification-popup",
            component: sn
        }, {
            tag: "modal-opener",
            component: ln
        }, {
            tag: "password-modal-opener",
            component: dn
        }, {
            tag: "modal-close-btn",
            component: fn
        }, {
            tag: "sidebar-button",
            component: pn
        }, {
            tag: "sidebar-component",
            component: vn
        }, {
            tag: "search-sidebar",
            component: gn
        }, {
            tag: "quick-view",
            component: kn
        }, {
            tag: "carousel-component",
            component: yi
        }, {
            tag: "carousel-play-button",
            component: gi
        }, {
            tag: "carousel-dots",
            component: Bi
        }, {
            tag: "carousel-dot",
            component: Di
        }, {
            tag: "carousel-btn",
            component: qi
        }, {
            tag: "carousel-progress",
            component: Ri
        }, {
            tag: "header-component",
            component: Fi
        }, {
            tag: "drawer-menu",
            component: Ni
        }, {
            tag: "drawer-menu-page",
            component: Hi
        }, {
            tag: "drawer-menu-page-link",
            component: zi
        }, {
            tag: "pagination-component",
            component: Ui
        }, {
            tag: "pagination-load-button",
            component: Yi
        }, {
            tag: "pagination-link",
            component: Xi
        }, {
            tag: "pagination-infinite-scroll",
            component: Qi
        }, {
            tag: "deferred-media",
            component: Gi
        }, {
            tag: "pickup-availability",
            component: Ji
        }, 
        // {
        //     tag: "product-form",
        //     component: ao
        // }, 
        {
            tag: "product-form-button",
            component: ro
        }, {
            tag: "product-block",
            component: so
        }, {
            tag: "product-model",
            component: lo
        }, {
            tag: "cart-item",
            component: po
        }, {
            tag: "cart-component",
            component: vo
        }, 
        // {
        //     tag: "sidebar-cart",
        //     component: mo
        // }, 
        {
            tag: "cart-free-shipping-bar",
            component: go
        }, {
            tag: "product-media",
            component: bo
        }, {
            tag: "product-media-carousel",
            component: So
        }, {
            tag: "variant-picker",
            component: Co
        }, {
            tag: "color-swatches-picker",
            component: Eo
        }, {
            tag: "product-modal",
            component: xo
        }, {
            tag: "product-modal-image-wrap",
            component: Lo
        }, {
            tag: "product-modal-opener",
            component: Mo
        }, {
            tag: "product-recommendations",
            component: Ao
        }, {
            tag: "recently-viewed",
            component: _n
        }, {
            tag: "search-sidebar-form-wrapper",
            component: Do
        }, {
            tag: "cart-remove-button",
            component: qo
        }, {
            tag: "clipboard-button",
            component: Fo
        }, {
            tag: "clipboard-button-tooltip",
            component: No
        }, {
            tag: "product-card",
            component: zo
        }, {
            tag: "max-lines-component",
            component: Ko
        }, {
            tag: "country-selector",
            component: Uo
        }, {
            tag: "search-field",
            component: Wo
        }, {
            tag: "password-field",
            component: Yo
        }, {
            tag: "zoom-cursor",
            component: jo
        }, {
            tag: "shop-component",
            component: Xo
        }, {
            tag: "shop-active-filters",
            component: Qo
        }, {
            tag: "sidebar-filters-desktop",
            component: Jo
        }, {
            tag: "sidebar-filters-mobile",
            component: ea
        }, {
            tag: "filter-remove-btn",
            component: na
        }, {
            tag: "sort-list",
            component: ia
        }, {
            tag: "price-range",
            component: oa
        }, {
            tag: "column-switcher",
            component: aa
        }, {
            tag: "filters-submit-btn",
            component: sa
        }, {
            tag: "before-after-images",
            component: ca
        }, {
            tag: "product-information-drawer",
            component: la
        }, {
            tag: "sidebar-filters-sticky-mobile-button",
            component: da
        }, {
            tag: "recipient-form",
            component: ha
        }, {
            tag: "collection-card",
            component: pa
        }, {
            tag: "article-card",
            component: va
        }, {
            tag: "subscription-btn",
            component: UpdateItemSubscription
        },
        {
            tag: "subscription-btn-plan-update",
            component: UpdateItemSubscriptionPlan
        }];
    window.recentlyViewed = _n;
    ma.forEach((function(e) {
        var t = e.tag,
            n = e.component;
        customElements.define(t, n)
    })), window.bodyElement = C, window.addEventListener("load", (function() {
        d({
            lazyClass: "yall-video-lazy",
            threshold: 0,
            observeChanges: !0
        })
    }))
}();